import { Component, ViewChild } from '@angular/core';
import { SessionService } from '../../Util/Session/session.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbNavModule, NgbNav, NgbDatepickerModule, NgbDateParserFormatter, NgbDateAdapter, NgbTypeahead, NgbTypeaheadModule, NgbDateStruct, NgbDropdownModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ComboService } from '../../Model/Combo/combo.service';
import { EmployeeRegistrationService } from '../../Model/EmployeeRegistration/employee-registration.service';
import { UtilityService } from '../../Model/utility/utility.service';
import { CommonService } from '../../Model/Common/common.service';
import moment from 'moment';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { ConfirmationComponent } from '../../Component/Confirmation/confirmation/confirmation.component';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { AadhaarKYCComponent } from '../AadhaarKYC/aadhaar-kyc/aadhaar-kyc.component';
import { PanKYCComponent } from '../PanKYC/pan-kyc/pan-kyc.component';
import { BankKYCComponent } from '../BankKYC/bank-kyc/bank-kyc.component';
import { TooltipService } from '../../Util/Tooltip/tooltip.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { Subject } from 'rxjs';
import { CustomDateParserFormatter } from '../../Util/DateFormat/date-format.service';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import { MobileEmailComponent } from '../../Component/MobileEmail/mobile-email/mobile-email.component';
import { InitMobileEmaiComponent } from '../initMobileEmail/init-mobile-emai/init-mobile-emai.component';
import { AlertSuccessComponent } from '../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../Component/Alert/alert-warning/alert-warning.component';
import { ChangeDetectorRef } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ApprovalMatrixService } from '../../Model/ApprovalMatrix/approval-matrix.service';
import { LetterDocumentService } from '../../Model/LetterDocument/letter-document.service';
import { BackgroundVerificationService } from '../../Model/BackgroundVerification/background-verification.service';
import { ApprovalMatrixFormFilterComponent } from '../../Setting/ApprovalMatrixFormFilter/approval-matrix-form-filter/approval-matrix-form-filter.component'
import { NoDataComponent } from '../../Component/NoData/no-data/no-data.component';
import { MenualBGVFormComponent } from '../MenualBGV/menual-bgvform/menual-bgvform.component';

@Component({
  selector: 'app-register-form',
  standalone: true,
  imports: [NgbNavModule, NgbNav, CommonModule, FormsModule, NgbDatepickerModule, NgbTypeaheadModule, NgSelectModule, NgbDropdownModule, DataTablesModule, LoaderComponent, NgbTooltipModule, ApprovalMatrixFormFilterComponent, NoDataComponent],
  providers: [
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
  templateUrl: './register-form.component.html',
  styleUrl: './register-form.component.scss'
})

export class RegisterFormComponent {
  EmpCodeForFRONT: string = ''
  RestData: any[] = []
  isDisabled: boolean = false;
  isDisabledG: boolean = false;
  addonURL = '';
  PercentageTotal = 0;
  IsEditable = false;
  urlSafe: SafeResourceUrl | undefined;
  activeTab = 'EVerification';
  currentYear = null as any;
  user = [] as any;
  PreJoiningDate = null as any;
  PostJoiningDate = null as any;
  MinProbationDate = null as any;
  IsReportingToNotApplicable = false;
  MinDate = {
    day: 1,
    month: 1,
    year: 1800
  };
  maxBirthdate: any;
  ToDayDate: any;
  ContractEndDate100Year = null as any;
  MinDrivingLicenceDate = null as any;
  minQulificationYear = 1990 as any;
  checkFieldDisableFlag = false;

  Branchs = [] as any;
  Genders = [] as any;
  Castes = [] as any;
  Religions = [] as any;
  Nationalities = [] as any;
  MotherTongues = [] as any;
  Grades = [] as any;
  Departments = [] as any;
  SalaryStructures = [] as any;
  PresentStatus = [] as any;
  EmpServiceTypes = [] as any;
  Clients = [] as any;
  Sites = [] as any;
  Designations = [] as any;
  EmpDesignations = [] as any;
  Dutys = [] as any;
  Shifts = [] as any;
  BloodGroups = [] as any;
  ColourOfEyes = [] as any;
  ColourofHairs = [] as any;
  UniformSizes = [] as any;
  ShoesSizes = [] as any;
  MaritalStatus = [] as any;
  Qualifications = [] as any;
  Languages = [] as any;
  LocalStates = [] as any;
  LocalDistricts = [] as any;
  LocalTalukas = [] as any;
  NativeStates = [] as any;
  NativeDistricts = [] as any;
  NativeTalukas = [] as any;
  PlaceOfBirthStates = [] as any;
  PlaceOfBirthDistricts = [] as any;
  PlaceOfBirthTalukas = [] as any;
  EmergencyContactStates = [] as any;
  EmergencyContactDistricts = [] as any;
  EmergencyContactTalukas = [] as any;
  ContactRelationShips = [] as any;
  NomineeRelationships = [] as any;
  NomineeStates = [] as any;
  NomineeDistricts = [] as any;
  NomineeTalukas = [] as any;
  NomineeAddressTypes = [] as any;
  EmpDependentsTypeOfProofs = [] as any;
  EmpDependentAddressTypes = [] as any;
  EmpDependentRelationships = [] as any;
  WitnessStates = [] as any;
  WitnessDistricts = [] as any;
  WitnessTalukas = [] as any;
  ReferenceStates = [] as any;
  ReferenceDistricts = [] as any;
  ReferenceTalukas = [] as any;
  TypeofGuns = [] as any;
  Documents = [] as any;
  Banks = [] as any;
  ReportingManagers = [] as any;

  QualificationDatas = [] as any;
  AddtionalEmpServiceTypes = [] as any;

  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtQulification!: DataTableDirective;

  LanguageDatas = [] as any;
  dtTriggerLng: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtLanguage!: DataTableDirective;

  YesNos: any = [{ ID: 1, Label: 'Yes', Value: true }, { ID: 2, Label: 'No', Value: false }];
  ReferralSources: any = [{ ID: 1, Label: 'Internal', Value: 'internal' }, { ID: 2, Label: 'External', Value: 'external' }];
  ReferralSourceInternals: any = [{ ID: 1, Label: 'Referred', Value: 'referred' }, { ID: 2, Label: 'Direct', Value: 'direct' }];
  addressTypes = [{ AddressID: 1, Address: 'Local Address' }, { AddressID: 2, Address: 'Native Address' }
    , { AddressID: 3, Address: 'Place Of Birth' }, { AddressID: 4, Address: 'Emergency Contact' }];

  Ess_Qual = {
    GradeClass: null,
    YearOfPassing: null as any,
    Percentage: null as any,
    UniversityBoard: null,
    QualificationId: null,
    EnrollmentNumber: null,
    College: null,
    CGPA: null,
  };

  Ess_Lang = {
    LanguageID: null as any,
    Read: false,
    Write: false,
    Speak: false
  };

  filter = {
    LocalAddressID: null,
    NativeAddressID: null,
    PlaceOfBirthAddressID: null,
    EmergencyContactAddressID: null,
    ImageDocumentID: null,
    aadharsaveflag: false,
    IsDraft: false as any,
    EmpStatus: null as any,
    isSiteCheck: false,
    IsPensionDeductionChangeAllow: false,
    PensionDeductionDefault: false as any,
  };

  CompulsoryField = [{
    Id: 0,
    FieldName: null,
  }] as any;

  BGVCompulsoryField = [] as any;
  bgvHistory = [] as any;
  bgvHistoryHeader = [] as any;

  VerificationStatus = {
    AADHAARCardVerificationEnabled: false,
    BankDetailsVerificationEnabled: null,
    CompulsoryAADHAARKYCVerification: null,
    CompulsoryBANKVerification: null,
    CompulsoryPANVerification: null,
    PANCardVerificationEnabled: null,
    CompulsoryMobileVerification: null,
    CompulsoryEmailVerification: null,
  };

  RegistrationDetail = {
    // EmpMasterId: 0,
    // EmpTempCode: null,
    // EmpName: null,
    // EmailID: null,
    // MobileNo: null,
    // EmpType: null,
    // Photo: null as any,
    Verification: {
      SelectType: 'U',//
      TabName: 'employeeverificationtab',//
      EmpMasterId: 0,// //
      IsDraft: true,//

      AADHAARVerificationID: 0 as any,// //
      AadharVerificationStatus: 'Not Verified' as any,
      PaymentMode: null as any,// //
      NameAsPerAadhaar: null as any,// //
      AadharNo: null,// //
      AadharNoKyc: null as any,// //
      AadharAttachment: null,// //
      AadharAttachmenturl: null as any,
      Gender: null as any,// //
      LocalAddress1: null as any,// //
      LocalAddress2: null as any,// //
      BirthDate: null as any,// //
      photo: null as any,// //
      photourl: null as any,
      PANVerificationID: 0 as any,// //
      PANVerificationStatus: 'Not Verified' as any,
      NameAsPerPAN: null,// //
      PANNo: null,// //
      PANAttachment: null,// //
      PANAttachmenturl: null as any,
      BankVerificationID: 0 as any,// //
      BankVerificationStatus: 'Not Verified' as any,
      BankId: null,// // 
      BankName: null,
      BankAccountNo: null,// //
      IFSCode: null,// //
      NameAsPerBank: null,// //
      BankAttachment: null,// //
      BankAttachmenturl: null as any,
      MobileVerificationStatus: 'Not Verified' as any,
      EmailVerificationStatus: 'Not Verified' as any,
      EmailId: null as any,
      MobileNo: null as any,
      ReplaceAddress: false,
      AskReplaceAddress: false,
    },
    BasicInformation: {
      SelectType: 'U',//
      TabName: 'basicinformation', //
      EmpMasterId: 0, // //
      IsDraft: true,//

      BranchID: null as any,// //
      EmpCode: null,// //
      OldEmpCode: null,// //
      RegistrationDate: null as any,
      JoiningDate: null as any,// //
      photo: null as any,// //
      photourl: null as any,
      NameAsPerAadhar: null as any,// //
      firstName: null as any,// // 
      middleName: null as any,// // 
      lastName: null as any,// //
      EmpName: null as any, // //
      PreviousName: null,// //
      FatherName: null,// //
      MotherName: null,// //
      GenderId: null,// //
      CasteId: null,// //
      ReligionId: null,// //
      NationalityId: null,// //
      MotherTongueId: null,// //
      ContactNo1: null,
      ContactNo2: null,// //
      PersonalEmail: null as any,// //
      OfficialEmail: null,// //
      MonthlySalaryExpected: null,// //
      GradeId: null,// //
      DepartmentId: null,// //
      SalaryStructureId: null,// //
      //ProbationDate: null as any,// //
      BirthDate: null as any,// //
      Age: null as any,
      RetirementDate: null as any,
      ContractStartDate: null as any,// //
      ContractEndDate: null as any,// //
      IsSmartPhoneUser: false,
      ReportingManagerId1: null as any,
      ReportingManager1: null,
      ReportingManagerId2: null as any,
      ReportingManager2: null,
      PresentStatusId: 1 as any,// //
      StatusDate: null as any,
      EmpServiceTypeId: null,// //
      ShiftId: null as any,// //
      ClientId: null as any,// //
      SiteId: null as any,// //
      DesignationId: null as any,// //
      MainDesignationId: null as any,// //
      DutyId: null as any,// //
      IsTempEmployee: true,
      ESS_EmpServiceTypeId: null as any,//new add on 24-dec-2025
      RelieverFlag: false as any,//new add on 24-dec-2025
      OldERPDesignation: null,//new add on 12-mar-2026
      ClientEmpCode: null,//new add on 12-mar-2026
      BillabilityStatus: null,//new add on 24-mar-2026,
      WorkLocationCode: null as any,//new add on 30-mar-2026,
      WorkLocationName: null as any,//new add on 30-mar-2026,
      IsZingHrEntry: false as any,//new add on 01-apr-2026,
      //ResourceId: null//new add on 12-may-2026,
      PensionDeduction: false as any,//new add on 20-may-2026,
    },
    AdditionalInformation: {
      SelectType: 'U',// //
      TabName: 'additionalinformation',
      EmpMasterId: 0,// //
      IsDraft: true,// //

      IdenficationMark1: null,// //
      IdenficationMark2: null,// // 
      PhysicalDisability: null as any,// //
      BloodGroup: null,// //
      Height: null,// //
      Weight: null,// //
      ChestSize: null,// //
      ColourofEyes: null,// //
      ColourofHair: null,// //
      UniformSize: null,// //
      ShoesSize: null,// //
      MartialStatus: null,// //
      NoofChildren: null as any,// //
      NoofDependents: null as any,// //
      SpouseName: null,// //
      SpouseBirthDate: null as any,// //
      SpouseAge: null as any,
      Ess_Qual: [] as any,
      Ess_Lang: [] as any,
      QualificationAttachment: null,// //
      QualificationAttachmenturl: null as any,
      DegreeAttachment: null,// //
      DegreeAttachmenturl: null as any,
      MetroCity: false,// //
      AutoTDS: false,// //
      IsPhysicalDisability: false,
      PhysicalDisabilityCertificate: null,//new add on 12-may-2026,
      PhysicalDisabilityCertificateURL: null as any//new add on 12-may-2026,
    },
    AddressTab: {
      SelectType: 'U',
      TabName: 'address',
      EmpMasterId: 0,
      IsDraft: true,

      LocalAddress: [{
        LocalAddress1: null as any,
        LocalAddress2: null as any,
        LocalCity: null,
        LocalStateId: null as any,
        LocalDistrictId: null as any,
        LocalTalukaTehsilId: null as any,
        LocalPincode: null as any,
        LocalPoliceStation: null,
        LocalPostOffice: null,
        LocalDateResiding: null as any,
        LocalPropertyOwned: true as any,
      }],
      Attachment: null,
      Attachmenturl: null as any,
      NativeAddress: [{
        NativeAddress1: null as any,
        NativeAddress2: null as any,
        NativeCity: null as any,
        NativeStateId: null as any,
        NativeDistrictId: null as any,
        NativeTalukaTehsilId: null as any,
        NativePincode: null as any,
        NativePoliceStation: null,
        NativePostOffice: null,
        NativeContactPersonName: null,
        NativeContactPersonNo: null,
        NativePropertyOwned: true as any,
      }],
      PlaceofBirth: [{
        PlaceOfBirthAddress1: null,
        PlaceOfBirthAddress2: null,
        PlaceOfBirthCity: null,
        PlaceOfBirthStateId: null as any,
        PlaceOfBirthDistrictId: null as any,
        PlaceOfBirthTalukaTehsilId: null as any,
        PlaceOfBirthPincode: null as any,
      }],
      EmergencyContact: [{
        ContactName: null,
        ContactNumber: null,
        ContactRelationShipId: null as any,
        ContactAddress1: null,
        ContactAddress2: null,
        ContactCity: null,
        StateId: null as any,
        DistrictId: null as any,
        TalukaTehsilId: null as any,
        Pincode: null as any
      }],
    },
    EmpNomineeESIC: {
      SelectType: 'U',
      TabName: 'nomineeesicdetails',
      EmpMasterId: 0,
      IsDraft: true,

      EmpPFNomineeDetails: [
        {
          EmpPFNominee: null,//
          NomineeAddress1: null as any,//
          NomineeAddress2: null as any,//
          NomineeRelationshipId: null,//
          NomineeVillageCity: null as any,//
          NomineeStateId: null as any,//
          NomineeDistrictId: null as any,//
          NomineeTalukaTehsilId: null as any,//
          NomineePinCode: null as any,//
          NomineeBirthDate: null as any,//
          NomineeShare: null,//
          Minor: false as any,//
          MinorNomineeGuardian: null,//
          NomineeAddressTypeId: null,//
          AddressTypeMasterId: null,
          ContactNo: null,
        }
      ],
      EmpDependentDetails: [
        // {
        //   Name: null,//
        //   Address: null,//
        //   DateOfBirth: null as any,//
        //   Relationship: null,//
        //   DocumentMasterId: null,//
        //   DocumentNo: null,//
        //   DocumentAttachment: null,//
        //   DocumentAttachmenturl: null as any,
        // }
      ] as any,
    },
    OtherDetails: {
      SelectType: 'U',
      TabName: 'otherdetails',
      EmpMasterId: 0,
      IsDraft: true,

      ReferenceDetails: [
        // {
        //   Name: null,//
        //   Address1: null as any,//
        //   Address2: null as any,//
        //   VillageCity: null as any,//
        //   StateId: null as any,//
        //   DistrictId: null as any,//
        //   TalukaTehsilId: null as any,//
        //   PinCode: null as any,//
        //   ContactNo: null,//
        //   AddressTypeMasterId: null,
        // }
      ] as any,
      Witness: [
        // {
        //   Name: null,//
        //   Address1: null as any,//
        //   Address2: null as any,//
        //   VillageCity: null as any,//
        //   StateId: null as any,//
        //   DistrictId: null as any,//
        //   TalukaTehsilId: null as any,//
        //   PinCode: null as any,//
        //   ContactNo: null,//
        //   AddressTypeMasterId: null,
        // }
      ] as any,
      PreviousEmploymentdetails: [
        // {
        //   Name: null,//
        //   Address: null,//
        //   Position: null,//
        //   FromDate: null as any,//
        //   ToDate: null as any,//
        //   EmployerPFNo: null,//
        //   EmployerESICNo: null,//
        //   TotalSalaryDrawn: null,//
        //   ReasonOfLeaving: null,//
        // }
      ] as any,
      Referraldetails: [] as any,
      ReferralSource: null as any,//new add on 24-dec-2025
      ReferredBy: null,//new add on 24-dec-2025
      ReferralSourceCategory: null as any,//new add on 24-dec-2025
      EmpCode: null,//new add on 24-dec-2025 for frontend use only
      EmpName: null as any,//new add on 24-dec-2025 for frontend use only
    },
    AccountLicencesTab: {
      SelectType: 'U',
      TabName: 'accountlicences',
      EmpMasterId: 0,
      IsDraft: true,

      PaymentMode: null as any,
      BankId: null as any,
      BankName: null,
      IFSCode: null,
      Accountno: null,
      AccountnoStar: null,
      AccountLength: null,
      NameAsPerBank: null,
      BankAttachment: null,
      BankAttachmenturl: null as any,
      ReferenceNumber: null,
      BankVerificationStatus: null as any,
      AadhaarNo: null,
      AadharAttachment: null,
      AadharAttachmenturl: null as any,
      AadharVerificationStatus: null as any,
      PANNo: null,
      PANAttachment: null,
      PANAttachmenturl: null as any,
      PANVerificationStatus: null as any,
      ExistingMemberOfESIC: false as any,
      ESICNo: null,
      ExistingMemberOfPF: false as any,
      PFNo: null,
      UANNo: null,
      PFStatutoryDeduction: false as any,
      LINNo: null,
      HoldingGun: false as any,
      //TypeofGunId: null,
      TypeOfGunId: null,
      GunLicenseNo: null,
      GunNo: null,
      IssuingAuthority: null,
      DateOfIssue: null as any,
      DateOfExpiry: null as any,
      GunRegistrationDate: null as any,
      GunAttachment: null,
      GunAttachmenturl: null as any,
      HoldingDrivingLicense: false as any,
      DrivingLicenseNumber: null,
      DrivingLicenseIssueDate: null as any,
      DrivingLicenseExpiryDate: null as any,
      DrivingLicenseIssuingAuthority: null,
      DrivingAttachment: null,
      DrivingAttachmenturl: null as any,
    },
    ImageDocumnetTab: {
      SelectType: 'U',
      TabName: 'imagedocument',
      EmpMasterId: 0,
      IsDraft: true,

      Photo: null,
      Photourl: null as any,
      Signature: null,
      Signatureurl: null as any,
      LH1: null,
      LH1url: null as any,
      LH2: null,
      LH2url: null as any,
      LH3: null,
      LH3url: null as any,
      LH4: null,
      LH4url: null as any,
      LH5: null,
      LH5url: null as any,
      RH1: null,
      RH1url: null as any,
      RH2: null,
      RH2url: null as any,
      RH3: null,
      RH3url: null as any,
      RH4: null,
      RH4url: null as any,
      RH5: null,
      RH5url: null as any,
      InterviewingOfficer: null,
      AppointingAuthority: null,
      RecommendedBy1: null,
      RecommendedBy2: null,
      Remark: null,
      EmpDocumentAttachment: [] as any,
    },
    employeeInfo: {
      EmpMasterId: 0,
      EmpTempCode: null as any,
      FirstName: null as any,
      EmailId: null as any,
      MobileNo: null as any,
      RegistrationType: null as any,
      EmpType: null as any,
      EmailIdShow: null as any,
      MobileNoShow: null as any,
      IsShow: true,
      IsEditVEmail: false,
      IsEditVMobileNo: false,
      BGVStatus: null as any,
      ColourCode: null as any,
      VerificationMode: null as any,
    }
  }

  LetterData = [];
  collapseStates: { [key: string]: boolean } = {};

  constructor(
    private approvalMatrix: ApprovalMatrixService,
    private route: ActivatedRoute,
    private utility: UtilityService,
    protected common: CommonService,
    private session: SessionService,
    private toast: ToastService,
    private modalService: NgbModal,
    private employeeRegistration: EmployeeRegistrationService,
    private combo: ComboService,
    protected dateFormat: CustomDateParserFormatter,
    private router: Router,
    private tooltip: TooltipService,
    protected sanitizer: DomSanitizer,
    private letterDocument: LetterDocumentService,
    private backgroundVerification: BackgroundVerificationService,
    private cd: ChangeDetectorRef
  ) {
    this.common.CompanyParameter();
    this.user = this.session.GetUserDetails();
    if (this.user.IsPreOnBoarding) {
      this.common.PageRight = {
        IsView: true,
        IsAdd: true,
        IsEdit: true,
        IsDelete: true,
        IsPrint: true,
      }
    } else {
      this.common.getPageRights();
    }
    this.route.params.subscribe(params => this.RegistrationDetail.employeeInfo.EmpMasterId = parseInt(params['id']));
    this.route.params.subscribe(params => this.filter.IsDraft = params['draft']);
    this.addonURL = this.router.url.split('/')[2];
  }

  async ngOnInit(): Promise<void> {
    this.SelectDate('RegistrationDate', null, null);
    if (this.user.IsPreOnBoarding) {
      this.GetDataPreonboarding();
    }

    if (this.RegistrationDetail.employeeInfo.EmpMasterId > 0 && (!this.user.IsPreOnBoarding || (this.user.IsPreOnBoarding && this.user.UserId == this.RegistrationDetail.employeeInfo.EmpMasterId))) {
      if (this.user.IsPreOnBoarding && this.user.first) {
        this.user.first = false;
        this.session.Start(this.user);
        window.location.reload();
      }
      //if (true) {
      // this.ComboLoad('Branch');
      // this.ComboLoad('Gender');
      // this.ComboLoad('Caste');
      // this.ComboLoad('Religion');
      // this.ComboLoad('Nationality');
      // this.ComboLoad('MotherTongue');
      // this.ComboLoad('Grade');
      // this.ComboLoad('Department');
      // this.ComboLoad('SalaryStructure');
      // this.ComboLoad('PresentStatus');
      // this.ComboLoad('ServiceType');
      // this.ComboLoad('shift');
      // this.ComboLoad('Approval1');
      // this.ComboLoad('BloodGroup');
      // this.ComboLoad('Colour', 'ColourOfEyes',);
      // this.ComboLoad('Colour', 'HairColor');
      // this.ComboLoad('UniformSize');
      // this.ComboLoad('ShoesSize');
      // this.ComboLoad('Marital');
      // this.ComboLoad('Qualification');
      // this.ComboLoad('Language');
      // this.ComboLoad('State');
      // this.ComboLoad('Address');
      // this.ComboLoad('RelationShip');
      // this.ComboLoad('document');
      // this.ComboLoad('TypeOfGun');
      // this.ComboLoad('Bank');
      this.ESS_FillComboLoadSingleType();
      this.ESS_AdditionalFillCombo();
      //this.GetAadharPanBankCompulsory();
      await new Promise(f => setTimeout(f, 1000));
      this.GetData();
    } else {
      this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      if (!this.user.IsPreOnBoarding) {
        this.router.navigate(['/onboarding/register/front']);
      } else {
        this.session.End();
      }
    }
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
    this.dtTriggerLng.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
    this.dtTriggerLng.unsubscribe();
  }

  tabChanged(index: any) { }

  Validate(form: any, Name: any, childForm: any = []) {
    if (form.valid && this.IsEditable) {
      if (Name == 'VerificationDetailForm') {
        this.SaveVerificationInformationDetail();
      } else if (Name == 'BasicInformationForm') {
        this.SaveBasicInformationDetail();
      } else if (Name == 'AdditionalInformationDetailForm') {
        this.SaveAdditionalInformationDetail();
      } else if (Name == 'AddressInformationDetailForm') {
        this.SaveAddressInformationDetail();
      } else if (Name == 'NomineeESICDetailForm') {
        this.SaveNomineeESICDetail();
      } else if (Name == 'OtherDetailForm') {
        this.SaveOtherDetail();
      } else if (Name == 'AccountLicencesDetailForm') {
        this.SaveAccountLicencesDetail();
      } else if (Name == 'ImageDocumentDetailForm') {
        this.SaveImageDocumentDetail();
      }
    } else {
      // childForm.forEach((element:any) => {
      //   this.removeValidationErrors(element);
      // });
      this.toast.show({ message: 'Please fill mandatory fields', type: toastTypeEnum.danger });
      form.submitted = true;
    }
  }

  // removeValidationErrors(form: any): void {
  //   Object.keys(form.controls).forEach(controlName => {
  //     const control = form.controls[controlName];
  //     control.setErrors(null); // Clear all validation errors for the control
  //     control.updateValueAndValidity();
  //     control.markAsPristine(); // Mark control as pristine (not modified)
  //     control.markAsUntouched(); // Mark control as untouched (not interacted with)
  //   });
  //   this.cdr.detectChanges();
  // }

  ComboLoad(Combotype: String, Combotype2: string = '', index = 0, clearChild = true) {
    this.isDisabled = true;
    if (Combotype == 'Site' && clearChild) {
      this.Sites = [];
      this.Designations = [];
      this.Dutys = [];
      this.Shifts = [];
      this.RegistrationDetail.BasicInformation.SiteId = null;
      this.RegistrationDetail.BasicInformation.DesignationId = null;
      this.RegistrationDetail.BasicInformation.DutyId = null;
      this.RegistrationDetail.BasicInformation.ShiftId = null;
    } else if (Combotype == 'Designation' && clearChild) {
      this.Designations = [];
      this.Dutys = [];
      this.Shifts = [];
      this.RegistrationDetail.BasicInformation.DesignationId = null;
      this.RegistrationDetail.BasicInformation.DutyId = null;
      this.RegistrationDetail.BasicInformation.ShiftId = null;
    } else if (Combotype == 'Duty' && clearChild && this.common.ToLowerCase(this.RegistrationDetail.employeeInfo.EmpType) == 'front') {
      this.Dutys = [];
      this.Shifts = [];
      this.RegistrationDetail.BasicInformation.DutyId = null;
      this.RegistrationDetail.BasicInformation.ShiftId = null;
    } else if (Combotype == 'ShiftLoadBasedOnDesignationDuty' && clearChild) {
      this.Shifts = [];
      this.RegistrationDetail.BasicInformation.ShiftId = null;
    }
    else if (Combotype2 == 'LocalDistrict' && clearChild) {
      this.LocalDistricts = [];
      this.LocalTalukas = [];
      this.RegistrationDetail.AddressTab.LocalAddress[0].LocalDistrictId = null;
      this.RegistrationDetail.AddressTab.LocalAddress[0].LocalTalukaTehsilId = null;
    } else if (Combotype2 == 'LocalTaluka' && clearChild) {
      this.LocalTalukas = [];
      this.RegistrationDetail.AddressTab.LocalAddress[0].LocalTalukaTehsilId = null;
    } else if (Combotype2 == 'NativeDistrict' && clearChild) {
      this.NativeDistricts = [];
      this.NativeTalukas = [];
      this.RegistrationDetail.AddressTab.NativeAddress[0].NativeDistrictId = null;
      this.RegistrationDetail.AddressTab.NativeAddress[0].NativeTalukaTehsilId = null;
    } else if (Combotype2 == 'NativeTaluka' && clearChild) {
      this.NativeTalukas = [];
      this.RegistrationDetail.AddressTab.NativeAddress[0].NativeTalukaTehsilId = null;
    } else if (Combotype2 == 'PlaceofBirthDistrict' && clearChild) {
      this.PlaceOfBirthDistricts = [];
      this.PlaceOfBirthTalukas = [];
      this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthDistrictId = null;
      this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthTalukaTehsilId = null;
    } else if (Combotype2 == 'PlaceofBirthTaluka' && clearChild) {
      this.PlaceOfBirthTalukas = [];
      this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthTalukaTehsilId = null;
    } else if (Combotype2 == 'EmergencyContactDistrict' && clearChild) {
      this.EmergencyContactDistricts = [];
      this.EmergencyContactTalukas = [];
      this.RegistrationDetail.AddressTab.EmergencyContact[0].DistrictId = null;
      this.RegistrationDetail.AddressTab.EmergencyContact[0].TalukaTehsilId = null;
    } else if (Combotype2 == 'EmergencyContactTaluka' && clearChild) {
      this.EmergencyContactTalukas = [];
      this.RegistrationDetail.AddressTab.EmergencyContact[0].TalukaTehsilId = null;
    } else if (Combotype2 == 'NomineeDistrict' && clearChild) {
      this.NomineeDistricts[index] = [];
      this.NomineeTalukas[index] = [];
      this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails[index].NomineeDistrictId = null;
      this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails[index].NomineeTalukaTehsilId = null;
    } else if (Combotype2 == 'NomineeTaluka' && clearChild) {
      this.NomineeTalukas[index] = [];
      this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails[index].NomineeTalukaTehsilId = null;
    } else if (Combotype2 == 'ReferenceDistrict' && clearChild) {
      this.ReferenceDistricts[index] = [];
      this.ReferenceTalukas[index] = [];
      this.RegistrationDetail.OtherDetails.ReferenceDetails[index].DistrictId = null;
      this.RegistrationDetail.OtherDetails.ReferenceDetails[index].TalukaTehsilId = null;
    } else if (Combotype2 == 'ReferenceTaluka' && clearChild) {
      this.ReferenceTalukas[index] = [];
      this.RegistrationDetail.OtherDetails.ReferenceDetails[index].TalukaTehsilId = null;
    } else if (Combotype2 == 'WitnessDistrict' && clearChild) {
      this.WitnessDistricts[index] = [];
      this.WitnessTalukas[index] = [];
      this.RegistrationDetail.OtherDetails.Witness[index].DistrictId = null;
      this.RegistrationDetail.OtherDetails.Witness[index].TalukaTehsilId = null;
    } else if (Combotype2 == 'WitnessTaluka' && clearChild) {
      this.WitnessTalukas[index] = [];
      this.RegistrationDetail.OtherDetails.Witness[index].TalukaTehsilId = null;
    } else if (Combotype == 'Client' && clearChild && this.common.ToLowerCase(this.RegistrationDetail.employeeInfo.EmpType) == 'front') {
      this.RegistrationDetail.BasicInformation.ClientId = null;
      this.RegistrationDetail.BasicInformation.SiteId = null;
      this.RegistrationDetail.BasicInformation.DesignationId = null;
      this.RegistrationDetail.BasicInformation.DutyId = null;
      this.RegistrationDetail.BasicInformation.ShiftId = null;

      this.Clients = [];
      this.Sites = [];
      this.Designations = [];
      this.Dutys = [];
      this.Shifts = [];
    } else if (Combotype == 'shift') {
      this.Shifts = [];
    }

    this.combo.ComboLoad({
      'Combotype': Combotype,
      'BranchId': (Combotype == 'Client' || Combotype == 'Site' || Combotype == 'Designation' || Combotype == 'Duty' || Combotype == 'ShiftLoadBasedOnDesignationDuty') ? this.RegistrationDetail.BasicInformation.BranchID : 0,
      'ClientId': ((Combotype == 'Client' && this.filter.IsDraft == 'false') || Combotype == 'Site' || Combotype == 'Designation' || Combotype == 'Duty' || Combotype == 'ShiftLoadBasedOnDesignationDuty') ? this.RegistrationDetail.BasicInformation.ClientId : 0,
      'SiteId': ((Combotype == 'Site' && this.filter.IsDraft == 'false') || Combotype == 'Designation' || Combotype == 'Duty' || Combotype == 'ShiftLoadBasedOnDesignationDuty') ? this.RegistrationDetail.BasicInformation.SiteId : 0,
      'DesignationId': ((Combotype == 'Designation' && this.filter.IsDraft == 'false') || Combotype == 'Duty' || Combotype == 'ShiftLoadBasedOnDesignationDuty') ? this.RegistrationDetail.BasicInformation.DesignationId : 0,
      'DutyId': ((Combotype == 'Duty' && this.filter.IsDraft == 'false') || Combotype == 'ShiftLoadBasedOnDesignationDuty') ? this.RegistrationDetail.BasicInformation.DutyId : 0,
      'EmpType': this.RegistrationDetail.employeeInfo.EmpType,
      'StateId': ((Combotype == 'District' && Combotype2 == 'LocalDistrict') || (Combotype == 'Taluka' && Combotype2 == 'LocalTaluka'))
        ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalStateId :
        ((Combotype == 'District' && Combotype2 == 'NativeDistrict') || (Combotype == 'Taluka' && Combotype2 == 'NativeTaluka'))
          ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativeStateId :
          ((Combotype == 'District' && Combotype2 == 'PlaceofBirthDistrict') || (Combotype == 'Taluka' && Combotype2 == 'PlaceofBirthTaluka'))
            ? this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthStateId :
            ((Combotype == 'District' && Combotype2 == 'EmergencyContactDistrict') || (Combotype == 'Taluka' && Combotype2 == 'EmergencyContactTaluka'))
              ? this.RegistrationDetail.AddressTab.EmergencyContact[0].StateId :
              ((Combotype == 'District' && Combotype2 == 'NomineeDistrict') || (Combotype == 'Taluka' && Combotype2 == 'NomineeTaluka'))
                ? this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails[index].NomineeStateId :
                ((Combotype == 'District' && Combotype2 == 'WitnessDistrict') || (Combotype == 'Taluka' && Combotype2 == 'WitnessTaluka'))
                  ? this.RegistrationDetail.OtherDetails.Witness[index].StateId :
                  ((Combotype == 'District' && Combotype2 == 'ReferenceDistrict') || (Combotype == 'Taluka' && Combotype2 == 'ReferenceTaluka'))
                    ? this.RegistrationDetail.OtherDetails.ReferenceDetails[index].StateId : 0,
      'DistrictId': (Combotype == 'Taluka' && Combotype2 == 'LocalTaluka')
        ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalDistrictId :
        (Combotype == 'Taluka' && Combotype2 == 'NativeTaluka')
          ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativeDistrictId :
          (Combotype == 'Taluka' && Combotype2 == 'PlaceofBirthTaluka')
            ? this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthDistrictId :
            (Combotype == 'Taluka' && Combotype2 == 'EmergencyContactTaluka')
              ? this.RegistrationDetail.AddressTab.EmergencyContact[0].DistrictId :
              (Combotype == 'Taluka' && Combotype2 == 'NomineeTaluka')
                ? this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails[index].NomineeDistrictId :
                (Combotype == 'Taluka' && Combotype2 == 'WitnessTaluka')
                  ? this.RegistrationDetail.OtherDetails.Witness[index].DistrictId :
                  (Combotype == 'Taluka' && Combotype2 == 'ReferenceTaluka')
                    ? this.RegistrationDetail.OtherDetails.ReferenceDetails[index].DistrictId : 0,
      'EmpMasterID': this.RegistrationDetail.employeeInfo.EmpMasterId
    }).subscribe({
      next: (response) => {
        if (Combotype == 'Branch') {
          if (response.ComboLoad) {
            this.Branchs = response.ComboLoad;
          }
        } else if (Combotype == 'Gender') {
          if (response.ComboLoad) {
            this.Genders = response.ComboLoad;
          }
        } else if (Combotype == 'Caste') {
          if (response.ComboLoad) {
            this.Castes = response.ComboLoad;
          }
        } else if (Combotype == 'Religion') {
          if (response.ComboLoad) {
            this.Religions = response.ComboLoad;
          }
        } else if (Combotype == 'Nationality') {
          if (response.ComboLoad) {
            this.Nationalities = response.ComboLoad;
          }
        } else if (Combotype == 'MotherTongue') {
          if (response.ComboLoad) {
            this.MotherTongues = response.ComboLoad;
          }
        } else if (Combotype == 'Grade') {
          if (response.ComboLoad) {
            this.Grades = response.ComboLoad;
          }
        } else if (Combotype == 'Department') {
          if (response.ComboLoad) {
            this.Departments = response.ComboLoad;
          }
        } else if (Combotype == 'SalaryStructure') {
          if (response.ComboLoad) {
            this.SalaryStructures = response.ComboLoad;
          }
        } else if (Combotype == 'PresentStatus') {
          if (response.ComboLoad) {
            this.PresentStatus = response.ComboLoad;
          }
        } else if (Combotype == 'ServiceType') {
          if (response.ComboLoad) {
            this.EmpServiceTypes = response.ComboLoad;
          }
        } else if (Combotype == 'Client') {
          if (response.ComboLoad) {
            this.Clients = response.ComboLoad;
          }
        } else if (Combotype == 'Site') {
          if (response.ComboLoad) {
            this.Sites = response.ComboLoad;
          }
        } else if (Combotype == 'Designation') {
          if (response.ComboLoad) {
            this.Designations = response.ComboLoad;
          }
        } else if (Combotype == 'Duty') {
          this.RegistrationDetail.BasicInformation.MainDesignationId = this.RegistrationDetail.BasicInformation.DesignationId;
          this.setIsReportingToNotApplicable();
          if (response.ComboLoad) {
            this.Dutys = response.ComboLoad;
          }
        }
        else if (Combotype == 'shift') {
          if (response.ComboLoad) {
            this.Shifts = response.ComboLoad;
          }
        }
        else if (Combotype == 'ShiftLoadBasedOnDesignationDuty') {
          if (response.ComboLoad) {
            this.Shifts = response.ComboLoad;
          }
        }
        else if (Combotype == 'BloodGroup') {
          if (response.ComboLoad) {
            this.BloodGroups = response.ComboLoad;
          }
        } else if (Combotype == 'Colour' && Combotype2 == 'ColourOfEyes') {
          if (response.ComboLoad) {
            this.ColourOfEyes = response.ComboLoad;
          }
        } else if (Combotype == 'Colour' && Combotype2 == 'HairColor') {
          if (response.ComboLoad) {
            this.ColourofHairs = response.ComboLoad;
          }
        } else if (Combotype == 'UniformSize') {
          if (response.ComboLoad) {
            this.UniformSizes = response.ComboLoad;
          }
        } else if (Combotype == 'ShoesSize') {
          if (response.ComboLoad) {
            this.ShoesSizes = response.ComboLoad;
          }
        } else if (Combotype == 'Marital') {
          if (response.ComboLoad) {
            this.MaritalStatus = response.ComboLoad;
          }
        } else if (Combotype == 'Qualification') {
          if (response.ComboLoad) {
            this.Qualifications = response.ComboLoad;
          }
        } else if (Combotype == 'Language') {
          if (response.ComboLoad) {
            this.Languages = response.ComboLoad;
          }
        } else if (Combotype == 'State') {
          if (response.ComboLoad) {
            this.LocalStates = response.ComboLoad;
            this.NativeStates = response.ComboLoad;
            this.PlaceOfBirthStates = response.ComboLoad;
            this.EmergencyContactStates = response.ComboLoad;
            this.NomineeStates = response.ComboLoad;
            this.WitnessStates = response.ComboLoad;
            this.ReferenceStates = response.ComboLoad;
          }
        } else if (Combotype == 'District' && Combotype2 == 'LocalDistrict') {
          if (response.ComboLoad) {
            this.LocalDistricts = response.ComboLoad;
          }
        } else if (Combotype == 'Taluka' && Combotype2 == 'LocalTaluka') {
          if (response.ComboLoad) {
            this.LocalTalukas = response.ComboLoad;
          }
        } else if (Combotype == 'District' && Combotype2 == 'NativeDistrict') {
          if (response.ComboLoad) {
            this.NativeDistricts = response.ComboLoad;
          }
        } else if (Combotype == 'Taluka' && Combotype2 == 'NativeTaluka') {
          if (response.ComboLoad) {
            this.NativeTalukas = response.ComboLoad;
          }
        } else if (Combotype == 'District' && Combotype2 == 'PlaceofBirthDistrict') {
          if (response.ComboLoad) {
            this.PlaceOfBirthDistricts = response.ComboLoad;
          }
        } else if (Combotype == 'Taluka' && Combotype2 == 'PlaceofBirthTaluka') {
          if (response.ComboLoad) {
            this.PlaceOfBirthTalukas = response.ComboLoad;
          }
        } else if (Combotype == 'District' && Combotype2 == 'EmergencyContactDistrict') {
          if (response.ComboLoad) {
            this.EmergencyContactDistricts = response.ComboLoad;
          }
        } else if (Combotype == 'Taluka' && Combotype2 == 'EmergencyContactTaluka') {
          if (response.ComboLoad) {
            this.EmergencyContactTalukas = response.ComboLoad;
          }
        } else if (Combotype == 'RelationShip') {
          if (response.ComboLoad) {
            this.NomineeRelationships = response.ComboLoad;
            this.EmpDependentRelationships = response.ComboLoad;
            this.ContactRelationShips = response.ComboLoad;
          }
        } else if (Combotype == 'District' && Combotype2 == 'NomineeDistrict') {
          if (response.ComboLoad) {
            this.NomineeDistricts[index] = response.ComboLoad;
          }
        } else if (Combotype == 'Taluka' && Combotype2 == 'NomineeTaluka') {
          if (response.ComboLoad) {
            this.NomineeTalukas[index] = response.ComboLoad;
          }
        } else if (Combotype == 'Address') {
          if (response.ComboLoad) {
            this.NomineeAddressTypes = response.ComboLoad;
            this.EmpDependentAddressTypes = response.ComboLoad;
          }
        } else if (Combotype == 'document') {
          if (response.ComboLoad) {
            this.EmpDependentsTypeOfProofs = response.ComboLoad;
            this.Documents = response.ComboLoad;
            //this.CheckMandateDocument();
          }
        } else if (Combotype == 'District' && Combotype2 == 'ReferenceDistrict') {
          if (response.ComboLoad) {
            this.ReferenceDistricts[index] = response.ComboLoad;
          }
        } else if (Combotype == 'Taluka' && Combotype2 == 'ReferenceTaluka') {
          if (response.ComboLoad) {
            this.ReferenceTalukas[index] = response.ComboLoad;
          }
        } else if (Combotype == 'District' && Combotype2 == 'WitnessDistrict') {
          if (response.ComboLoad) {
            this.WitnessDistricts[index] = response.ComboLoad;
          }
        } else if (Combotype == 'Taluka' && Combotype2 == 'WitnessTaluka') {
          if (response.ComboLoad) {
            this.WitnessTalukas[index] = response.ComboLoad;
          }
        } else if (Combotype == 'TypeOfGun') {
          if (response.ComboLoad) {
            this.TypeofGuns = response.ComboLoad;
          }
        } else if (Combotype == 'Bank') {
          if (response.ComboLoad) {
            this.Banks = response.ComboLoad;
          }
        } else if (Combotype == 'Approval1') {
          if (response.ComboLoad) {
            this.ReportingManagers = response.ComboLoad;
          }
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }


  ESS_FillComboLoadSingleType() {
    this.isDisabled = true;
    this.combo.ESS_FillComboLoadSingleType({
      'SelectType': 'All',
      'BranchId': this.RegistrationDetail.BasicInformation.BranchID
    }).subscribe({
      next: (response) => {
        if (response.Table) {
          this.Banks = response.Table
        }

        if (response.Table1) {
          this.TypeofGuns = response.Table1;
        }

        if (response.Table2) {
          this.EmpDependentsTypeOfProofs = response.Table2;
          this.Documents = response.Table2;
        }

        if (response.Table3) {
          this.NomineeRelationships = response.Table3;
          this.EmpDependentRelationships = response.Table3;
          this.ContactRelationShips = response.Table3;
        }

        if (response.Table4) {
          this.NomineeAddressTypes = response.Table4;
          this.EmpDependentAddressTypes = response.Table4;
        }

        if (response.Table5) {
          this.LocalStates = response.Table5;
          this.NativeStates = response.Table5;
          this.PlaceOfBirthStates = response.Table5;
          this.EmergencyContactStates = response.Table5;
          this.NomineeStates = response.Table5;
          this.WitnessStates = response.Table5;
          this.ReferenceStates = response.Table5;
        }

        if (response.Table6) {
          this.Languages = response.Table6;
        }

        if (response.Table7) {
          this.Qualifications = response.Table7;
        }

        if (response.Table8) {
          this.MaritalStatus = response.Table8;
        }

        if (response.Table9) {
          this.ShoesSizes = response.Table9;
        }

        if (response.Table10) {
          this.UniformSizes = response.Table10;
        }

        if (response.Table11) {
          this.ColourOfEyes = response.Table11;
          this.ColourofHairs = response.Table11;
        }

        if (response.Table12) {
          this.BloodGroups = response.Table12;
        }

        // if (response.Table13) {
        //   this.Shifts = response.Table13;
        // }

        if (response.Table14) {
          this.EmpServiceTypes = response.Table14;
        }

        if (response.Table15) {
          this.PresentStatus = response.Table15;
        }

        if (response.Table16) {
          this.SalaryStructures = response.Table16;
        }

        if (response.Table17) {
          this.Grades = response.Table17;
        }

        if (response.Table18) {
          this.MotherTongues = response.Table18;
        }

        if (response.Table19) {
          this.Religions = response.Table19;
        }

        if (response.Table20) {
          this.Genders = response.Table20;
        }

        if (response.Table21) {
          this.Castes = response.Table21;
        }

        if (response.Table22) {
          this.Nationalities = response.Table22;
        }

        if (response.Table23) {
          this.Departments = response.Table23;
        }

        if (response.Table24) {
          this.ReportingManagers = response.Table24;
        }

        if (response.Table25) {
          this.Branchs = response.Table25;
        }

        if (response.Table26) {
          this.EmpDesignations = response.Table26;
        }
        // if (Combotype == 'Branch') {
        //   if (response.ComboLoad) {
        //     this.Branchs = response.ComboLoad;
        //   }
        // } else if (Combotype == 'Gender') {
        //   if (response.ComboLoad) {
        //     this.Genders = response.ComboLoad;
        //   }
        // } else if (Combotype == 'Caste') {
        //   if (response.ComboLoad) {
        //     this.Castes = response.ComboLoad;
        //   }
        // } else if (Combotype == 'Religion') {
        //   if (response.ComboLoad) {
        //     this.Religions = response.ComboLoad;
        //   }
        // } else if (Combotype == 'Nationality') {
        //   if (response.ComboLoad) {
        //     this.Nationalities = response.ComboLoad;
        //   }
        // } else if (Combotype == 'MotherTongue') {
        //   if (response.ComboLoad) {
        //     this.MotherTongues = response.ComboLoad;
        //   }
        // } else if (Combotype == 'Grade') {
        //   if (response.ComboLoad) {
        //     this.Grades = response.ComboLoad;
        //   }
        // } else if (Combotype == 'Department') {
        //   if (response.ComboLoad) {
        //     this.Departments = response.ComboLoad;
        //   }
        // } else if (Combotype == 'SalaryStructure') {
        //   if (response.ComboLoad) {
        //     this.SalaryStructures = response.ComboLoad;
        //   }
        // } else if (Combotype == 'PresentStatus') {
        //   if (response.ComboLoad) {
        //     this.PresentStatus = response.ComboLoad;
        //   }
        // } else if (Combotype == 'ServiceType') {
        //   if (response.ComboLoad) {
        //     this.EmpServiceTypes = response.ComboLoad;
        //   }
        // } else if (Combotype == 'Client') {
        //   if (response.ComboLoad) {
        //     this.Clients = response.ComboLoad;
        //   }
        // } else if (Combotype == 'Site') {
        //   if (response.ComboLoad) {
        //     this.Sites = response.ComboLoad;
        //   }
        // } else if (Combotype == 'Designation') {
        //   if (response.ComboLoad) {
        //     this.Designations = response.ComboLoad;
        //   }
        // } else if (Combotype == 'Duty') {
        //   if (response.ComboLoad) {
        //     this.Dutys = response.ComboLoad;
        //   }
        // } else if (Combotype == 'shift') {
        //   if (response.ComboLoad) {
        //     this.Shifts = response.ComboLoad;
        //   }
        // } else if (Combotype == 'BloodGroup') {
        //   if (response.ComboLoad) {
        //     this.BloodGroups = response.ComboLoad;
        //   }
        // } else if (Combotype == 'Colour' && Combotype2 == 'ColourOfEyes') {
        //   if (response.ComboLoad) {
        //     this.ColourOfEyes = response.ComboLoad;
        //   }
        // } else if (Combotype == 'Colour' && Combotype2 == 'HairColor') {
        //   if (response.ComboLoad) {
        //     this.ColourofHairs = response.ComboLoad;
        //   }
        // } else if (Combotype == 'UniformSize') {
        //   if (response.ComboLoad) {
        //     this.UniformSizes = response.ComboLoad;
        //   }
        // } else if (Combotype == 'ShoesSize') {
        //   if (response.ComboLoad) {
        //     this.ShoesSizes = response.ComboLoad;
        //   }
        // } else if (Combotype == 'Marital') {
        //   if (response.ComboLoad) {
        //     this.MaritalStatus = response.ComboLoad;
        //   }
        // } else if (Combotype == 'Qualification') {
        //   if (response.ComboLoad) {
        //     this.Qualifications = response.ComboLoad;
        //   }
        // } else if (Combotype == 'Language') {
        //   if (response.ComboLoad) {
        //     this.Languages = response.ComboLoad;
        //   }
        // } else if (Combotype == 'State') {
        //   if (response.ComboLoad) {
        //     this.LocalStates = response.ComboLoad;
        //     this.NativeStates = response.ComboLoad;
        //     this.PlaceOfBirthStates = response.ComboLoad;
        //     this.EmergencyContactStates = response.ComboLoad;
        //     this.NomineeStates = response.ComboLoad;
        //     this.WitnessStates = response.ComboLoad;
        //     this.ReferenceStates = response.ComboLoad;
        //   }
        // } else if (Combotype == 'District' && Combotype2 == 'LocalDistrict') {
        //   if (response.ComboLoad) {
        //     this.LocalDistricts = response.ComboLoad;
        //   }
        // } else if (Combotype == 'Taluka' && Combotype2 == 'LocalTaluka') {
        //   if (response.ComboLoad) {
        //     this.LocalTalukas = response.ComboLoad;
        //   }
        // } else if (Combotype == 'District' && Combotype2 == 'NativeDistrict') {
        //   if (response.ComboLoad) {
        //     this.NativeDistricts = response.ComboLoad;
        //   }
        // } else if (Combotype == 'Taluka' && Combotype2 == 'NativeTaluka') {
        //   if (response.ComboLoad) {
        //     this.NativeTalukas = response.ComboLoad;
        //   }
        // } else if (Combotype == 'District' && Combotype2 == 'PlaceofBirthDistrict') {
        //   if (response.ComboLoad) {
        //     this.PlaceOfBirthDistricts = response.ComboLoad;
        //   }
        // } else if (Combotype == 'Taluka' && Combotype2 == 'PlaceofBirthTaluka') {
        //   if (response.ComboLoad) {
        //     this.PlaceOfBirthTalukas = response.ComboLoad;
        //   }
        // } else if (Combotype == 'District' && Combotype2 == 'EmergencyContactDistrict') {
        //   if (response.ComboLoad) {
        //     this.EmergencyContactDistricts = response.ComboLoad;
        //   }
        // } else if (Combotype == 'Taluka' && Combotype2 == 'EmergencyContactTaluka') {
        //   if (response.ComboLoad) {
        //     this.EmergencyContactTalukas = response.ComboLoad;
        //   }
        // } else if (Combotype == 'RelationShip') {
        //   if (response.ComboLoad) {
        //     this.NomineeRelationships = response.ComboLoad;
        //     this.EmpDependentRelationships = response.ComboLoad;
        //     this.ContactRelationShips = response.ComboLoad;
        //   }
        // } else if (Combotype == 'District' && Combotype2 == 'NomineeDistrict') {
        //   if (response.ComboLoad) {
        //     this.NomineeDistricts[index] = response.ComboLoad;
        //   }
        // } else if (Combotype == 'Taluka' && Combotype2 == 'NomineeTaluka') {
        //   if (response.ComboLoad) {
        //     this.NomineeTalukas[index] = response.ComboLoad;
        //   }
        // } else if (Combotype == 'Address') {
        //   if (response.ComboLoad) {
        //     this.NomineeAddressTypes = response.ComboLoad;
        //     this.EmpDependentAddressTypes = response.ComboLoad;
        //   }
        // } else if (Combotype == 'document') {
        //   if (response.ComboLoad) {
        //     this.EmpDependentsTypeOfProofs = response.ComboLoad;
        //     this.Documents = response.ComboLoad;
        //     //this.CheckMandateDocument();
        //   }
        // } else if (Combotype == 'District' && Combotype2 == 'ReferenceDistrict') {
        //   if (response.ComboLoad) {
        //     this.ReferenceDistricts[index] = response.ComboLoad;
        //   }
        // } else if (Combotype == 'Taluka' && Combotype2 == 'ReferenceTaluka') {
        //   if (response.ComboLoad) {
        //     this.ReferenceTalukas[index] = response.ComboLoad;
        //   }
        // } else if (Combotype == 'District' && Combotype2 == 'WitnessDistrict') {
        //   if (response.ComboLoad) {
        //     this.WitnessDistricts[index] = response.ComboLoad;
        //   }
        // } else if (Combotype == 'Taluka' && Combotype2 == 'WitnessTaluka') {
        //   if (response.ComboLoad) {
        //     this.WitnessTalukas[index] = response.ComboLoad;
        //   }
        // } else if (Combotype == 'TypeOfGun') {
        //   if (response.ComboLoad) {
        //     this.TypeofGuns = response.ComboLoad;
        //   }
        // } else if (Combotype == 'Bank') {
        //   if (response.ComboLoad) {
        //     this.Banks = response.ComboLoad;
        //   }
        // } else if (Combotype == 'Approval1') {
        //   if (response.ComboLoad) {
        //     this.ReportingManagers = response.ComboLoad;
        //   }
        // }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  CheckCompulsoryField(Id: number, FieldName: string, TabName: string) {
    //if{} changes suggested by rahul

    if (this.common.CompanyParameterValue.ESS_IsEmpBGVApplicable) {
      if (this.BGVCompulsoryField.length > 0) {
        return this.BGVCompulsoryField != null ? this.BGVCompulsoryField.filter((e: any) => e.MandatoryField == FieldName && e.TabName == TabName).length > 0 ? true : false : false;
      }
    }

    if (TabName == 'Tab7' && (FieldName == 'AadharNo' || FieldName == 'PANNo')) {
      if (FieldName == 'AadharNo') {
        return this.Documents.filter((e: any) => e.DocumentMasterID == 5 && e.Compulsory == 1).length > 0 ? true : false;
      } else if (FieldName == 'PANNo') {
        return this.Documents.filter((e: any) => e.DocumentMasterID == 4 && e.Compulsory == 1).length > 0 ? true : false;
      } else {
        return false;
      }
    } else {
      if (FieldName == 'ReportingManager1' || FieldName == 'ReportingManager2') {
        if (this.IsReportingToNotApplicable) {
          return false;
        }
      }
      if (this.CompulsoryField.length > 0) {
        return this.CompulsoryField != null ? this.CompulsoryField.filter((e: any) => e.FieldName == FieldName && e.TabName == TabName).length > 0 ? true : false : false;
      } else {
        return false;
      }
    }
  }

  JoiningDateChange(event: any) {
    this.RegistrationDetail.BasicInformation.ContractStartDate = this.RegistrationDetail.BasicInformation.JoiningDate;
    this.ContractEndDate100Year =
    {
      day: this.RegistrationDetail.BasicInformation.JoiningDate.day,
      month: this.RegistrationDetail.BasicInformation.JoiningDate.month,
      year: this.RegistrationDetail.BasicInformation.JoiningDate.year
    };
    this.ContractEndDate100Year.year = this.ContractEndDate100Year.year + 40;
    if (event != null) {
      this.RegistrationDetail.BasicInformation.StatusDate = {
        day: this.RegistrationDetail.BasicInformation.JoiningDate.day,
        month: this.RegistrationDetail.BasicInformation.JoiningDate.month,
        year: this.RegistrationDetail.BasicInformation.JoiningDate.year
      };
    }
    // this.RegistrationDetail.BasicInformation.ProbationDate = moment(this.dateFormat.format(this.RegistrationDetail.BasicInformation.JoiningDate));
    // this.RegistrationDetail.BasicInformation.ProbationDate = moment(this.RegistrationDetail.BasicInformation.ProbationDate.add({ day: this.common.CompanyParameterValue.ProbationDays }));
    // this.RegistrationDetail.BasicInformation.ProbationDate = this.dateFormat.parse(this.RegistrationDetail.BasicInformation.ProbationDate.format("DD MMM YYYY"))

    //this.SelectDate('ProbationDate', null, this.dateFormat.format(this.RegistrationDetail.BasicInformation.JoiningDate));

    this.maxBirthdate = moment(this.dateFormat.format(this.RegistrationDetail.BasicInformation.JoiningDate));
    this.maxBirthdate = moment(this.maxBirthdate.add({ Year: -this.common.CompanyParameterValue.WorkAge }));
    this.maxBirthdate = this.dateFormat.parse(this.maxBirthdate.format("DD MMM YYYY"));
  }

  ResetVerification(index: any) {
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Do you want to reset?';
    modalRef.result.then((result: any) => {
      if (result) {
        if (index == 1) {
          this.RegistrationDetail.Verification.AADHAARVerificationID = 0;
          this.RegistrationDetail.Verification.AadharVerificationStatus = 'Not Verified';
          this.RegistrationDetail.Verification.NameAsPerAadhaar = null;
          this.RegistrationDetail.Verification.AadharNo = null;
          this.RegistrationDetail.Verification.AadharNoKyc = null;
          this.RegistrationDetail.Verification.AadharAttachment = null;
          this.RegistrationDetail.Verification.AadharAttachmenturl = null;
          this.RegistrationDetail.Verification.Gender = null;
          this.RegistrationDetail.Verification.LocalAddress1 = null;
          this.RegistrationDetail.Verification.LocalAddress2 = null;
          this.RegistrationDetail.Verification.BirthDate = null;
          this.RegistrationDetail.Verification.photo = null;
          this.RegistrationDetail.Verification.photourl = null;
        } else if (index == 2) {
          this.RegistrationDetail.Verification.PaymentMode = null;
          this.RegistrationDetail.Verification.PANVerificationID = 0;
          this.RegistrationDetail.Verification.PANVerificationStatus = 'Not Verified';
          this.RegistrationDetail.Verification.NameAsPerPAN = null;
          this.RegistrationDetail.Verification.PANNo = null;
          this.RegistrationDetail.Verification.PANAttachment = null;
          this.RegistrationDetail.Verification.PANAttachmenturl = null;
        } else if (index == 3) {
          this.RegistrationDetail.Verification.BankVerificationID = 0;
          this.RegistrationDetail.Verification.BankVerificationStatus = 'Not Verified';
          this.RegistrationDetail.Verification.BankId = null;
          this.RegistrationDetail.Verification.BankName = null;
          this.RegistrationDetail.Verification.BankAccountNo = null;
          this.RegistrationDetail.Verification.IFSCode = null;
          this.RegistrationDetail.Verification.NameAsPerBank = null;
          this.RegistrationDetail.Verification.BankAttachment = null;
        } else if (index == 4) {
          this.RegistrationDetail.Verification.MobileVerificationStatus = 'Not Verified';
        } else if (index == 5) {
          this.RegistrationDetail.Verification.EmailVerificationStatus = 'Not Verified';
        }
      }
    });
  }

  upload(event: any, Folder: any, Tag = '') {
    try {
      if ((event.currentTarget.accept).includes(event.target.files[0].type.split('/')[1])) {
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          this.UploadServices(Folder, reader.result, Tag, null, event.target.files[0].type.split('/')[1]);
          event.target.value = null;
        };
      } else {
        this.toast.show({ message: 'selected file not allow, allow file only ' + event.currentTarget.accept, type: toastTypeEnum.danger });
        event.target.value = null;
      }
    } catch (e) { }
  }

  UploadServices(Folder: string, Base64: any, Tag = '', index = null, type = '') {
    this.isDisabled = true;
    this.utility.Upload({ 'DomainName': this.user.Domain, 'folder': Folder, 'CompanyCode': this.user.CompanyCode, 'FileBase64': Base64 }).subscribe((response: any) => {
      if (response.FileName != "") {
        if (Folder == this.common.CompanyParameterValue.PhotoFolder && Tag == '') {
          this.RegistrationDetail.BasicInformation.photo = response.FileName;
          this.RegistrationDetail.BasicInformation.photourl = response.Url;

          if (this.RegistrationDetail.ImageDocumnetTab.Photo == null || this.RegistrationDetail.ImageDocumnetTab.Photo == '') {
            this.RegistrationDetail.ImageDocumnetTab.Photo = this.RegistrationDetail.BasicInformation.photo;
            this.RegistrationDetail.ImageDocumnetTab.Photourl = this.RegistrationDetail.BasicInformation.photourl;
          }
        } else if (Folder == this.common.CompanyParameterValue.QualificationFolder && Tag == '') {
          this.RegistrationDetail.AdditionalInformation.QualificationAttachment = response.FileName;
          this.RegistrationDetail.AdditionalInformation.QualificationAttachmenturl = response.Url;
        } else if (Folder == this.common.CompanyParameterValue.DegreeAttachment && Tag == '') {
          this.RegistrationDetail.AdditionalInformation.DegreeAttachment = response.FileName;
          this.RegistrationDetail.AdditionalInformation.DegreeAttachmenturl = response.Url;
        } else if (Folder == this.common.CompanyParameterValue.AddressFolder && Tag == '') {
          this.RegistrationDetail.AddressTab.Attachment = response.FileName;
          this.RegistrationDetail.AddressTab.Attachmenturl = response.Url;
        } else if (Folder == this.common.CompanyParameterValue.GunLicenseFolder && Tag == '') {
          this.RegistrationDetail.AccountLicencesTab.GunAttachment = response.FileName;
          this.RegistrationDetail.AccountLicencesTab.GunAttachmenturl = response.Url;
        } else if (Folder == this.common.CompanyParameterValue.DrivingLicenseFolder && Tag == '') {
          this.RegistrationDetail.AccountLicencesTab.DrivingAttachment = response.FileName;
          this.RegistrationDetail.AccountLicencesTab.DrivingAttachmenturl = response.Url;
        } else if (Folder == this.common.CompanyParameterValue.PhotoFolder && Tag == 'aadharphoto') {
          this.RegistrationDetail.Verification.photo = response.FileName;
          this.RegistrationDetail.Verification.photourl = response.Url;
        } else if (Folder == this.common.CompanyParameterValue.AadhaarFolder && Tag == '') {
          this.RegistrationDetail.Verification.AadharAttachment = response.FileName;
          this.RegistrationDetail.Verification.AadharAttachmenturl = response.Url;
        } else if (Folder == this.common.CompanyParameterValue.PanFolder && Tag == '') {
          this.RegistrationDetail.Verification.PANAttachment = response.FileName;
          this.RegistrationDetail.Verification.PANAttachmenturl = response.Url;
        } else if (Folder == this.common.CompanyParameterValue.BankDetailsFolder && Tag == '') {
          this.RegistrationDetail.Verification.BankAttachment = response.FileName;
          this.RegistrationDetail.Verification.BankAttachmenturl = response.Url;
        } else if (Tag == 'DependentDoc' && index != null) {
          this.RegistrationDetail.EmpNomineeESIC.EmpDependentDetails[index].DocumentAttachment = response.FileName;
          this.RegistrationDetail.EmpNomineeESIC.EmpDependentDetails[index].DocumentAttachmenturl = response.Url;
        }
        else if (Tag == 'RelievingLetter' && Folder == this.common.CompanyParameterValue.PreviousEmployment && index != null) {
          this.RegistrationDetail.OtherDetails.PreviousEmploymentdetails[index].RelievingLetter = response.FileName;
          this.RegistrationDetail.OtherDetails.PreviousEmploymentdetails[index].RelievingLetterURL = response.Url;
        } else if (Tag == 'OfferLetter' && Folder == this.common.CompanyParameterValue.PreviousEmployment && index != null) {
          this.RegistrationDetail.OtherDetails.PreviousEmploymentdetails[index].OfferLetter = response.FileName;
          this.RegistrationDetail.OtherDetails.PreviousEmploymentdetails[index].OfferLetterURL = response.Url;
        } else if (Tag == 'Payslip' && Folder == this.common.CompanyParameterValue.PreviousEmployment && index != null) {
          this.RegistrationDetail.OtherDetails.PreviousEmploymentdetails[index].Payslip = response.FileName;
          this.RegistrationDetail.OtherDetails.PreviousEmploymentdetails[index].PayslipURL = response.Url;
        }
        else if (Folder == this.common.CompanyParameterValue.PhotoFolder && Tag == 'ImgDoc') {
          this.RegistrationDetail.ImageDocumnetTab.Photo = response.FileName;
          this.RegistrationDetail.ImageDocumnetTab.Photourl = response.Url;
        } else if (Folder == this.common.CompanyParameterValue.SignatureFolder && Tag == '') {
          this.RegistrationDetail.ImageDocumnetTab.Signature = response.FileName;
          this.RegistrationDetail.ImageDocumnetTab.Signatureurl = response.Url;
        } else if (Folder == this.common.CompanyParameterValue.LH1Folder && Tag == '') {
          this.RegistrationDetail.ImageDocumnetTab.LH1 = response.FileName;
          this.RegistrationDetail.ImageDocumnetTab.LH1url = response.Url;
        } else if (Folder == this.common.CompanyParameterValue.LH2Folder && Tag == '') {
          this.RegistrationDetail.ImageDocumnetTab.LH2 = response.FileName;
          this.RegistrationDetail.ImageDocumnetTab.LH2url = response.Url;
        } else if (Folder == this.common.CompanyParameterValue.LH3Folder && Tag == '') {
          this.RegistrationDetail.ImageDocumnetTab.LH3 = response.FileName;
          this.RegistrationDetail.ImageDocumnetTab.LH3url = response.Url;
        } else if (Folder == this.common.CompanyParameterValue.LH4Folder && Tag == '') {
          this.RegistrationDetail.ImageDocumnetTab.LH4 = response.FileName;
          this.RegistrationDetail.ImageDocumnetTab.LH4url = response.Url;
        } else if (Folder == this.common.CompanyParameterValue.LH5Folder && Tag == '') {
          this.RegistrationDetail.ImageDocumnetTab.LH5 = response.FileName;
          this.RegistrationDetail.ImageDocumnetTab.LH5url = response.Url;
        } else if (Folder == this.common.CompanyParameterValue.RH1Folder && Tag == '') {
          this.RegistrationDetail.ImageDocumnetTab.RH1 = response.FileName;
          this.RegistrationDetail.ImageDocumnetTab.RH1url = response.Url;
        } else if (Folder == this.common.CompanyParameterValue.RH2Folder && Tag == '') {
          this.RegistrationDetail.ImageDocumnetTab.RH2 = response.FileName;
          this.RegistrationDetail.ImageDocumnetTab.RH2url = response.Url;
        } else if (Folder == this.common.CompanyParameterValue.RH3Folder && Tag == '') {
          this.RegistrationDetail.ImageDocumnetTab.RH3 = response.FileName;
          this.RegistrationDetail.ImageDocumnetTab.RH3url = response.Url;
        } else if (Folder == this.common.CompanyParameterValue.RH4Folder && Tag == '') {
          this.RegistrationDetail.ImageDocumnetTab.RH4 = response.FileName;
          this.RegistrationDetail.ImageDocumnetTab.RH4url = response.Url;
        } else if (Folder == this.common.CompanyParameterValue.RH5Folder && Tag == '') {
          this.RegistrationDetail.ImageDocumnetTab.RH5 = response.FileName;
          this.RegistrationDetail.ImageDocumnetTab.RH5url = response.Url;
        } else if (Tag == 'ImgDoc' && index != null) {
          this.RegistrationDetail.ImageDocumnetTab.EmpDocumentAttachment[index].Attachment = response.FileName;
          this.RegistrationDetail.ImageDocumnetTab.EmpDocumentAttachment[index].Attachmenturl = response.Url;
        }
        //else if (Tag == 'DependentDoc' && index != null) {
        //   this.RegistrationDetail.EmpPFNomineeInformation.EmpDependentDetails[index].DocumentAttachment = response.FileName;
        //   this.RegistrationDetail.EmpPFNomineeInformation.EmpDependentDetails[index].DocumentAttachmenturl = response.Url;
        // } 
        else if (Folder == this.common.CompanyParameterValue.AadhaarFolder && Tag == 'AL') {
          this.RegistrationDetail.AccountLicencesTab.AadharAttachment = response.FileName;
          this.RegistrationDetail.AccountLicencesTab.AadharAttachmenturl = response.Url;
        } else if (Folder == this.common.CompanyParameterValue.PanFolder && Tag == 'AL') {
          this.RegistrationDetail.AccountLicencesTab.PANAttachment = response.FileName;
          this.RegistrationDetail.AccountLicencesTab.PANAttachmenturl = response.Url;
        } else if (Folder == this.common.CompanyParameterValue.BankDetailsFolder && Tag == 'AL') {
          this.RegistrationDetail.AccountLicencesTab.BankAttachment = response.FileName;
          this.RegistrationDetail.AccountLicencesTab.BankAttachmenturl = response.Url;
        } if (Folder == this.common.CompanyParameterValue.PhysicalDisabilityAttachmentFolder && Tag == '') {
          this.RegistrationDetail.AdditionalInformation.PhysicalDisabilityCertificate = response.FileName;
          this.RegistrationDetail.AdditionalInformation.PhysicalDisabilityCertificateURL = response.Url;
        }

      } else {
        this.toast.show({ message: 'Image not uploaded', type: toastTypeEnum.warning });
      }
      this.isDisabled = false;
    }, (error) => {
      this.isDisabled = false;
    });
  }

  uploadImageDoc(event: any, index: any, Tag: string = '') {
    try {
      if ((event.currentTarget.accept).includes(event.target.files[0].type.split('/')[1])) {
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          if (Tag == 'ImgDoc') {
            this.UploadServices(this.RegistrationDetail.ImageDocumnetTab.EmpDocumentAttachment[index].Document, reader.result, Tag, index, event.target.files[0].type.split('/')[1]);
          } else if (Tag == 'DependentDoc') {
            this.UploadServices(this.EmpDependentsTypeOfProofs.filter((e: any) => e.DocumentMasterID == this.RegistrationDetail.EmpNomineeESIC.EmpDependentDetails[index].DocumentMasterId)[0]["Document"], reader.result, Tag, index, event.target.files[0].type.split('/')[1]);
          }
          else if (Tag == 'RelievingLetter' || Tag == 'OfferLetter' || Tag == 'Payslip') {
            this.UploadServices(this.common.CompanyParameterValue.PreviousEmployment, reader.result, Tag, index, event.target.files[0].type.split('/')[1]);
          }
        };
      } else {
        this.toast.show({ message: 'selected file not allow, allow file only ' + event.currentTarget.accept, type: toastTypeEnum.danger });
        event = null;
      }

    } catch (e) { }
  }

  GetCompulsoryFields(TabName: string) {
    this.isDisabled = true;
    this.employeeRegistration.GetCompulsoryFields({ TabName: TabName, SelectType: 'Add', TableName: 'EmployeeMaster', EmpType: this.RegistrationDetail.employeeInfo.EmpType, EmpMasterId: this.RegistrationDetail.employeeInfo.EmpMasterId, IsDraft: this.filter.IsDraft }).subscribe({
      next: (response) => {
        if (response.Table) {
          this.CompulsoryField = [...response.Table];
        } else {
          this.CompulsoryField = [];
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.cd.detectChanges();
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  GetAadharPanBankCompulsory() {
    this.isDisabled = true;
    if (this.RegistrationDetail.BasicInformation.IsZingHrEntry) {
      //if (false) {
      this.employeeRegistration.ESS_GetCompanyParameterDetailsZingHr({ EmpMasterId: this.RegistrationDetail.employeeInfo.EmpMasterId, IsDraft: this.filter.IsDraft }).subscribe({
        next: (response) => {
          if (response) {
            this.VerificationStatus = response[0];
          }
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    } else {
      this.employeeRegistration.GetAadharPanBankCompulsory({}).subscribe({
        next: (response) => {
          if (response) {
            this.VerificationStatus = response;
          }
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    }

  }

  GetData() {
    this.isDisabledG = true;
    this.employeeRegistration.GetData({ 'RegistrationType': '', 'SelectType': '', 'EmpMasterId': this.RegistrationDetail.employeeInfo.EmpMasterId, 'IsDraft': this.filter.IsDraft }).subscribe({
      next: (response) => {
        if (response) {
          if (!response.hasOwnProperty("Error_Code")) {
            this.RegistrationDetail = response;
            this.RegistrationDetail.Verification.SelectType = 'U';
            this.RegistrationDetail.Verification.TabName = 'employeeverificationtab';
            this.RegistrationDetail.Verification.EmpMasterId = this.RegistrationDetail.employeeInfo.EmpMasterId;
            this.RegistrationDetail.Verification.IsDraft = this.filter.IsDraft;

            this.RegistrationDetail.BasicInformation.SelectType = 'U';
            this.RegistrationDetail.BasicInformation.TabName = 'basicinformation';
            this.RegistrationDetail.BasicInformation.EmpMasterId = this.RegistrationDetail.employeeInfo.EmpMasterId;
            this.RegistrationDetail.BasicInformation.IsDraft = this.filter.IsDraft;

            this.RegistrationDetail.AdditionalInformation.SelectType = 'U';
            this.RegistrationDetail.AdditionalInformation.TabName = 'additionalinformation';
            this.RegistrationDetail.AdditionalInformation.EmpMasterId = this.RegistrationDetail.employeeInfo.EmpMasterId;
            this.RegistrationDetail.AdditionalInformation.IsDraft = this.filter.IsDraft;

            this.RegistrationDetail.AddressTab.SelectType = 'U';
            this.RegistrationDetail.AddressTab.TabName = 'address';
            this.RegistrationDetail.AddressTab.EmpMasterId = this.RegistrationDetail.employeeInfo.EmpMasterId;
            this.RegistrationDetail.AddressTab.IsDraft = this.filter.IsDraft;

            this.RegistrationDetail.EmpNomineeESIC.SelectType = 'U';
            this.RegistrationDetail.EmpNomineeESIC.TabName = 'nomineeesicdetails';
            this.RegistrationDetail.EmpNomineeESIC.EmpMasterId = this.RegistrationDetail.employeeInfo.EmpMasterId;
            this.RegistrationDetail.EmpNomineeESIC.IsDraft = this.filter.IsDraft;

            this.RegistrationDetail.OtherDetails.SelectType = 'U';
            this.RegistrationDetail.OtherDetails.TabName = 'otherdetails';
            this.RegistrationDetail.OtherDetails.EmpMasterId = this.RegistrationDetail.employeeInfo.EmpMasterId;
            this.RegistrationDetail.OtherDetails.IsDraft = this.filter.IsDraft;

            this.RegistrationDetail.AccountLicencesTab.SelectType = 'U';
            this.RegistrationDetail.AccountLicencesTab.TabName = 'accountlicences';
            this.RegistrationDetail.AccountLicencesTab.EmpMasterId = this.RegistrationDetail.employeeInfo.EmpMasterId;
            this.RegistrationDetail.AccountLicencesTab.IsDraft = this.filter.IsDraft;

            this.RegistrationDetail.ImageDocumnetTab.SelectType = 'U';
            this.RegistrationDetail.ImageDocumnetTab.TabName = 'imagedocument';
            this.RegistrationDetail.ImageDocumnetTab.EmpMasterId = this.RegistrationDetail.employeeInfo.EmpMasterId;
            this.RegistrationDetail.ImageDocumnetTab.IsDraft = this.filter.IsDraft;


            //varification tab attachment
            if (this.RegistrationDetail.Verification.photo != null && this.RegistrationDetail.Verification.photo != "") {
              this.RegistrationDetail.Verification.photourl = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.PhotoFolder + '/' + this.RegistrationDetail.Verification.photo;
            }
            if (this.RegistrationDetail.Verification.AadharAttachment != null && this.RegistrationDetail.Verification.AadharAttachment != "") {
              this.RegistrationDetail.Verification.AadharAttachmenturl = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.AadhaarFolder + '/' + this.RegistrationDetail.Verification.AadharAttachment;
            }
            if (this.RegistrationDetail.Verification.PANAttachment != null && this.RegistrationDetail.Verification.PANAttachment != "") {
              this.RegistrationDetail.Verification.PANAttachmenturl = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.PanFolder + '/' + this.RegistrationDetail.Verification.PANAttachment;
            }
            if (this.RegistrationDetail.Verification.BankAttachment != null && this.RegistrationDetail.Verification.BankAttachment != "") {
              this.RegistrationDetail.Verification.BankAttachmenturl = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.BankDetailsFolder + '/' + this.RegistrationDetail.Verification.BankAttachment;
            }

            try {
              if (this.RegistrationDetail.Verification.BankId != null && this.RegistrationDetail.Verification.BankId != '' && parseInt(this.RegistrationDetail.Verification.BankId) > 0) {
                this.RegistrationDetail.Verification.BankName = this.Banks.filter((e: any) => e.bank_master_id == this.RegistrationDetail.Verification.BankId)[0].bank_name;
              }
            } catch (e) { }


            this.RegistrationDetail.BasicInformation.MainDesignationId = this.RegistrationDetail.BasicInformation.DesignationId;
            //add condtion as per ravi sir
            if (this.RegistrationDetail.BasicInformation.RegistrationDate == '' || this.RegistrationDetail.BasicInformation.RegistrationDate == null) {
              this.RegistrationDetail.BasicInformation.RegistrationDate = this.ToDayDate;
            } else {
              this.RegistrationDetail.BasicInformation.RegistrationDate = this.dateFormat.parse(this.RegistrationDetail.BasicInformation.RegistrationDate);
            }

            //basic detail tab attachment
            if (this.RegistrationDetail.BasicInformation.photo != null && this.RegistrationDetail.Verification.photo != "") {
              this.RegistrationDetail.BasicInformation.photourl = this.RegistrationDetail.BasicInformation.photourl = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.PhotoFolder + '/' + this.RegistrationDetail.BasicInformation.photo;
            }

            if (this.RegistrationDetail.BasicInformation.JoiningDate != "" && this.RegistrationDetail.BasicInformation.JoiningDate != null) {
              this.RegistrationDetail.BasicInformation.JoiningDate = this.dateFormat.parse(this.RegistrationDetail.BasicInformation.JoiningDate);
              this.maxBirthdate = moment(this.dateFormat.format(this.RegistrationDetail.BasicInformation.JoiningDate));
              this.maxBirthdate = moment(this.maxBirthdate.add({ Year: -this.common.CompanyParameterValue.WorkAge }));
              this.maxBirthdate = this.dateFormat.parse(this.maxBirthdate.format("DD MMM YYYY"));
            }

            if (this.RegistrationDetail.BasicInformation.BirthDate != "" && this.RegistrationDetail.BasicInformation.BirthDate != null) {
              this.RegistrationDetail.BasicInformation.BirthDate = this.dateFormat.parse(this.RegistrationDetail.BasicInformation.BirthDate);
            }
            if (this.RegistrationDetail.BasicInformation.ContractStartDate != "" && this.RegistrationDetail.BasicInformation.ContractStartDate != null) {
              this.RegistrationDetail.BasicInformation.ContractStartDate = this.dateFormat.parse(this.RegistrationDetail.BasicInformation.ContractStartDate);
            } else {
              this.RegistrationDetail.BasicInformation.ContractStartDate = this.RegistrationDetail.BasicInformation.JoiningDate
            }
            if (this.RegistrationDetail.BasicInformation.ContractEndDate != "" && this.RegistrationDetail.BasicInformation.ContractEndDate != null) {
              this.RegistrationDetail.BasicInformation.ContractEndDate = this.dateFormat.parse(this.RegistrationDetail.BasicInformation.ContractEndDate);
            }

            //uncommit confirm with shreya on 15-sep-2025
            if (this.RegistrationDetail.BasicInformation.StatusDate != "" && this.RegistrationDetail.BasicInformation.StatusDate != null) {
              this.RegistrationDetail.BasicInformation.StatusDate = this.dateFormat.parse(this.RegistrationDetail.BasicInformation.StatusDate);
            }

            //commit confirm with shreya on 15-sep-2025
            // if (this.RegistrationDetail.BasicInformation.JoiningDate != "" && this.RegistrationDetail.BasicInformation.JoiningDate != null) {
            //   this.RegistrationDetail.BasicInformation.StatusDate = {
            //     day: this.RegistrationDetail.BasicInformation.JoiningDate.day,
            //     month: this.RegistrationDetail.BasicInformation.JoiningDate.month,
            //     year: this.RegistrationDetail.BasicInformation.JoiningDate.year
            //   };

            //   //this.SelectDate('ProbationDate', null, this.dateFormat.format(this.RegistrationDetail.BasicInformation.JoiningDate));
            // }

            // if (this.RegistrationDetail.BasicInformation.ProbationDate != "" && this.RegistrationDetail.BasicInformation.ProbationDate != null) {
            //   this.RegistrationDetail.BasicInformation.ProbationDate = this.dateFormat.parse(this.RegistrationDetail.BasicInformation.ProbationDate);
            // } else {
            if (this.RegistrationDetail.BasicInformation.JoiningDate != null && this.RegistrationDetail.BasicInformation.JoiningDate != "") {
              this.JoiningDateChange(null);
            }
            //}

            if (this.RegistrationDetail.BasicInformation.RetirementDate != "" && this.RegistrationDetail.BasicInformation.RetirementDate != null) {
              this.RegistrationDetail.BasicInformation.RetirementDate = this.dateFormat.parse(this.RegistrationDetail.BasicInformation.RetirementDate);
            }
            if (this.RegistrationDetail.BasicInformation.BranchID != null || this.RegistrationDetail.BasicInformation.BranchID > 0) {
              this.ComboLoad('Client', '', 0, false);
            }
            if (this.RegistrationDetail.BasicInformation.ClientId != null || this.RegistrationDetail.BasicInformation.ClientId > 0) {
              this.ComboLoad('Client', '', 0, false);
            }
            if (this.RegistrationDetail.BasicInformation.SiteId != null || this.RegistrationDetail.BasicInformation.SiteId > 0) {
              this.filter.isSiteCheck = true;
              this.ComboLoad('Site', '', 0, false);
            }

            if ((this.RegistrationDetail.BasicInformation.SiteId != null || this.RegistrationDetail.BasicInformation.SiteId > 0) && (this.RegistrationDetail.BasicInformation.DesignationId != null || this.RegistrationDetail.BasicInformation.DesignationId > 0 || this.RegistrationDetail.BasicInformation.IsTempEmployee)) {
              this.ComboLoad('Designation', '', 0, false);
            } else {
              this.RegistrationDetail.BasicInformation.DesignationId = null;
            }
            if ((this.RegistrationDetail.BasicInformation.DesignationId != null || this.RegistrationDetail.BasicInformation.DesignationId > 0) && (this.RegistrationDetail.BasicInformation.DutyId != null || this.RegistrationDetail.BasicInformation.DutyId > 0 || this.RegistrationDetail.BasicInformation.IsTempEmployee)) {
              this.ComboLoad('Duty', '', 0, false);
            } else {
              this.RegistrationDetail.BasicInformation.DutyId = null;
            }

            if ((this.RegistrationDetail.BasicInformation.SiteId != null || this.RegistrationDetail.BasicInformation.SiteId > 0) && (this.RegistrationDetail.BasicInformation.ShiftId != null || this.RegistrationDetail.BasicInformation.ShiftId > 0)) {
              if (this.common.ToLowerCase(this.RegistrationDetail.employeeInfo.EmpType) == 'front') {
                this.ComboLoad('ShiftLoadBasedOnDesignationDuty', '', 0, false);
              }
            } else {
              if (this.common.ToLowerCase(this.RegistrationDetail.employeeInfo.EmpType) == 'front') {
                this.RegistrationDetail.BasicInformation.ShiftId = null;
              }
            }

            if (this.common.ToLowerCase(this.RegistrationDetail.employeeInfo.EmpType) == 'back') {
              this.ComboLoad('shift');
            }

            if (this.RegistrationDetail.BasicInformation.BirthDate != null && this.RegistrationDetail.BasicInformation.BirthDate != "") {
              this.BirthDateChange(null);
            }

            if (this.user.IsPreOnBoarding || this.RegistrationDetail.BasicInformation.PresentStatusId == 0 || this.RegistrationDetail.BasicInformation.PresentStatusId == null) {
              this.RegistrationDetail.BasicInformation.PresentStatusId = 1;
            }

            this.RegistrationDetail.BasicInformation.NameAsPerAadhar = this.common.ToUpperCase(this.RegistrationDetail.BasicInformation.NameAsPerAadhar);
            this.RegistrationDetail.BasicInformation.firstName = this.common.ToUpperCase(this.RegistrationDetail.BasicInformation.firstName);
            this.RegistrationDetail.BasicInformation.EmpName = (this.RegistrationDetail.BasicInformation.firstName != null ? this.RegistrationDetail.BasicInformation.firstName : '') + " " + (this.RegistrationDetail.BasicInformation.middleName != null ? this.RegistrationDetail.BasicInformation.middleName : '') + " " + (this.RegistrationDetail.BasicInformation.lastName != null ? this.RegistrationDetail.BasicInformation.lastName : '');
            this.RegistrationDetail.BasicInformation.EmpName = this.common.ToUpperCase(this.RegistrationDetail.BasicInformation.EmpName);
            this.RegistrationDetail.AddressTab.LocalAddress[0].LocalAddress1 = this.common.ToUpperCase(this.RegistrationDetail.AddressTab.LocalAddress[0].LocalAddress1);
            this.RegistrationDetail.AddressTab.LocalAddress[0].LocalAddress2 = this.common.ToUpperCase(this.RegistrationDetail.AddressTab.LocalAddress[0].LocalAddress2);

            if (this.RegistrationDetail.BasicInformation.ReportingManagerId1 != null && this.RegistrationDetail.BasicInformation.ReportingManagerId1 != '' && this.RegistrationDetail.BasicInformation.ReportingManagerId1 != 0 && this.RegistrationDetail.BasicInformation.ReportingManagerId1 != '0') {
              try {
                this.RegistrationDetail.BasicInformation.ReportingManager1 = this.ReportingManagers.filter((e: any) => e.UserMasterId == parseInt(this.RegistrationDetail.BasicInformation.ReportingManagerId1))[0].Name;
              } catch (e) {
                this.RegistrationDetail.BasicInformation.ReportingManagerId1 = null;
                this.RegistrationDetail.BasicInformation.ReportingManager1 = null;
              }
            }
            if (this.RegistrationDetail.BasicInformation.ReportingManagerId2 != null && this.RegistrationDetail.BasicInformation.ReportingManagerId2 != '' && this.RegistrationDetail.BasicInformation.ReportingManagerId2 != 0 && this.RegistrationDetail.BasicInformation.ReportingManagerId2 != '0') {
              try {
                this.RegistrationDetail.BasicInformation.ReportingManager2 = this.ReportingManagers.filter((e: any) => e.UserMasterId == parseInt(this.RegistrationDetail.BasicInformation.ReportingManagerId2))[0].Name;
              } catch (e) {
                this.RegistrationDetail.BasicInformation.ReportingManagerId2 = null;
                this.RegistrationDetail.BasicInformation.ReportingManager2 = null;
              }
            }

            if (this.RegistrationDetail.BasicInformation.ContactNo1 == 0 || this.RegistrationDetail.BasicInformation.ContactNo1 == '0' || this.RegistrationDetail.BasicInformation.ContactNo1 == '') {
              this.RegistrationDetail.BasicInformation.ContactNo1 = null;
            }

            if (this.RegistrationDetail.BasicInformation.ContactNo2 == 0 || this.RegistrationDetail.BasicInformation.ContactNo2 == '0' || this.RegistrationDetail.BasicInformation.ContactNo2 == '') {
              this.RegistrationDetail.BasicInformation.ContactNo2 = null;
            }

            if (this.RegistrationDetail.BasicInformation.RelieverFlag == null || this.RegistrationDetail.BasicInformation.RelieverFlag == '') {
              this.RegistrationDetail.BasicInformation.RelieverFlag = false;
            }

            if (this.RegistrationDetail.BasicInformation.ESS_EmpServiceTypeId == null || this.RegistrationDetail.BasicInformation.ESS_EmpServiceTypeId == '' || this.RegistrationDetail.BasicInformation.ESS_EmpServiceTypeId == 0 || this.RegistrationDetail.BasicInformation.ESS_EmpServiceTypeId == '0') {
              this.RegistrationDetail.BasicInformation.ESS_EmpServiceTypeId = null;
            }

            if (this.RegistrationDetail.BasicInformation.PensionDeduction == null || this.RegistrationDetail.BasicInformation.PensionDeduction === '') {
              if (this.RegistrationDetail.BasicInformation.Age > this.common.CompanyParameterValue.RetirementAge) {
                this.RegistrationDetail.BasicInformation.PensionDeduction = false;
              } else {
                this.RegistrationDetail.BasicInformation.PensionDeduction = true;
              }
            }
            this.filter.PensionDeductionDefault = structuredClone(this.RegistrationDetail.BasicInformation.PensionDeduction)

            if (this.RegistrationDetail.BasicInformation.Age >= this.common.CompanyParameterValue.RetirementAge) {
              this.filter.IsPensionDeductionChangeAllow = false;
            } else {
              this.filter.IsPensionDeductionChangeAllow = true;
            }


            //addtional detail
            if (this.RegistrationDetail.AdditionalInformation.SpouseBirthDate != "" && this.RegistrationDetail.AdditionalInformation.SpouseBirthDate != null) {
              this.RegistrationDetail.AdditionalInformation.SpouseBirthDate = this.dateFormat.parse(this.RegistrationDetail.AdditionalInformation.SpouseBirthDate);
              this.SpouseBirthDateChange(null);
            }

            if (this.RegistrationDetail.AdditionalInformation.PhysicalDisability != "" && this.RegistrationDetail.AdditionalInformation.PhysicalDisability != null) {
              if (this.common.ToLowerCase(this.RegistrationDetail.AdditionalInformation.PhysicalDisability.split(" ")[0]) == 'yes') {
                this.RegistrationDetail.AdditionalInformation.IsPhysicalDisability = true;
              } else {
                this.RegistrationDetail.AdditionalInformation.IsPhysicalDisability = false;
              }
              let PhysicalDisability = "";
              this.RegistrationDetail.AdditionalInformation.PhysicalDisability.split(" ").forEach((element: any, index: any) => {
                if (index == 0 && (this.common.ToLowerCase(element) == 'yes' || this.common.ToLowerCase(element) == 'no')) {

                } else {
                  PhysicalDisability += element;
                }
              });
              this.RegistrationDetail.AdditionalInformation.PhysicalDisability = PhysicalDisability;

            } else {
              this.RegistrationDetail.AdditionalInformation.IsPhysicalDisability = false;
            }

            if (this.RegistrationDetail.AdditionalInformation.PhysicalDisabilityCertificate != null && this.RegistrationDetail.AdditionalInformation.PhysicalDisabilityCertificate != "") {
              this.RegistrationDetail.AdditionalInformation.PhysicalDisabilityCertificateURL = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.PhysicalDisabilityAttachmentFolder + '/' + this.RegistrationDetail.AdditionalInformation.PhysicalDisabilityCertificate;
            }

            try {
              if (this.RegistrationDetail.AdditionalInformation.Ess_Qual.length > 0) {
                if (this.RegistrationDetail.AdditionalInformation.Ess_Qual[0].QualificationId == 0 || this.RegistrationDetail.AdditionalInformation.Ess_Qual[0].QualificationId == null || this.RegistrationDetail.AdditionalInformation.Ess_Qual[0].QualificationId == '' || this.RegistrationDetail.AdditionalInformation.Ess_Qual[0].QualificationId == '0') {
                  this.RegistrationDetail.AdditionalInformation.Ess_Qual = []
                }
              } else { this.RegistrationDetail.AdditionalInformation.Ess_Qual = []; }
            } catch (e) {
              this.RegistrationDetail.AdditionalInformation.Ess_Qual = [];
            }

            try {
              if (this.RegistrationDetail.AdditionalInformation.Ess_Lang.length > 0) {
                if (this.RegistrationDetail.AdditionalInformation.Ess_Lang[0].LanguageID == 0 || this.RegistrationDetail.AdditionalInformation.Ess_Lang[0].LanguageID == null || this.RegistrationDetail.AdditionalInformation.Ess_Lang[0].LanguageID == '' || this.RegistrationDetail.AdditionalInformation.Ess_Lang[0].LanguageID == '0') {
                  this.RegistrationDetail.AdditionalInformation.Ess_Lang = [];
                }
              } else { this.RegistrationDetail.AdditionalInformation.Ess_Lang = []; }
            } catch (e) {
              this.RegistrationDetail.AdditionalInformation.Ess_Lang = [];
            }

            this.RegistrationDetail.AdditionalInformation.Ess_Lang.forEach((element: any) => {
              element.Read = element.Read.toLowerCase() == 'true' ? true : false;
              element.Write = element.Write.toLowerCase() == 'true' ? true : false;
              element.Speak = element.Speak.toLowerCase() == 'true' ? true : false;
            });

            this.QualificationDatas = this.RegistrationDetail.AdditionalInformation.Ess_Qual;
            this.LanguageDatas = this.RegistrationDetail.AdditionalInformation.Ess_Lang;

            if (this.RegistrationDetail.AdditionalInformation.QualificationAttachment != null && this.RegistrationDetail.AdditionalInformation.QualificationAttachment != "") {
              this.RegistrationDetail.AdditionalInformation.QualificationAttachmenturl = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.QualificationFolder + '/' + this.RegistrationDetail.AdditionalInformation.QualificationAttachment;
            }

            if (this.RegistrationDetail.AdditionalInformation.DegreeAttachment != null && this.RegistrationDetail.AdditionalInformation.DegreeAttachment != "") {
              this.RegistrationDetail.AdditionalInformation.DegreeAttachmenturl = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.DegreeAttachment + '/' + this.RegistrationDetail.AdditionalInformation.DegreeAttachment;
            }

            //Address detail
            if (this.RegistrationDetail.AddressTab.LocalAddress[0].LocalDateResiding != "" && this.RegistrationDetail.AddressTab.LocalAddress[0].LocalDateResiding != null) {
              this.RegistrationDetail.AddressTab.LocalAddress[0].LocalDateResiding = this.dateFormat.parse(this.RegistrationDetail.AddressTab.LocalAddress[0].LocalDateResiding);
            }

            if (this.RegistrationDetail.AddressTab.LocalAddress[0].LocalPropertyOwned != null && this.RegistrationDetail.AddressTab.LocalAddress[0].LocalPropertyOwned != '') {
              this.RegistrationDetail.AddressTab.LocalAddress[0].LocalPropertyOwned = this.RegistrationDetail.AddressTab.LocalAddress[0].LocalPropertyOwned.toLowerCase() == 'true' ? true : false;
            }
            if (this.RegistrationDetail.AddressTab.LocalAddress[0].LocalDistrictId > 0) {
              this.ComboLoad('District', 'LocalDistrict', 0, false);
            }
            if (this.RegistrationDetail.AddressTab.LocalAddress[0].LocalTalukaTehsilId > 0) {
              this.ComboLoad('Taluka', 'LocalTaluka', 0, false);
            }
            if (this.RegistrationDetail.AddressTab.LocalAddress[0].LocalPincode == 0 || this.RegistrationDetail.AddressTab.LocalAddress[0].LocalPincode == '0' || this.RegistrationDetail.AddressTab.LocalAddress[0].LocalPincode == '') {
              this.RegistrationDetail.AddressTab.LocalAddress[0].LocalPincode = null;
            }

            if (this.RegistrationDetail.AddressTab.Attachment != null && this.RegistrationDetail.AddressTab.Attachment != "") {
              this.RegistrationDetail.AddressTab.Attachmenturl = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.AddressFolder + '/' + this.RegistrationDetail.AddressTab.Attachment;
            }

            if (this.RegistrationDetail.AddressTab.NativeAddress[0].NativeDistrictId > 0) {
              this.ComboLoad('District', 'NativeDistrict', 0, false);
            }
            if (this.RegistrationDetail.AddressTab.NativeAddress[0].NativeTalukaTehsilId > 0) {
              this.ComboLoad('Taluka', 'NativeTaluka', 0, false);
            }

            if (this.RegistrationDetail.AddressTab.NativeAddress[0].NativePincode == 0 || this.RegistrationDetail.AddressTab.NativeAddress[0].NativePincode == '0' || this.RegistrationDetail.AddressTab.NativeAddress[0].NativePincode == '') {
              this.RegistrationDetail.AddressTab.NativeAddress[0].NativePincode = null;
            }

            if (this.RegistrationDetail.AddressTab.NativeAddress[0].NativeContactPersonNo == 0 || this.RegistrationDetail.AddressTab.NativeAddress[0].NativeContactPersonNo == '0' || this.RegistrationDetail.AddressTab.NativeAddress[0].NativeContactPersonNo == '') {
              this.RegistrationDetail.AddressTab.NativeAddress[0].NativeContactPersonNo = null;
            }

            if (this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthDistrictId > 0) {
              this.ComboLoad('District', 'PlaceofBirthDistrict', 0, false);
            }
            if (this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthTalukaTehsilId > 0) {
              this.ComboLoad('Taluka', 'PlaceofBirthTaluka', 0, false);
            }
            if (this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthPincode == 0 || this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthPincode == '0' || this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthPincode == '') {
              this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthPincode = null;
            }

            if (this.RegistrationDetail.AddressTab.EmergencyContact[0].DistrictId > 0) {
              this.ComboLoad('District', 'EmergencyContactDistrict', 0, false);
            }
            if (this.RegistrationDetail.AddressTab.EmergencyContact[0].TalukaTehsilId > 0) {
              this.ComboLoad('Taluka', 'EmergencyContactTaluka', 0, false);
            }
            if (this.RegistrationDetail.AddressTab.EmergencyContact[0].ContactNumber == 0 || this.RegistrationDetail.AddressTab.EmergencyContact[0].ContactNumber == '0' || this.RegistrationDetail.AddressTab.EmergencyContact[0].ContactNumber == '') {
              this.RegistrationDetail.AddressTab.EmergencyContact[0].ContactNumber = null;
            }
            if (this.RegistrationDetail.AddressTab.EmergencyContact[0].Pincode == 0 || this.RegistrationDetail.AddressTab.EmergencyContact[0].Pincode == '0' || this.RegistrationDetail.AddressTab.EmergencyContact[0].Pincode == '') {
              this.RegistrationDetail.AddressTab.EmergencyContact[0].Pincode = null;
            }


            //ESIC Nominee Detail
            try {
              if (this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails.length > 0) {
                if (this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails[0].EmpPFNominee != null && this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails[0].EmpPFNominee != '') {
                  this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails.forEach((element, index) => {
                    if (element.NomineeBirthDate != "" && element.NomineeBirthDate) {
                      element.NomineeBirthDate = this.dateFormat.parse(element.NomineeBirthDate);
                    }
                    if (element.NomineePinCode == 0 || element.NomineePinCode == '0' || element.NomineePinCode == '') {
                      element.NomineePinCode = null;
                    }
                    this.ComboLoad('District', 'NomineeDistrict', index, false);
                    this.ComboLoad('Taluka', 'NomineeTaluka', index, false);
                    element.Minor = element.Minor == null ? false : element.Minor.toLowerCase() == 'yes' ? true : false;
                    if (element.ContactNo == null || element.ContactNo == '' || element.ContactNo == undefined) {
                      element.ContactNo = null;
                    }
                  });
                } else {
                  if ((this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails[0].EmpPFNominee == null || this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails[0].EmpPFNominee == '') && !this.CheckCompulsoryField(0, 'EmpPFNominee', 'Tab5')) {
                    this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails = [];
                  }
                }
              } else { this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails = []; }
            } catch (e) {
              this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails = [];
            }


            try {
              if (this.RegistrationDetail.EmpNomineeESIC.EmpDependentDetails.length > 0) {
                if (this.RegistrationDetail.EmpNomineeESIC.EmpDependentDetails[0].Name != null && this.RegistrationDetail.EmpNomineeESIC.EmpDependentDetails[0].Name != '') {
                  this.RegistrationDetail.EmpNomineeESIC.EmpDependentDetails.forEach((element: any) => {
                    if (element.Address != null && element.Address != "") {
                      element.Address = parseInt(element.Address);
                    }

                    if (element.DateOfBirth != "" && element.DateOfBirth) {
                      element.DateOfBirth = this.dateFormat.parse(element.DateOfBirth);
                    }
                    try {
                      if (element.DocumentMasterId != null && element.DocumentAttachment != null && element.DocumentAttachment != "") {
                        element.DocumentAttachmenturl = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.EmpDependentsTypeOfProofs.filter((e: any) => e.DocumentMasterID == element.DocumentMasterId)[0].Document + '/' + element.DocumentAttachment;
                      }
                    } catch (e) { }

                    try {
                      if (element.DocumentMasterId == null) {
                        if (element.DocumentNo == 0 || element.DocumentNo == '0') {
                          element.DocumentNo = null;
                        }
                      }
                    } catch (e) { }
                  });
                } else {
                  if ((this.RegistrationDetail.EmpNomineeESIC.EmpDependentDetails[0].Name == null || this.RegistrationDetail.EmpNomineeESIC.EmpDependentDetails[0].Name == '') && !this.CheckCompulsoryField(0, 'Name', 'Tab5')) {
                    this.RegistrationDetail.EmpNomineeESIC.EmpDependentDetails = [];
                  }
                }
              } else {
                this.RegistrationDetail.EmpNomineeESIC.EmpDependentDetails = [];
              }
            } catch (e) {
              this.RegistrationDetail.EmpNomineeESIC.EmpDependentDetails = [];
            }


            if (this.RegistrationDetail.EmpNomineeESIC.EmpDependentDetails.length < this.RegistrationDetail.AdditionalInformation.NoofDependents) {
              for (let index = 0; this.RegistrationDetail.EmpNomineeESIC.EmpDependentDetails.length < this.RegistrationDetail.AdditionalInformation.NoofDependents; index++) {
                this.addDependentForm();
              }
            }

            //Other Detail
            try {
              if (this.RegistrationDetail.OtherDetails.ReferenceDetails.length > 0) {
                if (this.RegistrationDetail.OtherDetails.ReferenceDetails[0].Name != null && this.RegistrationDetail.OtherDetails.ReferenceDetails[0].Name != '') {
                  this.RegistrationDetail.OtherDetails.ReferenceDetails.forEach((element: any, index: any) => {
                    this.ComboLoad('District', 'ReferenceDistrict', index, false);
                    this.ComboLoad('Taluka', 'ReferenceTaluka', index, false)

                    if (element.PinCode == 0 || element.PinCode == '0' || element.PinCode == '') {
                      element.PinCode = null;
                    }

                    if (element.ContactNo == 0 || element.ContactNo == '0' || element.ContactNo == '') {
                      element.ContactNo = null;
                    }
                  });

                } else {
                  if ((this.RegistrationDetail.OtherDetails.ReferenceDetails[0].Name == null || this.RegistrationDetail.OtherDetails.ReferenceDetails[0].Name == '') && !this.CheckCompulsoryField(0, 'OthDet_Name', 'Tab6')) {
                    this.RegistrationDetail.OtherDetails.ReferenceDetails = [];
                  }
                }
              } else {
                this.RegistrationDetail.OtherDetails.ReferenceDetails = [];
              }
            } catch (e) {
              this.RegistrationDetail.OtherDetails.ReferenceDetails = [];
            }

            try {
              if (this.RegistrationDetail.OtherDetails.Witness.length > 0) {
                if (this.RegistrationDetail.OtherDetails.Witness[0].Name != null && this.RegistrationDetail.OtherDetails.Witness[0].Name != '') {
                  this.RegistrationDetail.OtherDetails.Witness.forEach((element: any, index: any) => {
                    this.ComboLoad('District', 'WitnessDistrict', index, false);
                    this.ComboLoad('Taluka', 'WitnessTaluka', index, false)

                    if (element.PinCode == 0 || element.PinCode == '0' || element.PinCode == '') {
                      element.PinCode = null;
                    }

                    if (element.ContactNo == 0 || element.ContactNo == '0' || element.ContactNo == '') {
                      element.ContactNo = null;
                    }
                  });
                } else {
                  if ((this.RegistrationDetail.OtherDetails.Witness[0].Name == null || this.RegistrationDetail.OtherDetails.Witness[0].Name == '') && !this.CheckCompulsoryField(0, 'WitnessDet_Name', 'Tab6')) {
                    this.RegistrationDetail.OtherDetails.Witness = [];
                  }
                }
              } else {
                this.RegistrationDetail.OtherDetails.Witness = [];
              }
            } catch (e) {
              this.RegistrationDetail.OtherDetails.Witness = [];
            }

            try {
              if (this.RegistrationDetail.OtherDetails.PreviousEmploymentdetails.length > 0) {
                if (this.RegistrationDetail.OtherDetails.PreviousEmploymentdetails[0].Name != null && this.RegistrationDetail.OtherDetails.PreviousEmploymentdetails[0].Name != '') {
                  this.RegistrationDetail.OtherDetails.PreviousEmploymentdetails.forEach((element: any, index: any) => {
                    if (element.FromDate != "" && element.FromDate != null) {
                      element.FromDate = this.dateFormat.parse(element.FromDate);
                    }
                    if (element.ToDate != "" && element.ToDate != null) {
                      element.ToDate = this.dateFormat.parse(element.ToDate);
                    }

                    if (element.Attachment != null && element.Attachment != "") {
                      element.AttachmentURL = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.PreviousEmployment + '/' + element.Attachment;
                    }

                    if (element.RelievingLetter != null && element.RelievingLetter != "") {
                      element.RelievingLetterURL = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.PreviousEmployment + '/' + element.RelievingLetter;
                    }

                    if (element.OfferLetter != null && element.OfferLetter != "") {
                      element.OfferLetterURL = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.PreviousEmployment + '/' + element.OfferLetter;
                    }

                    if (element.Payslip != null && element.Payslip != "") {
                      element.PayslipURL = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.PreviousEmployment + '/' + element.Payslip;
                    }
                  });
                } else {
                  if ((this.RegistrationDetail.OtherDetails.PreviousEmploymentdetails[0].Name == null || this.RegistrationDetail.OtherDetails.PreviousEmploymentdetails[0].Name == '') && !this.CheckCompulsoryField(0, 'Name', 'Tab6')) {
                    this.RegistrationDetail.OtherDetails.PreviousEmploymentdetails = [];
                  }
                }
              } else {
                this.RegistrationDetail.OtherDetails.PreviousEmploymentdetails = [];
              }
            } catch (e) {
              this.RegistrationDetail.OtherDetails.PreviousEmploymentdetails = [];
            }

            if (this.RegistrationDetail.OtherDetails.Referraldetails.length > 0) {
              this.RegistrationDetail.OtherDetails.ReferralSource = this.common.ToLowerCase(this.RegistrationDetail.OtherDetails.Referraldetails[0].ReferralSource);
              this.RegistrationDetail.OtherDetails.ReferredBy = this.RegistrationDetail.OtherDetails.Referraldetails[0].ReferredBy;
              this.RegistrationDetail.OtherDetails.ReferralSourceCategory = this.common.ToLowerCase(this.RegistrationDetail.OtherDetails.Referraldetails[0].ReferralSourceCategory);
              this.RegistrationDetail.OtherDetails.EmpCode = this.RegistrationDetail.OtherDetails.Referraldetails[0].ReferrerCode;
              this.RegistrationDetail.OtherDetails.EmpName = this.RegistrationDetail.OtherDetails.Referraldetails[0].ReferrerCode + " - " + this.RegistrationDetail.OtherDetails.Referraldetails[0].ReferrerName;
            }

            //Account Licences
            // if (this.RegistrationDetail.AccountLicencesTab.ExistingMemberOfESIC != null && this.RegistrationDetail.AccountLicencesTab.ExistingMemberOfESIC != "") {
            //   this.RegistrationDetail.AccountLicencesTab.ExistingMemberOfESIC = this.RegistrationDetail.AccountLicencesTab.ExistingMemberOfESIC.toLowerCase() == 'true' ? true : false;
            // }
            // if (this.RegistrationDetail.AccountLicencesTab.ExistingMemberOfPF != null && this.RegistrationDetail.AccountLicencesTab.ExistingMemberOfPF != "") {
            //   this.RegistrationDetail.AccountLicencesTab.ExistingMemberOfPF = this.RegistrationDetail.AccountLicencesTab.ExistingMemberOfPF.toLowerCase() == 'true' ? true : false;
            // }
            // if (this.RegistrationDetail.AccountLicencesTab.PFStatutoryDeduction != null && this.RegistrationDetail.AccountLicencesTab.PFStatutoryDeduction != "") {
            //   this.RegistrationDetail.AccountLicencesTab.PFStatutoryDeduction = this.RegistrationDetail.AccountLicencesTab.PFStatutoryDeduction.toLowerCase() == 'true' ? true : false;
            // }
            // if (this.RegistrationDetail.AccountLicencesTab.HoldingGun != null && this.RegistrationDetail.AccountLicencesTab.HoldingGun != "") {
            //   this.RegistrationDetail.AccountLicencesTab.HoldingGun = this.RegistrationDetail.AccountLicencesTab.HoldingGun.toLowerCase() == 'true' ? true : false;
            // }
            if (this.RegistrationDetail.AccountLicencesTab.HoldingDrivingLicense != null && this.RegistrationDetail.AccountLicencesTab.HoldingDrivingLicense != "") {
              this.RegistrationDetail.AccountLicencesTab.HoldingDrivingLicense = this.RegistrationDetail.AccountLicencesTab.HoldingDrivingLicense.toLowerCase() == 'true' ? true : false;
            }

            if (this.RegistrationDetail.AccountLicencesTab.HoldingGun) {
              if (this.RegistrationDetail.AccountLicencesTab.DateOfIssue != "" && this.RegistrationDetail.AccountLicencesTab.DateOfIssue != null) {
                this.RegistrationDetail.AccountLicencesTab.DateOfIssue = this.dateFormat.parse(this.RegistrationDetail.AccountLicencesTab.DateOfIssue);
              }
              if (this.RegistrationDetail.AccountLicencesTab.DateOfExpiry != "" && this.RegistrationDetail.AccountLicencesTab.DateOfExpiry != null) {
                this.RegistrationDetail.AccountLicencesTab.DateOfExpiry = this.dateFormat.parse(this.RegistrationDetail.AccountLicencesTab.DateOfExpiry);
              }
              if (this.RegistrationDetail.AccountLicencesTab.GunRegistrationDate != "" && this.RegistrationDetail.AccountLicencesTab.GunRegistrationDate != null) {
                this.RegistrationDetail.AccountLicencesTab.GunRegistrationDate = this.dateFormat.parse(this.RegistrationDetail.AccountLicencesTab.GunRegistrationDate);
              }
            }

            if (this.RegistrationDetail.AccountLicencesTab.HoldingDrivingLicense) {
              if (this.RegistrationDetail.AccountLicencesTab.DrivingLicenseIssueDate != "" && this.RegistrationDetail.AccountLicencesTab.DrivingLicenseIssueDate != null) {
                this.RegistrationDetail.AccountLicencesTab.DrivingLicenseIssueDate = this.dateFormat.parse(this.RegistrationDetail.AccountLicencesTab.DrivingLicenseIssueDate);
              }
              if (this.RegistrationDetail.AccountLicencesTab.DrivingLicenseExpiryDate != "" && this.RegistrationDetail.AccountLicencesTab.DrivingLicenseExpiryDate != null) {
                this.RegistrationDetail.AccountLicencesTab.DrivingLicenseExpiryDate = this.dateFormat.parse(this.RegistrationDetail.AccountLicencesTab.DrivingLicenseExpiryDate);
              }
            }

            if (this.RegistrationDetail.AccountLicencesTab.AadharAttachment != null && this.RegistrationDetail.AccountLicencesTab.AadharAttachment != "") {
              this.RegistrationDetail.AccountLicencesTab.AadharAttachmenturl = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.AadhaarFolder + '/' + this.RegistrationDetail.AccountLicencesTab.AadharAttachment;
            }
            if (this.RegistrationDetail.AccountLicencesTab.PANAttachment != null && this.RegistrationDetail.AccountLicencesTab.PANAttachment != "") {
              this.RegistrationDetail.AccountLicencesTab.PANAttachmenturl = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.PanFolder + '/' + this.RegistrationDetail.AccountLicencesTab.PANAttachment;
            }
            if (this.RegistrationDetail.AccountLicencesTab.BankAttachment != null && this.RegistrationDetail.AccountLicencesTab.BankAttachment != "") {
              this.RegistrationDetail.AccountLicencesTab.BankAttachmenturl = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.BankDetailsFolder + '/' + this.RegistrationDetail.AccountLicencesTab.BankAttachment;
            }
            if (this.RegistrationDetail.AccountLicencesTab.DrivingAttachment != null && this.RegistrationDetail.AccountLicencesTab.DrivingAttachment != "") {
              this.RegistrationDetail.AccountLicencesTab.DrivingAttachmenturl = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.DrivingLicenseFolder + '/' + this.RegistrationDetail.AccountLicencesTab.DrivingAttachment;
            }
            if (this.RegistrationDetail.AccountLicencesTab.GunAttachment != null && this.RegistrationDetail.AccountLicencesTab.GunAttachment != "") {
              this.RegistrationDetail.AccountLicencesTab.GunAttachmenturl = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.GunLicenseFolder + '/' + this.RegistrationDetail.AccountLicencesTab.GunAttachment;
            }

            this.RegistrationDetail.AccountLicencesTab.AccountnoStar = this.RegistrationDetail.AccountLicencesTab.Accountno;

            //Image and document
            if (this.RegistrationDetail.ImageDocumnetTab.Photo != null && this.RegistrationDetail.ImageDocumnetTab.Photo != "") {
              this.RegistrationDetail.ImageDocumnetTab.Photourl = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.PhotoFolder + '/' + '/' + this.RegistrationDetail.ImageDocumnetTab.Photo;
            } else {
              if (this.RegistrationDetail.BasicInformation.photo != null && this.RegistrationDetail.BasicInformation.photo == '') {
                this.RegistrationDetail.ImageDocumnetTab.Photo = this.RegistrationDetail.BasicInformation.photo;
                this.RegistrationDetail.ImageDocumnetTab.Photourl = this.RegistrationDetail.BasicInformation.photourl;
              }
            }

            if (this.RegistrationDetail.ImageDocumnetTab.Signature != null && this.RegistrationDetail.ImageDocumnetTab.Signature != "") {
              this.RegistrationDetail.ImageDocumnetTab.Signatureurl = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.SignatureFolder + '/' + '/' + this.RegistrationDetail.ImageDocumnetTab.Signature;
            }
            if (this.RegistrationDetail.ImageDocumnetTab.LH1 != null && this.RegistrationDetail.ImageDocumnetTab.LH1 != "") {
              this.RegistrationDetail.ImageDocumnetTab.LH1url = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.LH1Folder + '/' + this.RegistrationDetail.ImageDocumnetTab.LH1;
            }
            if (this.RegistrationDetail.ImageDocumnetTab.LH2 != null && this.RegistrationDetail.ImageDocumnetTab.LH2 != "") {
              this.RegistrationDetail.ImageDocumnetTab.LH2url = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.LH2Folder + '/' + this.RegistrationDetail.ImageDocumnetTab.LH2;
            }
            if (this.RegistrationDetail.ImageDocumnetTab.LH3 != null && this.RegistrationDetail.ImageDocumnetTab.LH3 != "") {
              this.RegistrationDetail.ImageDocumnetTab.LH3url = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.LH3Folder + '/' + this.RegistrationDetail.ImageDocumnetTab.LH3;
            }
            if (this.RegistrationDetail.ImageDocumnetTab.LH4 != null && this.RegistrationDetail.ImageDocumnetTab.LH4 != "") {
              this.RegistrationDetail.ImageDocumnetTab.LH4url = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.LH4Folder + '/' + this.RegistrationDetail.ImageDocumnetTab.LH4;
            }
            if (this.RegistrationDetail.ImageDocumnetTab.LH5 != null && this.RegistrationDetail.ImageDocumnetTab.LH5 != "") {
              this.RegistrationDetail.ImageDocumnetTab.LH5url = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.LH5Folder + '/' + this.RegistrationDetail.ImageDocumnetTab.LH5;
            }
            if (this.RegistrationDetail.ImageDocumnetTab.RH1 != null && this.RegistrationDetail.ImageDocumnetTab.RH1 != "") {
              this.RegistrationDetail.ImageDocumnetTab.RH1url = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.RH1Folder + '/' + this.RegistrationDetail.ImageDocumnetTab.RH1;
            }
            if (this.RegistrationDetail.ImageDocumnetTab.RH2 != null && this.RegistrationDetail.ImageDocumnetTab.RH2 != "") {
              this.RegistrationDetail.ImageDocumnetTab.RH2url = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.RH2Folder + '/' + this.RegistrationDetail.ImageDocumnetTab.RH2;
            }
            if (this.RegistrationDetail.ImageDocumnetTab.RH3 != null && this.RegistrationDetail.ImageDocumnetTab.RH3 != "") {
              this.RegistrationDetail.ImageDocumnetTab.RH3url = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.RH3Folder + '/' + this.RegistrationDetail.ImageDocumnetTab.RH3;
            }
            if (this.RegistrationDetail.ImageDocumnetTab.RH4 != null && this.RegistrationDetail.ImageDocumnetTab.RH4 != "") {
              this.RegistrationDetail.ImageDocumnetTab.RH4url = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.RH4Folder + '/' + this.RegistrationDetail.ImageDocumnetTab.RH4;
            }
            if (this.RegistrationDetail.ImageDocumnetTab.RH5 != null && this.RegistrationDetail.ImageDocumnetTab.RH5 != "") {
              this.RegistrationDetail.ImageDocumnetTab.RH5url = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.RH5Folder + '/' + this.RegistrationDetail.ImageDocumnetTab.RH5;
            }
            if (this.RegistrationDetail.ImageDocumnetTab.EmpDocumentAttachment.length > 0) {
              if (this.RegistrationDetail.ImageDocumnetTab.EmpDocumentAttachment[0].DocumentMasterId == null || this.RegistrationDetail.ImageDocumnetTab.EmpDocumentAttachment[0].DocumentMasterId == '' || parseInt(this.RegistrationDetail.ImageDocumnetTab.EmpDocumentAttachment[0].DocumentMasterId) == 0) {
                this.RegistrationDetail.ImageDocumnetTab.EmpDocumentAttachment = [];
              }
            }

            if (!this.RegistrationDetail.BasicInformation.IsZingHrEntry || this.RegistrationDetail.BasicInformation.IsZingHrEntry == null || this.RegistrationDetail.BasicInformation.IsZingHrEntry == '') {
              //if (true) {
              this.CheckMandateDocument();
            }


            this.RegistrationDetail.ImageDocumnetTab.EmpDocumentAttachment.forEach((element: any) => {
              if (element.Attachment != null && element.Attachment != "") {
                element.Attachmenturl = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + element.Document + '/' + element.Attachment;
              }
              if (element.IssueDate != "" && element.IssueDate != null) {
                element.IssueDate = this.dateFormat.parse(element.IssueDate);
              }
              if (element.ExpiryDate != "" && element.ExpiryDate != null) {
                element.ExpiryDate = this.dateFormat.parse(element.ExpiryDate);
              }
              try {
                element.IssueExpiryDateRequired = this.Documents.filter((e: any) => e.DocumentMasterID == element.DocumentMasterId)[0]["IssueExpiryDateRequired"];
              } catch (e) {
                element.IssueExpiryDateRequired = false;
              }
              try {
                element.Compulsory = this.Documents.filter((e: any) => e.DocumentMasterID == element.DocumentMasterId)[0]["Compulsory"];
              } catch (e) {
                element.Compulsory = false;
              }
            });
            if (this.common.ToLowerCase(this.RegistrationDetail.employeeInfo.RegistrationType) == 'preonboarding') {
              this.GetDataPreonboarding();
            } else if (this.common.ToLowerCase(this.RegistrationDetail.employeeInfo.RegistrationType) == 'manual' || this.RegistrationDetail.employeeInfo.RegistrationType == '' || this.RegistrationDetail.employeeInfo.RegistrationType == null) {
              if (!this.filter.IsDraft || this.common.ToLowerCase(this.filter.IsDraft.toString()) == 'false') {
                this.GetDataMenual();
              } else {
                // debugger
                // if (this.common.ToLowerCase(this.RegistrationDetail.employeeInfo.BGVStatus) == null || this.common.ToLowerCase(this.RegistrationDetail.employeeInfo.BGVStatus) == '' || this.common.ToLowerCase(this.RegistrationDetail.employeeInfo.VerificationMode) == 'manual') {
                //   this.IsEditable = true;
                // } else {
                //   this.IsEditable = false;
                // }
                this.IsEditable = true;
              }
            } else if (this.common.ToLowerCase(this.RegistrationDetail.employeeInfo.RegistrationType) == 'mobile registration' && (!this.filter.IsDraft || this.common.ToLowerCase(this.filter.IsDraft.toString()) == 'false')) {
              this.IsEditable = true;
              this.GetDataMenual();
              // debugger
              // if ( this.common.ToLowerCase(this.RegistrationDetail.employeeInfo.BGVStatus) == null || this.common.ToLowerCase(this.RegistrationDetail.employeeInfo.BGVStatus) == '' || this.common.ToLowerCase(this.RegistrationDetail.employeeInfo.VerificationMode) == 'manual') {
              //   this.IsEditable = true;
              // } else {
              //   this.IsEditable = false;
              // }
              //this.IsEditable = true;
            }
            this.showFooterMasking();
          } else {
            this.toast.show({ message: response.Error_Message, type: toastTypeEnum.warning });
          }
        }

        if ((this.RegistrationDetail.BasicInformation.SiteId != null && this.RegistrationDetail.BasicInformation.SiteId != '' && this.RegistrationDetail.BasicInformation.SiteId > 0) && !this.RegistrationDetail.BasicInformation.IsTempEmployee) {
          this.checkFieldDisableFlag = true;
        } else {
          this.checkFieldDisableFlag = false;
        }

        this.GetCompulsoryFields('');
        if (this.common.CompanyParameterValue.ESS_IsEmpBGVApplicable) {
          this.ESS_EmpBgvMandatoryDataLoad();
        }
        this.SelectDate('PreJoiningDate', null, null);

        if (!this.RegistrationDetail.BasicInformation.IsTempEmployee) {
          this.ESS_EmployeeLetterDetailsLoad();
        }
        this.GetAadharPanBankCompulsory();
        this.ESS_EmpBGVVerificationDetailsSelect();
        this.isDisabledG = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabledG = false;
      },
    });
  }

  SetEmployeeName(event: any) {
    // this.RegistrationDetail.BasicInformation.firstName = this.RegistrationDetail.BasicInformation.firstName;
    // this.RegistrationDetail.BasicInformation.middleName = this.RegistrationDetail.BasicInformation.middleName;
    // this.RegistrationDetail.BasicInformation.lastName = this.RegistrationDetail.BasicInformation.lastName;
    this.RegistrationDetail.BasicInformation.EmpName = (this.RegistrationDetail.BasicInformation.firstName != null ? this.common.ToUpperCase(this.RegistrationDetail.BasicInformation.firstName) : '') + " " + (this.RegistrationDetail.BasicInformation.middleName != null ? this.common.ToUpperCase(this.RegistrationDetail.BasicInformation.middleName) : '') + " " + (this.RegistrationDetail.BasicInformation.lastName != null ? this.common.ToUpperCase(this.RegistrationDetail.BasicInformation.lastName) : '');
  }

  AddEss_Qual(form: any) {
    if (form.valid) {
      if (this.RegistrationDetail.AdditionalInformation.Ess_Qual.findIndex((e: any) => e.QualificationId == this.Ess_Qual.QualificationId) == -1) {
        if ((!this.CheckCompulsoryField(0, 'YearOfPassing', 'Tab3') && this.Ess_Qual.YearOfPassing == null) || (this.Ess_Qual.YearOfPassing >= this.minQulificationYear && this.Ess_Qual.YearOfPassing <= this.currentYear)) {
          if (this.Ess_Qual.Percentage <= 100) {
            if (this.Ess_Qual.CGPA == null || this.Ess_Qual.CGPA == '' || this.Ess_Qual.CGPA <= 10) {
              this.RegistrationDetail.AdditionalInformation.Ess_Qual.push(
                {
                  GradeClass: this.Ess_Qual.GradeClass,// // 
                  YearOfPassing: this.Ess_Qual.YearOfPassing,// //
                  Percentage: this.Ess_Qual.Percentage,// //
                  UniversityBoard: this.Ess_Qual.UniversityBoard,// //
                  QualificationId: this.Ess_Qual.QualificationId,// //
                  QualificationName: this.Qualifications[this.Qualifications.findIndex((e: any) => e.QualificationMasterID == this.Ess_Qual.QualificationId)].QualificationName,// //
                  EnrollmentNumber: this.Ess_Qual.EnrollmentNumber,
                  College: this.Ess_Qual.College,
                  CGPA: this.Ess_Qual.CGPA,
                }
              );
              this.QualificationDatas = Object.values(this.RegistrationDetail.AdditionalInformation.Ess_Qual);
              // this.dtQulification.dtInstance.then((dtInstance: DataTables.Api) => {
              //   dtInstance.destroy();
              //   this.dtTrigger.next(null);
              // });

              this.Ess_Qual.GradeClass = null;
              this.Ess_Qual.YearOfPassing = null;
              this.Ess_Qual.Percentage = null;
              this.Ess_Qual.UniversityBoard = null;
              this.Ess_Qual.QualificationId = null;
              this.Ess_Qual.EnrollmentNumber = null;
              this.Ess_Qual.College = null;
              this.Ess_Qual.CGPA = null;
            } else {
              this.toast.show({ message: 'CGPA maximum 10 allow', type: toastTypeEnum.warning });
            }
          } else {
            this.toast.show({ message: 'Qualification percentage max 100', type: toastTypeEnum.warning });
          }
        } else {
          this.toast.show({ message: 'Passing year shoud be between ' + this.minQulificationYear + ' to ' + this.currentYear, type: toastTypeEnum.warning });
        }
        form.submitted = false;
      } else {
        this.toast.show({ message: 'Qualification already exists', type: toastTypeEnum.warning });
      }
    }
    else {
      form.submitted = true;
    }
  }

  DeleteQulification(index: any) {
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Do you want to delete?';
    modalRef.result.then((result: any) => {
      if (result) {
        this.RegistrationDetail.AdditionalInformation.Ess_Qual.splice(index, 1);
        this.QualificationDatas = Object.values(this.RegistrationDetail.AdditionalInformation.Ess_Qual);
        // this.dtQulification.dtInstance.then((dtInstance: DataTables.Api) => {
        //   dtInstance.destroy();
        //   this.dtTrigger.next(null);
        // });
      }
    });
  }

  AddEss_Lang(form: any) {
    if (form.valid) {
      if (this.RegistrationDetail.AdditionalInformation.Ess_Lang.findIndex((e: any) => e.LanguageID == this.Ess_Lang.LanguageID) == -1) {
        if (this.Ess_Lang.LanguageID > 0 && (this.Ess_Lang.Read || this.Ess_Lang.Write || this.Ess_Lang.Speak)) {
          this.RegistrationDetail.AdditionalInformation.Ess_Lang.push(
            {
              LanguageID: this.Ess_Lang.LanguageID,// //
              Language: this.Languages[this.Languages.findIndex((e: any) => e.LanguageMasterID == this.Ess_Lang.LanguageID)].LanguageName,// //
              Read: this.Ess_Lang.Read,// //
              Write: this.Ess_Lang.Write,// // 
              Speak: this.Ess_Lang.Speak,// //
            }
          );

          //this.DataTable2.LoadData(this.RegistrationDetail.AdditionalInformation.Ess_Lang);
          this.LanguageDatas = Object.values(this.RegistrationDetail.AdditionalInformation.Ess_Lang);
          this.dtLanguage.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtTriggerLng.next(null);
          });
          this.Ess_Lang.LanguageID = null;
          this.Ess_Lang.Read = false;
          this.Ess_Lang.Write = false;
          this.Ess_Lang.Speak = false;
        } else {
          this.toast.show({ message: 'Please select one of read/write/speak options', type: toastTypeEnum.warning });
        }
      } else {
        this.toast.show({ message: 'Language already exists', type: toastTypeEnum.warning });
      }
      form.submitted = false;
    }
    else {
      form.submitted = true;
    }
  }

  DeleteLanguage(index: any) {
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Do you want to delete?';
    modalRef.result.then((result: any) => {
      if (result) {
        this.RegistrationDetail.AdditionalInformation.Ess_Lang.splice(index, 1);
        this.LanguageDatas = Object.values(this.RegistrationDetail.AdditionalInformation.Ess_Lang);
        this.dtLanguage.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTriggerLng.next(null);
        });
      }
    });
  }

  addNomineeForm() {
    this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails.push(
      {
        EmpPFNominee: null,
        NomineeAddress1: null,
        NomineeAddress2: null,
        NomineeRelationshipId: null,
        NomineeVillageCity: null,
        NomineeStateId: null,
        NomineeDistrictId: null,
        NomineeTalukaTehsilId: null,
        NomineePinCode: null,
        NomineeBirthDate: null as any,
        NomineeShare: null,
        Minor: false,
        MinorNomineeGuardian: null,
        NomineeAddressTypeId: null,
        AddressTypeMasterId: null,
        ContactNo: null
      }
    );
    // this.NomineeRelationshipsFilter[this.NomineeRelationshipsFilter.length] = this.NomineeRelationships;
    // this.NomineeStatesFilter[this.NomineeStatesFilter.length] = this.NomineeStates;
  }

  addDependentForm() {
    this.RegistrationDetail.EmpNomineeESIC.EmpDependentDetails.push(
      {
        Name: null,
        Address: null,
        DateOfBirth: null as any,
        Relationship: null,
        DocumentMasterId: null,
        DocumentNo: null,
        DocumentAttachment: null,
        DocumentAttachmenturl: null,
      }
    );
    // this.EmpDependentRelationshipsFilter[this.EmpDependentRelationshipsFilter.length] = this.EmpDependentRelationships;
    // this.EmpDependentAddressTypesFilter[this.EmpDependentAddressTypesFilter.length] = this.EmpDependentsAddressTypes;
    // this.EmpDependentsTypeOfProofsFilter[this.EmpDependentsTypeOfProofsFilter.length] = this.EmpDependentsTypeOfProofs;
  }

  addReferenceForm() {
    this.RegistrationDetail.OtherDetails.ReferenceDetails.push(
      {
        Name: null,
        Address1: null,
        Address2: null,
        VillageCity: null,
        StateId: null,
        DistrictId: null,
        TalukaTehsilId: null,
        PinCode: null,
        ContactNo: null,
        AddressTypeMasterId: null,
      }
    );
    // this.ReferenceStatesFilter[this.ReferenceStatesFilter.length] = this.ReferenceStates;
  }

  addWitnessForm() {
    this.RegistrationDetail.OtherDetails.Witness.push(
      {
        Name: null,
        Address1: null,
        Address2: null,
        VillageCity: null,
        StateId: null,
        DistrictId: null,
        TalukaTehsilId: null,
        PinCode: null,
        ContactNo: null,
        AddressTypeMasterId: null,
      }
    );
    //this.WitnessStatesFilter[this.WitnessStatesFilter.length] = this.WitnessStates;
  }

  addPreviousEmploymentForm() {
    this.RegistrationDetail.OtherDetails.PreviousEmploymentdetails.push(
      {
        Name: null,
        Address: null,
        Position: null,
        FromDate: null,
        ToDate: null,
        EmployerPFNo: null,
        EmployerESICNo: null,
        TotalSalaryDrawn: null,
        ReasonOfLeaving: null,
        RelievingLetter: null,
        RelievingLetterURL: null,
        OfferLetter: null,
        OfferLetterURL: null,
        Payslip: null,
        PayslipURL: null,
      }
    );
  }

  DeleteRefWitEmpl(index: any, type: any) {
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Do you want to delete?';
    modalRef.result.then((result: any) => {
      if (result) {
        if (type == 'Reference') {
          this.RegistrationDetail.OtherDetails.ReferenceDetails.splice(index, 1);
        } else if (type == 'Witness') {
          this.RegistrationDetail.OtherDetails.Witness.splice(index, 1);
        } else if (type == 'Employment') {
          this.RegistrationDetail.OtherDetails.PreviousEmploymentdetails.splice(index, 1);
        }
      }
    });
  }

  DeletePFESICNominee(index: any, type: any) {
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Do you want to delete?';
    modalRef.result.then((result: any) => {
      if (result) {
        if (type == 'PF') {
          this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails.splice(index, 1);
        } else if (type == 'ESIC') {
          this.RegistrationDetail.EmpNomineeESIC.EmpDependentDetails.splice(index, 1);

          this.RegistrationDetail.AdditionalInformation.NoofDependents = this.RegistrationDetail.EmpNomineeESIC.EmpDependentDetails.length;
        }
      }
    });
  }

  DeleteDocument(index: any) {
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Do you want to delete?';
    modalRef.result.then((result: any) => {
      if (result) {
        this.RegistrationDetail.ImageDocumnetTab.EmpDocumentAttachment.splice(index, 1);
      }
    });
  }

  GetAddress(type: string, index: number) {
    if (type == 'Nominee') {
      this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails[index].NomineeAddress1 = this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails[index].AddressTypeMasterId == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalAddress1 : this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails[index].AddressTypeMasterId == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativeAddress1 : this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails[index].AddressTypeMasterId == 3 ? this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthAddress1 : this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails[index].AddressTypeMasterId == 4 ? this.RegistrationDetail.AddressTab.EmergencyContact[0].ContactAddress1 : null;
      this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails[index].NomineeAddress2 = this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails[index].AddressTypeMasterId == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalAddress2 : this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails[index].AddressTypeMasterId == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativeAddress2 : this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails[index].AddressTypeMasterId == 3 ? this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthAddress2 : this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails[index].AddressTypeMasterId == 4 ? this.RegistrationDetail.AddressTab.EmergencyContact[0].ContactAddress2 : null;
      this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails[index].NomineeVillageCity = this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails[index].AddressTypeMasterId == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalCity : this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails[index].AddressTypeMasterId == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativeCity : this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails[index].AddressTypeMasterId == 3 ? this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthCity : this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails[index].AddressTypeMasterId == 4 ? this.RegistrationDetail.AddressTab.EmergencyContact[0].ContactCity : null;
      this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails[index].NomineeStateId = this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails[index].AddressTypeMasterId == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalStateId : this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails[index].AddressTypeMasterId == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativeStateId : this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails[index].AddressTypeMasterId == 3 ? this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthStateId : this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails[index].AddressTypeMasterId == 4 ? this.RegistrationDetail.AddressTab.EmergencyContact[0].StateId : null;
      this.ComboLoad('District', 'NomineeDistrict', index);
      this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails[index].NomineeDistrictId = this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails[index].AddressTypeMasterId == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalDistrictId : this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails[index].AddressTypeMasterId == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativeDistrictId : this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails[index].AddressTypeMasterId == 3 ? this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthDistrictId : this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails[index].AddressTypeMasterId == 4 ? this.RegistrationDetail.AddressTab.EmergencyContact[0].DistrictId : null;
      this.ComboLoad('Taluka', 'NomineeTaluka', index);
      this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails[index].NomineeTalukaTehsilId = this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails[index].AddressTypeMasterId == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalTalukaTehsilId : this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails[index].AddressTypeMasterId == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativeTalukaTehsilId : this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails[index].AddressTypeMasterId == 3 ? this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthTalukaTehsilId : this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails[index].AddressTypeMasterId == 4 ? this.RegistrationDetail.AddressTab.EmergencyContact[0].TalukaTehsilId : null;
      this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails[index].NomineePinCode = this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails[index].AddressTypeMasterId == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalPincode : this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails[index].AddressTypeMasterId == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativePincode : this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails[index].AddressTypeMasterId == 3 ? this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthPincode : this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails[index].AddressTypeMasterId == 4 ? this.RegistrationDetail.AddressTab.EmergencyContact[0].Pincode : null;
    } else if (type == 'Reference') {
      this.RegistrationDetail.OtherDetails.ReferenceDetails[index].Address1 = this.RegistrationDetail.OtherDetails.ReferenceDetails[index].AddressTypeMasterId == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalAddress1 : this.RegistrationDetail.OtherDetails.ReferenceDetails[index].AddressTypeMasterId == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativeAddress1 : this.RegistrationDetail.OtherDetails.ReferenceDetails[index].AddressTypeMasterId == 3 ? this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthAddress1 : this.RegistrationDetail.OtherDetails.ReferenceDetails[index].AddressTypeMasterId == 4 ? this.RegistrationDetail.AddressTab.EmergencyContact[0].ContactAddress1 : null;
      this.RegistrationDetail.OtherDetails.ReferenceDetails[index].Address2 = this.RegistrationDetail.OtherDetails.ReferenceDetails[index].AddressTypeMasterId == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalAddress2 : this.RegistrationDetail.OtherDetails.ReferenceDetails[index].AddressTypeMasterId == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativeAddress2 : this.RegistrationDetail.OtherDetails.ReferenceDetails[index].AddressTypeMasterId == 3 ? this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthAddress2 : this.RegistrationDetail.OtherDetails.ReferenceDetails[index].AddressTypeMasterId == 4 ? this.RegistrationDetail.AddressTab.EmergencyContact[0].ContactAddress2 : null;
      this.RegistrationDetail.OtherDetails.ReferenceDetails[index].VillageCity = this.RegistrationDetail.OtherDetails.ReferenceDetails[index].AddressTypeMasterId == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalCity : this.RegistrationDetail.OtherDetails.ReferenceDetails[index].AddressTypeMasterId == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativeCity : this.RegistrationDetail.OtherDetails.ReferenceDetails[index].AddressTypeMasterId == 3 ? this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthCity : this.RegistrationDetail.OtherDetails.ReferenceDetails[index].AddressTypeMasterId == 4 ? this.RegistrationDetail.AddressTab.EmergencyContact[0].ContactCity : null;
      this.RegistrationDetail.OtherDetails.ReferenceDetails[index].StateId = this.RegistrationDetail.OtherDetails.ReferenceDetails[index].AddressTypeMasterId == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalStateId : this.RegistrationDetail.OtherDetails.ReferenceDetails[index].AddressTypeMasterId == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativeStateId : this.RegistrationDetail.OtherDetails.ReferenceDetails[index].AddressTypeMasterId == 3 ? this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthStateId : this.RegistrationDetail.OtherDetails.ReferenceDetails[index].AddressTypeMasterId == 4 ? this.RegistrationDetail.AddressTab.EmergencyContact[0].StateId : null;
      this.ComboLoad('District', 'ReferenceDistrict', index);
      this.RegistrationDetail.OtherDetails.ReferenceDetails[index].DistrictId = this.RegistrationDetail.OtherDetails.ReferenceDetails[index].AddressTypeMasterId == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalDistrictId : this.RegistrationDetail.OtherDetails.ReferenceDetails[index].AddressTypeMasterId == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativeDistrictId : this.RegistrationDetail.OtherDetails.ReferenceDetails[index].AddressTypeMasterId == 3 ? this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthDistrictId : this.RegistrationDetail.OtherDetails.ReferenceDetails[index].AddressTypeMasterId == 4 ? this.RegistrationDetail.AddressTab.EmergencyContact[0].DistrictId : null;
      this.ComboLoad('Taluka', 'ReferenceTaluka', index);
      this.RegistrationDetail.OtherDetails.ReferenceDetails[index].TalukaTehsilId = this.RegistrationDetail.OtherDetails.ReferenceDetails[index].AddressTypeMasterId == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalTalukaTehsilId : this.RegistrationDetail.OtherDetails.ReferenceDetails[index].AddressTypeMasterId == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativeTalukaTehsilId : this.RegistrationDetail.OtherDetails.ReferenceDetails[index].AddressTypeMasterId == 3 ? this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthTalukaTehsilId : this.RegistrationDetail.OtherDetails.ReferenceDetails[index].AddressTypeMasterId == 4 ? this.RegistrationDetail.AddressTab.EmergencyContact[0].TalukaTehsilId : null;
      this.RegistrationDetail.OtherDetails.ReferenceDetails[index].PinCode = this.RegistrationDetail.OtherDetails.ReferenceDetails[index].AddressTypeMasterId == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalPincode : this.RegistrationDetail.OtherDetails.ReferenceDetails[index].AddressTypeMasterId == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativePincode : this.RegistrationDetail.OtherDetails.ReferenceDetails[index].AddressTypeMasterId == 3 ? this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthPincode : this.RegistrationDetail.OtherDetails.ReferenceDetails[index].AddressTypeMasterId == 4 ? this.RegistrationDetail.AddressTab.EmergencyContact[0].Pincode : null;
    } else if (type == 'Witness') {
      this.RegistrationDetail.OtherDetails.Witness[index].Address1 = this.RegistrationDetail.OtherDetails.Witness[index].AddressTypeMasterId == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalAddress1 : this.RegistrationDetail.OtherDetails.Witness[index].AddressTypeMasterId == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativeAddress1 : this.RegistrationDetail.OtherDetails.Witness[index].AddressTypeMasterId == 3 ? this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthAddress1 : this.RegistrationDetail.OtherDetails.Witness[index].AddressTypeMasterId == 4 ? this.RegistrationDetail.AddressTab.EmergencyContact[0].ContactAddress1 : null;
      this.RegistrationDetail.OtherDetails.Witness[index].Address2 = this.RegistrationDetail.OtherDetails.Witness[index].AddressTypeMasterId == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalAddress2 : this.RegistrationDetail.OtherDetails.Witness[index].AddressTypeMasterId == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativeAddress2 : this.RegistrationDetail.OtherDetails.Witness[index].AddressTypeMasterId == 3 ? this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthAddress2 : this.RegistrationDetail.OtherDetails.Witness[index].AddressTypeMasterId == 4 ? this.RegistrationDetail.AddressTab.EmergencyContact[0].ContactAddress2 : null;
      this.RegistrationDetail.OtherDetails.Witness[index].VillageCity = this.RegistrationDetail.OtherDetails.Witness[index].AddressTypeMasterId == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalCity : this.RegistrationDetail.OtherDetails.Witness[index].AddressTypeMasterId == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativeCity : this.RegistrationDetail.OtherDetails.Witness[index].AddressTypeMasterId == 3 ? this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthCity : this.RegistrationDetail.OtherDetails.Witness[index].AddressTypeMasterId == 4 ? this.RegistrationDetail.AddressTab.EmergencyContact[0].ContactCity : null;
      this.RegistrationDetail.OtherDetails.Witness[index].StateId = this.RegistrationDetail.OtherDetails.Witness[index].AddressTypeMasterId == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalStateId : this.RegistrationDetail.OtherDetails.Witness[index].AddressTypeMasterId == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativeStateId : this.RegistrationDetail.OtherDetails.Witness[index].AddressTypeMasterId == 3 ? this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthStateId : this.RegistrationDetail.OtherDetails.Witness[index].AddressTypeMasterId == 4 ? this.RegistrationDetail.AddressTab.EmergencyContact[0].StateId : null;
      this.ComboLoad('District', 'WitnessDistrict', index);
      this.RegistrationDetail.OtherDetails.Witness[index].DistrictId = this.RegistrationDetail.OtherDetails.Witness[index].AddressTypeMasterId == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalDistrictId : this.RegistrationDetail.OtherDetails.Witness[index].AddressTypeMasterId == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativeDistrictId : this.RegistrationDetail.OtherDetails.Witness[index].AddressTypeMasterId == 3 ? this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthDistrictId : this.RegistrationDetail.OtherDetails.Witness[index].AddressTypeMasterId == 4 ? this.RegistrationDetail.AddressTab.EmergencyContact[0].DistrictId : null;
      this.ComboLoad('Taluka', 'WitnessTaluka', index);
      this.RegistrationDetail.OtherDetails.Witness[index].TalukaTehsilId = this.RegistrationDetail.OtherDetails.Witness[index].AddressTypeMasterId == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalTalukaTehsilId : this.RegistrationDetail.OtherDetails.Witness[index].AddressTypeMasterId == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativeTalukaTehsilId : this.RegistrationDetail.OtherDetails.Witness[index].AddressTypeMasterId == 3 ? this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthTalukaTehsilId : this.RegistrationDetail.OtherDetails.Witness[index].AddressTypeMasterId == 4 ? this.RegistrationDetail.AddressTab.EmergencyContact[0].TalukaTehsilId : null;
      this.RegistrationDetail.OtherDetails.Witness[index].PinCode = this.RegistrationDetail.OtherDetails.Witness[index].AddressTypeMasterId == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalPincode : this.RegistrationDetail.OtherDetails.Witness[index].AddressTypeMasterId == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativePincode : this.RegistrationDetail.OtherDetails.Witness[index].AddressTypeMasterId == 3 ? this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthPincode : this.RegistrationDetail.OtherDetails.Witness[index].AddressTypeMasterId == 4 ? this.RegistrationDetail.AddressTab.EmergencyContact[0].Pincode : null;
    } else if (type == 'Local') {
      this.RegistrationDetail.AddressTab.LocalAddress[index].LocalAddress1 = this.filter.LocalAddressID == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalAddress1 : this.filter.LocalAddressID == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativeAddress1 : this.filter.LocalAddressID == 3 ? this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthAddress1 : this.filter.LocalAddressID == 4 ? this.RegistrationDetail.AddressTab.EmergencyContact[0].ContactAddress1 : null;
      this.RegistrationDetail.AddressTab.LocalAddress[index].LocalAddress2 = this.filter.LocalAddressID == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalAddress2 : this.filter.LocalAddressID == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativeAddress2 : this.filter.LocalAddressID == 3 ? this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthAddress2 : this.filter.LocalAddressID == 4 ? this.RegistrationDetail.AddressTab.EmergencyContact[0].ContactAddress2 : null;
      this.RegistrationDetail.AddressTab.LocalAddress[index].LocalCity = this.filter.LocalAddressID == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalCity : this.filter.LocalAddressID == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativeCity : this.filter.LocalAddressID == 3 ? this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthCity : this.filter.LocalAddressID == 4 ? this.RegistrationDetail.AddressTab.EmergencyContact[0].ContactCity : null;
      this.RegistrationDetail.AddressTab.LocalAddress[index].LocalStateId = this.filter.LocalAddressID == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalStateId : this.filter.LocalAddressID == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativeStateId : this.filter.LocalAddressID == 3 ? this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthStateId : this.filter.LocalAddressID == 4 ? this.RegistrationDetail.AddressTab.EmergencyContact[0].StateId : null;
      this.RegistrationDetail.AddressTab.LocalAddress[index].LocalPoliceStation = this.filter.LocalAddressID == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalPoliceStation : this.filter.LocalAddressID == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativePoliceStation : this.filter.LocalAddressID == 3 ? null : this.filter.LocalAddressID == 4 ? null : null;
      this.RegistrationDetail.AddressTab.LocalAddress[index].LocalPostOffice = this.filter.LocalAddressID == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalPostOffice : this.filter.LocalAddressID == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativePostOffice : this.filter.LocalAddressID == 3 ? null : this.filter.LocalAddressID == 4 ? null : null;
      this.ComboLoad('District', 'LocalDistrict', index);
      this.RegistrationDetail.AddressTab.LocalAddress[index].LocalDistrictId = this.filter.LocalAddressID == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalDistrictId : this.filter.LocalAddressID == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativeDistrictId : this.filter.LocalAddressID == 3 ? this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthDistrictId : this.filter.LocalAddressID == 4 ? this.RegistrationDetail.AddressTab.EmergencyContact[0].DistrictId : null;
      this.ComboLoad('Taluka', 'LocalTaluka', index);
      this.RegistrationDetail.AddressTab.LocalAddress[index].LocalTalukaTehsilId = this.filter.LocalAddressID == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalTalukaTehsilId : this.filter.LocalAddressID == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativeTalukaTehsilId : this.filter.LocalAddressID == 3 ? this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthTalukaTehsilId : this.filter.LocalAddressID == 4 ? this.RegistrationDetail.AddressTab.EmergencyContact[0].TalukaTehsilId : null;
      this.RegistrationDetail.AddressTab.LocalAddress[index].LocalPincode = this.filter.LocalAddressID == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalPincode : this.filter.LocalAddressID == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativePincode : this.filter.LocalAddressID == 3 ? this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthPincode : this.filter.LocalAddressID == 4 ? this.RegistrationDetail.AddressTab.EmergencyContact[0].Pincode : null;
    } else if (type == 'Native') {
      this.RegistrationDetail.AddressTab.NativeAddress[index].NativeAddress1 = this.filter.NativeAddressID == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalAddress1 : this.filter.NativeAddressID == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativeAddress1 : this.filter.NativeAddressID == 3 ? this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthAddress1 : this.filter.NativeAddressID == 4 ? this.RegistrationDetail.AddressTab.EmergencyContact[0].ContactAddress1 : null;
      this.RegistrationDetail.AddressTab.NativeAddress[index].NativeAddress2 = this.filter.NativeAddressID == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalAddress2 : this.filter.NativeAddressID == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativeAddress2 : this.filter.NativeAddressID == 3 ? this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthAddress2 : this.filter.NativeAddressID == 4 ? this.RegistrationDetail.AddressTab.EmergencyContact[0].ContactAddress2 : null;
      this.RegistrationDetail.AddressTab.NativeAddress[index].NativeCity = this.filter.NativeAddressID == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalCity : this.filter.NativeAddressID == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativeCity : this.filter.NativeAddressID == 3 ? this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthCity : this.filter.NativeAddressID == 4 ? this.RegistrationDetail.AddressTab.EmergencyContact[0].ContactCity : null;
      this.RegistrationDetail.AddressTab.NativeAddress[index].NativeStateId = this.filter.NativeAddressID == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalStateId : this.filter.NativeAddressID == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativeStateId : this.filter.NativeAddressID == 3 ? this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthStateId : this.filter.NativeAddressID == 4 ? this.RegistrationDetail.AddressTab.EmergencyContact[0].StateId : null;
      this.RegistrationDetail.AddressTab.NativeAddress[index].NativePoliceStation = this.filter.NativeAddressID == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalPoliceStation : this.filter.NativeAddressID == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativePoliceStation : this.filter.NativeAddressID == 3 ? null : this.filter.NativeAddressID == 4 ? null : null;
      this.RegistrationDetail.AddressTab.NativeAddress[index].NativePostOffice = this.filter.NativeAddressID == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalPostOffice : this.filter.NativeAddressID == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativePostOffice : this.filter.NativeAddressID == 3 ? null : this.filter.NativeAddressID == 4 ? null : null;
      this.ComboLoad('District', 'NativeDistrict', index);
      this.RegistrationDetail.AddressTab.NativeAddress[index].NativeDistrictId = this.filter.NativeAddressID == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalDistrictId : this.filter.NativeAddressID == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativeDistrictId : this.filter.NativeAddressID == 3 ? this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthDistrictId : this.filter.NativeAddressID == 4 ? this.RegistrationDetail.AddressTab.EmergencyContact[0].DistrictId : null;
      this.ComboLoad('Taluka', 'NativeTaluka', index);
      this.RegistrationDetail.AddressTab.NativeAddress[index].NativeTalukaTehsilId = this.filter.NativeAddressID == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalTalukaTehsilId : this.filter.NativeAddressID == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativeTalukaTehsilId : this.filter.NativeAddressID == 3 ? this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthTalukaTehsilId : this.filter.NativeAddressID == 4 ? this.RegistrationDetail.AddressTab.EmergencyContact[0].TalukaTehsilId : null;
      this.RegistrationDetail.AddressTab.NativeAddress[index].NativePincode = this.filter.NativeAddressID == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalPincode : this.filter.NativeAddressID == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativePincode : this.filter.NativeAddressID == 3 ? this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthPincode : this.filter.NativeAddressID == 4 ? this.RegistrationDetail.AddressTab.EmergencyContact[0].Pincode : null;
    } else if (type == 'PlaceOfBirth') {
      this.RegistrationDetail.AddressTab.PlaceofBirth[index].PlaceOfBirthAddress1 = this.filter.PlaceOfBirthAddressID == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalAddress1 : this.filter.PlaceOfBirthAddressID == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativeAddress1 : this.filter.PlaceOfBirthAddressID == 3 ? this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthAddress1 : this.filter.PlaceOfBirthAddressID == 4 ? this.RegistrationDetail.AddressTab.EmergencyContact[0].ContactAddress1 : null;
      this.RegistrationDetail.AddressTab.PlaceofBirth[index].PlaceOfBirthAddress2 = this.filter.PlaceOfBirthAddressID == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalAddress2 : this.filter.PlaceOfBirthAddressID == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativeAddress2 : this.filter.PlaceOfBirthAddressID == 3 ? this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthAddress2 : this.filter.PlaceOfBirthAddressID == 4 ? this.RegistrationDetail.AddressTab.EmergencyContact[0].ContactAddress2 : null;
      this.RegistrationDetail.AddressTab.PlaceofBirth[index].PlaceOfBirthCity = this.filter.PlaceOfBirthAddressID == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalCity : this.filter.PlaceOfBirthAddressID == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativeCity : this.filter.PlaceOfBirthAddressID == 3 ? this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthCity : this.filter.PlaceOfBirthAddressID == 4 ? this.RegistrationDetail.AddressTab.EmergencyContact[0].ContactCity : null;
      this.RegistrationDetail.AddressTab.PlaceofBirth[index].PlaceOfBirthStateId = this.filter.PlaceOfBirthAddressID == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalStateId : this.filter.PlaceOfBirthAddressID == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativeStateId : this.filter.PlaceOfBirthAddressID == 3 ? this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthStateId : this.filter.PlaceOfBirthAddressID == 4 ? this.RegistrationDetail.AddressTab.EmergencyContact[0].StateId : null;
      this.ComboLoad('District', 'PlaceofBirthDistrict', index);
      this.RegistrationDetail.AddressTab.PlaceofBirth[index].PlaceOfBirthDistrictId = this.filter.PlaceOfBirthAddressID == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalDistrictId : this.filter.PlaceOfBirthAddressID == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativeDistrictId : this.filter.PlaceOfBirthAddressID == 3 ? this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthDistrictId : this.filter.PlaceOfBirthAddressID == 4 ? this.RegistrationDetail.AddressTab.EmergencyContact[0].DistrictId : null;
      this.ComboLoad('Taluka', 'PlaceofBirthTaluka', index);
      this.RegistrationDetail.AddressTab.PlaceofBirth[index].PlaceOfBirthTalukaTehsilId = this.filter.PlaceOfBirthAddressID == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalTalukaTehsilId : this.filter.PlaceOfBirthAddressID == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativeTalukaTehsilId : this.filter.PlaceOfBirthAddressID == 3 ? this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthTalukaTehsilId : this.filter.PlaceOfBirthAddressID == 4 ? this.RegistrationDetail.AddressTab.EmergencyContact[0].TalukaTehsilId : null;
      this.RegistrationDetail.AddressTab.PlaceofBirth[index].PlaceOfBirthPincode = this.filter.PlaceOfBirthAddressID == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalPincode : this.filter.PlaceOfBirthAddressID == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativePincode : this.filter.PlaceOfBirthAddressID == 3 ? this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthPincode : this.filter.PlaceOfBirthAddressID == 4 ? this.RegistrationDetail.AddressTab.EmergencyContact[0].Pincode : null;
    } else if (type == 'EmergencyContact') {
      this.RegistrationDetail.AddressTab.EmergencyContact[index].ContactAddress1 = this.filter.EmergencyContactAddressID == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalAddress1 : this.filter.EmergencyContactAddressID == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativeAddress1 : this.filter.EmergencyContactAddressID == 3 ? this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthAddress1 : this.filter.EmergencyContactAddressID == 4 ? this.RegistrationDetail.AddressTab.EmergencyContact[0].ContactAddress1 : null;
      this.RegistrationDetail.AddressTab.EmergencyContact[index].ContactAddress2 = this.filter.EmergencyContactAddressID == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalAddress2 : this.filter.EmergencyContactAddressID == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativeAddress2 : this.filter.EmergencyContactAddressID == 3 ? this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthAddress2 : this.filter.EmergencyContactAddressID == 4 ? this.RegistrationDetail.AddressTab.EmergencyContact[0].ContactAddress2 : null;
      this.RegistrationDetail.AddressTab.EmergencyContact[index].ContactCity = this.filter.EmergencyContactAddressID == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalCity : this.filter.EmergencyContactAddressID == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativeCity : this.filter.EmergencyContactAddressID == 3 ? this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthCity : this.filter.EmergencyContactAddressID == 4 ? this.RegistrationDetail.AddressTab.EmergencyContact[0].ContactCity : null;
      this.RegistrationDetail.AddressTab.EmergencyContact[index].StateId = this.filter.EmergencyContactAddressID == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalStateId : this.filter.EmergencyContactAddressID == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativeStateId : this.filter.EmergencyContactAddressID == 3 ? this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthStateId : this.filter.EmergencyContactAddressID == 4 ? this.RegistrationDetail.AddressTab.EmergencyContact[0].StateId : null;
      this.ComboLoad('District', 'EmergencyContactDistrict', index);
      this.RegistrationDetail.AddressTab.EmergencyContact[index].DistrictId = this.filter.EmergencyContactAddressID == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalDistrictId : this.filter.EmergencyContactAddressID == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativeDistrictId : this.filter.EmergencyContactAddressID == 3 ? this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthDistrictId : this.filter.EmergencyContactAddressID == 4 ? this.RegistrationDetail.AddressTab.EmergencyContact[0].DistrictId : null;
      this.ComboLoad('Taluka', 'EmergencyContactTaluka', index);
      this.RegistrationDetail.AddressTab.EmergencyContact[index].TalukaTehsilId = this.filter.EmergencyContactAddressID == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalTalukaTehsilId : this.filter.EmergencyContactAddressID == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativeTalukaTehsilId : this.filter.EmergencyContactAddressID == 3 ? this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthTalukaTehsilId : this.filter.EmergencyContactAddressID == 4 ? this.RegistrationDetail.AddressTab.EmergencyContact[0].TalukaTehsilId : null;
      this.RegistrationDetail.AddressTab.EmergencyContact[index].Pincode = this.filter.EmergencyContactAddressID == 1 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalPincode : this.filter.EmergencyContactAddressID == 2 ? this.RegistrationDetail.AddressTab.NativeAddress[0].NativePincode : this.filter.EmergencyContactAddressID == 3 ? this.RegistrationDetail.AddressTab.PlaceofBirth[0].PlaceOfBirthPincode : this.filter.EmergencyContactAddressID == 4 ? this.RegistrationDetail.AddressTab.EmergencyContact[0].Pincode : null;
    }
  }

  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    this.isDisabled = true;
    this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, 'EmpMasterId': this.RegistrationDetail.employeeInfo.EmpMasterId, IsDraft: this.filter.IsDraft }).subscribe({
      next: (response) => {
        if (SelectType == 'PreJoiningDate') {
          //comment as confirm with rahul and ankur sir (21-Jan-2025)
          // if (this.common.CompanyParameterValue.RestrictFutureDateEntry) {
          //   this.PostJoiningDate = this.dateFormat.parse(response.Table[0].FutureJoiningDate);
          // }
          // if (this.common.CompanyParameterValue.RestrictFutureDateEntryBack) {
          //   this.PreJoiningDate = this.dateFormat.parse(response.Table[0].PreJoiningDate);
          // }

          //new changes confirm with rahul and ankur sir (21-Jan-2025)
          // if (this.common.CompanyParameterValue.RestrictFutureDateEntry && this.common.ToLowerCase(this.RegistrationDetail.employeeInfo.EmpType) == 'front') {
          //   this.PostJoiningDate = this.dateFormat.parse(response.Table[0].FutureJoiningDate);
          // }
          // if (this.common.CompanyParameterValue.RestrictFutureDateEntryBack && this.RegistrationDetail.BasicInformation.IsTempEmployee) {
          //   this.PostJoiningDate = this.dateFormat.parse(response.Table[0].FutureJoiningDateBack);
          // }
          //new changes confirm with rahul (19-April-2025)
          if (this.common.CompanyParameterValue.RestrictFutureDateEntry && this.RegistrationDetail.BasicInformation.IsTempEmployee && this.common.ToLowerCase(this.RegistrationDetail.employeeInfo.EmpType) == 'front') {
            this.PostJoiningDate = this.dateFormat.parse(response.Table[0].FutureJoiningDate);
          }
          if (this.common.CompanyParameterValue.RestrictFutureDateEntryBack && this.RegistrationDetail.BasicInformation.IsTempEmployee && this.common.ToLowerCase(this.RegistrationDetail.employeeInfo.EmpType) == 'back') {
            this.PostJoiningDate = this.dateFormat.parse(response.Table[0].FutureJoiningDateBack);
          }
          if (this.RegistrationDetail.BasicInformation.IsTempEmployee) {
            this.PreJoiningDate = this.dateFormat.parse(response.Table[0].PreJoiningDate);
          }
        } else if (SelectType == 'RegistrationDate') {
          this.ToDayDate = this.dateFormat.parse(response.Table[0].RegistrationDate);
          this.maxBirthdate = this.dateFormat.parse(response.Table[0].RegistrationDate);
          this.RegistrationDetail.BasicInformation.RegistrationDate = this.dateFormat.parse(response.Table[0].RegistrationDate);
          this.currentYear = this.ToDayDate.year
        }
        // else if (SelectType == 'ProbationDate') {
        //   if (response.Table) {
        //     this.MinProbationDate = this.dateFormat.parse(response.Table[0].ProbationDate);
        //     this.RegistrationDetail.BasicInformation.ProbationDate = this.dateFormat.parse(response.Table[0].ProbationDate);
        //   }
        // }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  BirthDateChange(event: any) {
    // this.RegistrationDetail.BasicInformation.Age = 
    // Math.floor((Date.UTC(this.ToDayDate.year, this.ToDayDate.month, this.ToDayDate.day) - 
    // Date.UTC(this.RegistrationDetail.BasicInformation.BirthDate.year, this.RegistrationDetail.BasicInformation.BirthDate.month, this.RegistrationDetail.BasicInformation.BirthDate.day)) / (1000 * 60 * 60 * 24) / 365);

    const today = new Date();
    const birthDate = new Date(
      this.RegistrationDetail.BasicInformation.BirthDate.year,
      this.RegistrationDetail.BasicInformation.BirthDate.month - 1,
      this.RegistrationDetail.BasicInformation.BirthDate.day
    );

    let age = today.getFullYear() - birthDate.getFullYear();

    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }

    this.RegistrationDetail.BasicInformation.Age = age;
    
    this.RegistrationDetail.BasicInformation.RetirementDate = {
      day: this.RegistrationDetail.BasicInformation.BirthDate.day,
      month: this.RegistrationDetail.BasicInformation.BirthDate.month,
      year: this.RegistrationDetail.BasicInformation.BirthDate.year
    };

    this.RegistrationDetail.BasicInformation.RetirementDate = moment(this.dateFormat.format(this.RegistrationDetail.BasicInformation.RetirementDate));
    this.RegistrationDetail.BasicInformation.RetirementDate = moment(this.RegistrationDetail.BasicInformation.RetirementDate.add({ year: this.common.CompanyParameterValue.RetirementAge }));
    this.RegistrationDetail.BasicInformation.RetirementDate = this.dateFormat.parse(this.RegistrationDetail.BasicInformation.RetirementDate.format("DD MMM YYYY"))

    this.minQulificationYear = this.RegistrationDetail.BasicInformation.BirthDate.year;
    this.MinDrivingLicenceDate = {
      day: this.RegistrationDetail.BasicInformation.BirthDate.day,
      month: this.RegistrationDetail.BasicInformation.BirthDate.month,
      year: this.RegistrationDetail.BasicInformation.BirthDate.year
    };
    this.MinDrivingLicenceDate.year = this.MinDrivingLicenceDate.year + this.common.CompanyParameterValue.WorkAge;

    if (this.RegistrationDetail.BasicInformation.Age >= this.common.CompanyParameterValue.RetirementAge) {
      this.filter.IsPensionDeductionChangeAllow = false;
      //this.RegistrationDetail.BasicInformation.PensionDeduction = structuredClone(this.filter.PensionDeductionDefault);
    } else {
      this.filter.IsPensionDeductionChangeAllow = true;
    }
  }

  SpouseBirthDateChange(event: any) {
    this.RegistrationDetail.AdditionalInformation.SpouseAge = Math.floor((Date.UTC(this.ToDayDate.year, this.ToDayDate.month, this.ToDayDate.day) - Date.UTC(this.RegistrationDetail.AdditionalInformation.SpouseBirthDate.year, this.RegistrationDetail.AdditionalInformation.SpouseBirthDate.month, this.RegistrationDetail.AdditionalInformation.SpouseBirthDate.day)) / (1000 * 60 * 60 * 24) / 365);
  }

  aadhaarKyc() {
    if (this.VerificationStatus.AADHAARCardVerificationEnabled) {
      const modalRef = this.modalService.open(AadhaarKYCComponent, { size: 'lg', backdrop: 'static', });
      modalRef.componentInstance.EmpMasterId = this.RegistrationDetail.employeeInfo.EmpMasterId;
      modalRef.componentInstance.EmpType = this.RegistrationDetail.employeeInfo.EmpType;
      modalRef.componentInstance.AadhaarNo = this.RegistrationDetail.Verification.AadharNo;
      modalRef.result.then(result => {
        if (result != null && result != undefined) {

          //this.RegistrationDetail.Verification.AadharrequestId = result.AadharrequestId;
          this.RegistrationDetail.Verification.AADHAARVerificationID = result.AADHAARVerificationID;
          this.RegistrationDetail.Verification.AadharVerificationStatus = result.AadharVerificationStatus;
          this.filter.aadharsaveflag = true;
          this.RegistrationDetail.Verification.AadharNoKyc = result.AadharNoKyc;
          this.RegistrationDetail.Verification.AadharNo = result.AadhaarNo;
          this.RegistrationDetail.Verification.NameAsPerAadhaar = result.NameAsPerAadhaar;
          this.RegistrationDetail.Verification.BirthDate = result.BirthDate;
          this.RegistrationDetail.Verification.Gender = result.Gender;
          this.RegistrationDetail.Verification.photo = result.photo;
          this.RegistrationDetail.Verification.LocalAddress1 = result.LocalAddress1;
          this.RegistrationDetail.Verification.LocalAddress2 = result.LocalAddress2;
          this.RegistrationDetail.Verification.AskReplaceAddress = true;

          this.UploadServices(this.common.CompanyParameterValue.PhotoFolder, this.RegistrationDetail.Verification.photo, 'aadharphoto')
        }
      });
    } else {
      const modalRef = this.modalService.open(AlertWarningComponent, {
        size: 'md',
        backdrop: 'static',
        centered: true,
        windowClass: 'confirmation-modal'
      });
      modalRef.componentInstance.Message = "Aadhaar verification not enabled. please contact your administrator.";
      modalRef.result.then((result: any) => { });
    }
  }

  panKyc() {
    if (this.VerificationStatus.PANCardVerificationEnabled) {
      const modalRef = this.modalService.open(PanKYCComponent, { backdrop: 'static', });
      modalRef.componentInstance.EmpMasterId = this.RegistrationDetail.employeeInfo.EmpMasterId;
      modalRef.componentInstance.EmpType = this.RegistrationDetail.employeeInfo.EmpType;
      modalRef.componentInstance.PANNo = this.RegistrationDetail.Verification.PANNo;
      modalRef.result.then(result => {
        if (result != null && result != undefined) {
          this.RegistrationDetail.Verification.PANVerificationID = result.PANVerificationID;
          this.RegistrationDetail.Verification.PANVerificationStatus = result.PANVerificationStatus;
          this.RegistrationDetail.Verification.PANNo = result.PANNo;
          this.RegistrationDetail.Verification.NameAsPerPAN = result.NameAsPerPAN;
        }
      });
    } else {
      const modalRef = this.modalService.open(AlertWarningComponent, {
        size: 'md',
        backdrop: 'static',
        centered: true,
        windowClass: 'confirmation-modal'
      });
      modalRef.componentInstance.Message = "Pan verification not enabled. please contact your administrator.";
      modalRef.result.then((result: any) => { });
    }
  }

  bankKyc() {
    if (this.VerificationStatus.BankDetailsVerificationEnabled) {
      const modalRef = this.modalService.open(BankKYCComponent, { backdrop: 'static', });
      modalRef.componentInstance.EmpMasterId = this.RegistrationDetail.employeeInfo.EmpMasterId;
      modalRef.componentInstance.EmpType = this.RegistrationDetail.employeeInfo.EmpType;
      modalRef.result.then(result => {
        if (result != null && result != undefined) {
          this.RegistrationDetail.Verification.BankId = result.BankId;
          this.RegistrationDetail.Verification.BankName = result.BankName;
          this.RegistrationDetail.Verification.BankAccountNo = result.BankAccountNo;
          this.RegistrationDetail.Verification.IFSCode = result.IFSCode;
          this.RegistrationDetail.Verification.NameAsPerBank = result.NameAsPerBank;
          this.RegistrationDetail.Verification.BankVerificationID = result.BankVerificationID;
          this.RegistrationDetail.Verification.BankVerificationStatus = result.BankVerificationStatus;
        }
      });
    } else {
      const modalRef = this.modalService.open(AlertWarningComponent, {
        size: 'md',
        backdrop: 'static',
        centered: true,
        windowClass: 'confirmation-modal'
      });
      modalRef.componentInstance.Message = "Bank verification not enabled. please contact your administrator.";
      modalRef.result.then((result: any) => { });
    }
  }

  AddImageDocument() {
    if (this.RegistrationDetail.ImageDocumnetTab.EmpDocumentAttachment.findIndex((e: any) => e.DocumentMasterId == this.filter.ImageDocumentID) == -1) {
      this.RegistrationDetail.ImageDocumnetTab.EmpDocumentAttachment.push(
        {
          DocumentMasterId: this.Documents.filter((e: any) => e.DocumentMasterID == this.filter.ImageDocumentID)[0]["DocumentMasterID"],
          DocumentName: this.Documents.filter((e: any) => e.DocumentMasterID == this.filter.ImageDocumentID)[0]["DocumentName"],
          DocumentNo: null,
          Attachment: null,
          Attachmenturl: null,
          Document: this.Documents.filter((e: any) => e.DocumentMasterID == this.filter.ImageDocumentID)[0]["Document"],
          IssueDate: null,
          ExpiryDate: null,
          IssueExpiryDateRequired: this.Documents.filter((e: any) => e.DocumentMasterID == this.filter.ImageDocumentID)[0]["IssueExpiryDateRequired"],
          Compulsory: this.Documents.filter((e: any) => e.DocumentMasterID == this.filter.ImageDocumentID)[0]["Compulsory"],
        }
      );
    } else {
      this.toast.show({ message: 'Document already exist', type: toastTypeEnum.warning })
    }
  }

  CheckMandateDocument() {
    this.Documents.filter((e: any) => e.Compulsory == 1 && e.FixedDocumentMasterId == 0).forEach((element: any) => {
      if (this.RegistrationDetail.ImageDocumnetTab.EmpDocumentAttachment.findIndex((e: any) => parseInt(e.DocumentMasterId) == parseInt(element.DocumentMasterID)) == -1) {
        this.RegistrationDetail.ImageDocumnetTab.EmpDocumentAttachment.push(
          {
            DocumentMasterId: element.DocumentMasterID,
            DocumentName: element.DocumentName,
            DocumentNo: null,
            Attachment: null,
            Attachmenturl: null,
            Document: element.DocumentName.Document,
            IssueDate: null,
            ExpiryDate: null,
            IssueExpiryDateRequired: element.IssueExpiryDateRequired,
            Compulsory: element.Compulsory,
          }
        );
      }
    });
  }

  async SaveVerificationInformationDetail() {
    if (!this.user.IsPreOnBoarding) {
      await this.common.getPageRights();
    }

    if (this.VerificationStatus.CompulsoryAADHAARKYCVerification && (this.RegistrationDetail.Verification.AADHAARVerificationID == 0 || this.RegistrationDetail.Verification.AADHAARVerificationID == null || this.RegistrationDetail.Verification.AADHAARVerificationID == '')) {
      this.toast.show({ message: 'Please verify aadhar card.', type: toastTypeEnum.warning });
    } else if (this.VerificationStatus.CompulsoryPANVerification && (this.RegistrationDetail.Verification.PANVerificationID == 0 || this.RegistrationDetail.Verification.PANVerificationID == null || this.RegistrationDetail.Verification.PANVerificationID == '')) {
      this.toast.show({ message: 'Please verify pan card.', type: toastTypeEnum.warning });
    } else if (this.VerificationStatus.CompulsoryBANKVerification && (this.RegistrationDetail.Verification.BankVerificationID == 0 || this.RegistrationDetail.Verification.BankVerificationID == null || this.RegistrationDetail.Verification.BankVerificationID == '')) {
      this.toast.show({ message: 'Please verify bank account.', type: toastTypeEnum.warning });
    }
    // else if (this.VerificationStatus.CompulsoryAADHAARKYCVerification && this.CheckCompulsoryField(0, 'AadharAttachment', 'Tab1') && this.RegistrationDetail.Verification.AadharAttachment == null) {
    //   this.toast.show({ message: 'Upload aadhar attachment', type: toastTypeEnum.warning });
    // }
    else if (this.RegistrationDetail.Verification.AADHAARVerificationID > 0 && (this.RegistrationDetail.Verification.AadharAttachment == null || this.RegistrationDetail.Verification.AadharAttachment == '')) {
      this.toast.show({ message: 'Upload aadhar attachment', type: toastTypeEnum.warning });
    }
    // else if (this.VerificationStatus.CompulsoryPANVerification && this.CheckCompulsoryField(0, 'PANAttachment', 'Tab1') && this.RegistrationDetail.Verification.PANAttachment == null) {
    //   this.toast.show({ message: 'Upload pan attachment', type: toastTypeEnum.warning });
    // } 
    else if (this.RegistrationDetail.Verification.PANVerificationID > 0 && this.RegistrationDetail.Verification.PANAttachment == null) {
      this.toast.show({ message: 'Upload pan attachment', type: toastTypeEnum.warning });
    }
    else if (this.VerificationStatus.CompulsoryBANKVerification && this.CheckCompulsoryField(0, 'BankAttachment', 'Tab1') && (this.RegistrationDetail.Verification.BankAttachment == null || this.RegistrationDetail.Verification.BankAttachment == '')) {
      this.toast.show({ message: 'Upload bank attachment', type: toastTypeEnum.warning });
    } else if (this.VerificationStatus.CompulsoryMobileVerification && this.common.ToLowerCase(this.RegistrationDetail.Verification.MobileVerificationStatus) != 'verified') {
      this.toast.show({ message: 'Please verify mobile no.', type: toastTypeEnum.warning });
    } else if (this.VerificationStatus.CompulsoryEmailVerification && this.common.ToLowerCase(this.RegistrationDetail.Verification.EmailVerificationStatus) != 'verified') {
      this.toast.show({ message: 'Please verify email id.', type: toastTypeEnum.warning });
    } else {
      if (this.common.PageRight.IsEdit) {

        if (this.RegistrationDetail.Verification.AskReplaceAddress && (this.RegistrationDetail.AddressTab.LocalAddress[0].LocalAddress1 == null || this.RegistrationDetail.AddressTab.LocalAddress[0].LocalAddress1 == '')) {
          this.RegistrationDetail.Verification.AskReplaceAddress = false;
          this.RegistrationDetail.Verification.ReplaceAddress = true;
        }

        if (this.RegistrationDetail.Verification.AskReplaceAddress) {
          const modalRef = this.modalService.open(ConfirmationComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = 'Do you want to replace local address with aadhaar address?';
          modalRef.componentInstance.Button1 = 'YES';
          modalRef.componentInstance.Button2 = 'NO';
          modalRef.result.then((result: any) => {
            this.RegistrationDetail.Verification.AskReplaceAddress = false;
            if (result) {
              this.RegistrationDetail.Verification.ReplaceAddress = true;
            } else { this.RegistrationDetail.Verification.ReplaceAddress = false; }
            this.SaveVarificationData()
          });

        } else {
          this.SaveVarificationData()
        }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    }
  }

  async SaveVarificationData() {
    if (true) {
      this.isDisabled = true;
      if (true || this.RegistrationDetail.Verification.AADHAARVerificationID > 0 ||
        this.RegistrationDetail.Verification.PANVerificationID > 0 ||
        this.RegistrationDetail.Verification.BankVerificationID > 0 ||
        this.common.ToLowerCase(this.RegistrationDetail.Verification.EmailVerificationStatus) == 'verified' ||
        this.common.ToLowerCase(this.RegistrationDetail.Verification.MobileVerificationStatus) == 'verified') {
        this.isDisabled = true;
        if (this.RegistrationDetail.Verification.AADHAARVerificationID == 0) {
          this.RegistrationDetail.Verification.AADHAARVerificationID = 0;
          this.RegistrationDetail.Verification.AadharVerificationStatus = 'Not Verified';
          this.RegistrationDetail.Verification.NameAsPerAadhaar = null;
          this.RegistrationDetail.Verification.AadharNo = null;
          this.RegistrationDetail.Verification.AadharNoKyc = null;
          this.RegistrationDetail.Verification.AadharAttachment = null;
          this.RegistrationDetail.Verification.AadharAttachmenturl = null;
          this.RegistrationDetail.Verification.Gender = null;
          this.RegistrationDetail.Verification.LocalAddress1 = null;
          this.RegistrationDetail.Verification.LocalAddress2 = null;
          this.RegistrationDetail.Verification.BirthDate = null;
          this.RegistrationDetail.Verification.photo = null;
          this.RegistrationDetail.Verification.photourl = null;
        }

        if (this.RegistrationDetail.Verification.PANVerificationID == 0) {
          this.RegistrationDetail.Verification.PANVerificationID = 0;
          this.RegistrationDetail.Verification.PANVerificationStatus = 'Not Verified';
          this.RegistrationDetail.Verification.NameAsPerPAN = null;
          this.RegistrationDetail.Verification.PANNo = null;
          this.RegistrationDetail.Verification.PANAttachment = null;
          this.RegistrationDetail.Verification.PANAttachmenturl = null;
        }

        if (this.RegistrationDetail.Verification.BankVerificationID == 0) {
          this.RegistrationDetail.Verification.BankVerificationID = 0;
          this.RegistrationDetail.Verification.BankVerificationStatus = 'Not Verified';
          this.RegistrationDetail.Verification.BankId = null;
          this.RegistrationDetail.Verification.BankAccountNo = null;
          this.RegistrationDetail.Verification.IFSCode = null;
          this.RegistrationDetail.Verification.NameAsPerBank = null;
          this.RegistrationDetail.Verification.BankAttachment = null;
          this.RegistrationDetail.Verification.BankAttachmenturl = null;
        }
        this.RegistrationDetail.Verification.PaymentMode = this.RegistrationDetail.Verification.BankVerificationID > 0 ? 3 : 2;

        if (this.filter.aadharsaveflag) {
          if (this.RegistrationDetail.Verification.BirthDate.includes("/")) {
            this.RegistrationDetail.Verification.BirthDate = this.RegistrationDetail.Verification.BirthDate.split("/")[1] + '/' + this.RegistrationDetail.Verification.BirthDate.split("/")[0] + '/' + this.RegistrationDetail.Verification.BirthDate.split("/")[2]
          } else if (this.RegistrationDetail.Verification.BirthDate.includes("-")) {
            this.RegistrationDetail.Verification.BirthDate = this.RegistrationDetail.Verification.BirthDate.split("-")[1] + '/' + this.RegistrationDetail.Verification.BirthDate.split("-")[0] + '/' + this.RegistrationDetail.Verification.BirthDate.split("-")[2]
          }
        }

        this.employeeRegistration.TabWise(this.RegistrationDetail.Verification).subscribe({
          next: (response) => {
            if (response.Error_Code == '351') {
              if (this.RegistrationDetail.Verification.photo != null && this.RegistrationDetail.Verification.photo != '' &&
                (this.RegistrationDetail.BasicInformation.photo == null || this.RegistrationDetail.BasicInformation.photo == '')
              ) {
                this.RegistrationDetail.BasicInformation.photo = this.RegistrationDetail.Verification.photo;
                this.RegistrationDetail.BasicInformation.photourl = this.RegistrationDetail.Verification.photourl;
              }

              this.RegistrationDetail.BasicInformation.NameAsPerAadhar = this.common.ToUpperCase(this.RegistrationDetail.Verification.NameAsPerAadhaar);
              if (this.RegistrationDetail.BasicInformation.firstName == null || this.RegistrationDetail.BasicInformation.firstName == "") {
                this.RegistrationDetail.BasicInformation.firstName = this.common.ToUpperCase(this.RegistrationDetail.Verification.NameAsPerAadhaar);
              }
              if (this.RegistrationDetail.BasicInformation.EmpName == null || this.RegistrationDetail.BasicInformation.EmpName == "") {
                this.RegistrationDetail.BasicInformation.EmpName = this.common.ToUpperCase(this.RegistrationDetail.Verification.NameAsPerAadhaar);
              }

              if ((this.RegistrationDetail.BasicInformation.BirthDate == null || this.RegistrationDetail.BasicInformation.BirthDate == '') && (this.RegistrationDetail.Verification.BirthDate != null && this.RegistrationDetail.Verification.BirthDate != '')) {
                this.RegistrationDetail.BasicInformation.BirthDate = this.dateFormat.parse(moment(this.RegistrationDetail.Verification.BirthDate).format('DD MMM YYYY'));
                this.BirthDateChange(null);
              }

              if (this.RegistrationDetail.BasicInformation.GenderId == null || this.RegistrationDetail.BasicInformation.GenderId == '' || this.RegistrationDetail.BasicInformation.GenderId == 0) {
                if (this.Genders.length > 0 && this.RegistrationDetail.Verification.Gender != null && this.RegistrationDetail.Verification.Gender != '') {
                  this.RegistrationDetail.BasicInformation.GenderId = this.Genders.filter((e: any) =>
                    (this.common.ToLowerCase(e.GenderName) == 'male' && this.common.ToLowerCase(this.RegistrationDetail.Verification.Gender) == 'm') ||
                    (this.common.ToLowerCase(e.GenderName) == 'female' && this.common.ToLowerCase(this.RegistrationDetail.Verification.Gender) == 'f') ||
                    (this.common.ToLowerCase(e.GenderName) == 'other' && this.common.ToLowerCase(this.RegistrationDetail.Verification.Gender) != 'm' && this.common.ToLowerCase(this.RegistrationDetail.Verification.Gender) != 'f'))[0].GenderMasterID
                }
              }

              if (this.RegistrationDetail.Verification.EmailId != null && this.RegistrationDetail.Verification.EmailId != "") {
                this.RegistrationDetail.BasicInformation.PersonalEmail = this.RegistrationDetail.Verification.EmailId;
              }

              if (this.RegistrationDetail.Verification.MobileNo != null && this.RegistrationDetail.Verification.MobileNo != "") {
                this.RegistrationDetail.BasicInformation.ContactNo1 = this.RegistrationDetail.Verification.MobileNo;
                this.RegistrationDetail.employeeInfo.MobileNo = this.RegistrationDetail.Verification.MobileNo;
              }

              if (this.RegistrationDetail.Verification.ReplaceAddress) {
                this.RegistrationDetail.AddressTab.LocalAddress[0].LocalAddress1 = this.common.ToUpperCase(this.RegistrationDetail.Verification.LocalAddress1);
                this.RegistrationDetail.AddressTab.LocalAddress[0].LocalAddress2 = this.common.ToUpperCase(this.RegistrationDetail.Verification.LocalAddress2);
              }

              if (this.RegistrationDetail.Verification.AADHAARVerificationID > 0) {
                this.RegistrationDetail.AccountLicencesTab.AadhaarNo = this.RegistrationDetail.Verification.AadharNo;
                this.RegistrationDetail.AccountLicencesTab.AadharAttachment = this.RegistrationDetail.Verification.AadharAttachment;
                this.RegistrationDetail.AccountLicencesTab.AadharAttachmenturl = this.RegistrationDetail.Verification.AadharAttachmenturl;

                this.RegistrationDetail.ImageDocumnetTab.Photo = this.RegistrationDetail.Verification.photo;
                this.RegistrationDetail.ImageDocumnetTab.Photourl = this.RegistrationDetail.Verification.photourl;
              }
              this.RegistrationDetail.AccountLicencesTab.AadharVerificationStatus = this.RegistrationDetail.Verification.AadharVerificationStatus;

              if (this.RegistrationDetail.Verification.BankVerificationID > 0) {
                this.RegistrationDetail.AccountLicencesTab.PaymentMode = this.RegistrationDetail.Verification.PaymentMode;
                this.RegistrationDetail.AccountLicencesTab.BankId = this.RegistrationDetail.Verification.BankId;
                this.RegistrationDetail.AccountLicencesTab.BankName = this.RegistrationDetail.Verification.BankName;
                this.RegistrationDetail.AccountLicencesTab.IFSCode = this.RegistrationDetail.Verification.IFSCode;
                this.RegistrationDetail.AccountLicencesTab.Accountno = this.RegistrationDetail.Verification.BankAccountNo;
                this.RegistrationDetail.AccountLicencesTab.AccountnoStar = this.RegistrationDetail.Verification.BankAccountNo;
                this.RegistrationDetail.AccountLicencesTab.NameAsPerBank = this.RegistrationDetail.Verification.NameAsPerBank;
                this.RegistrationDetail.AccountLicencesTab.BankAttachment = this.RegistrationDetail.Verification.BankAttachment;
                this.RegistrationDetail.AccountLicencesTab.BankAttachmenturl = this.RegistrationDetail.Verification.BankAttachmenturl;
              }
              this.RegistrationDetail.AccountLicencesTab.BankVerificationStatus = this.RegistrationDetail.Verification.BankVerificationStatus;

              if (this.RegistrationDetail.Verification.PANVerificationID > 0) {
                this.RegistrationDetail.AccountLicencesTab.PANNo = this.RegistrationDetail.Verification.PANNo;
                this.RegistrationDetail.AccountLicencesTab.PANAttachment = this.RegistrationDetail.Verification.PANAttachment;
                this.RegistrationDetail.AccountLicencesTab.PANAttachmenturl = this.RegistrationDetail.Verification.PANAttachmenturl;
              }
              this.RegistrationDetail.AccountLicencesTab.PANVerificationStatus = this.RegistrationDetail.Verification.PANVerificationStatus;
              if (this.RegistrationDetail.employeeInfo.EmpType.toLowerCase() === 'front') {
                if (this.user.CompanyCode === 'MSF' || this.user.CompanyCode === 'MFM') {
                  this.employeeRegistration.EmpRegSelectGetData({ 'RegistrationType': '', 'SelectType': 'EmpApproval', 'EmpMasterId': this.RegistrationDetail.employeeInfo.EmpMasterId, 'IsDraft': this.filter.IsDraft }).subscribe({
                    next: async (responsecheck) => {
                      if (responsecheck.Table.length > 0) {
                        this.EmpCodeForFRONT = responsecheck.Table[0].EmpCode;
                        if (!this.common.CompanyParameterValue.DefaultAPIIntegration && !this.common.CompanyParameterValue.ZingHRAPIIntegration && !this.common.CompanyParameterValue.ProptorAPIIntegration) {

                        }
                        else {
                          if (responsecheck.Table[0].EmpCode !== '' && responsecheck.Table[0].ApprovalStatus.toLowerCase() === 'approved') {
                            await this.Transovative(this.EmpCodeForFRONT, 'edit');
                          }
                        }
                      }
                      this.isDisabledG = false;
                    },
                    complete: () => {

                    },
                    error: (error) => {
                      this.isDisabledG = false;
                    },
                  });
                }
              }
              this.toast.show({ message: response.Error_Message, type: toastTypeEnum.success });
              this.activeTab = 'BasicInformation';
            } else {
              this.toast.show({ message: response.Error_Message, type: toastTypeEnum.danger });
            }
            this.isDisabled = false;
          },
          complete: () => {
            if (this.filter.aadharsaveflag) {
              this.RegistrationDetail.Verification.BirthDate = this.RegistrationDetail.Verification.BirthDate.split("/")[1] + '/' + this.RegistrationDetail.Verification.BirthDate.split("/")[0] + '/' + this.RegistrationDetail.Verification.BirthDate.split("/")[2]
            }
          },
          error: (error) => {
            this.isDisabled = false;
          },
        });
      } else {
        this.isDisabled = false;
        this.activeTab = 'BasicInformation';
      }
    }
  }

  async SaveBasicInformationDetail() {
    if (!this.user.IsPreOnBoarding) {
      await this.common.getPageRights();
    }
    if (this.CheckCompulsoryField(0, 'photo', 'Tab2') && this.RegistrationDetail.BasicInformation.photo == null) {
      this.toast.show({ message: 'Upload photo', type: toastTypeEnum.warning });
    } else if ((this.RegistrationDetail.BasicInformation.BirthDate != null || this.RegistrationDetail.BasicInformation.BirthDate != '') && this.RegistrationDetail.BasicInformation.Age < this.common.CompanyParameterValue.WorkAge) {
      this.toast.show({ message: 'Minmum Age ' + this.common.CompanyParameterValue.WorkAge, type: toastTypeEnum.warning });
    } else if (this.RegistrationDetail.BasicInformation.ContactNo2 != null && this.RegistrationDetail.BasicInformation.ContactNo2 != '' && this.RegistrationDetail.BasicInformation.ContactNo2 == this.RegistrationDetail.employeeInfo.MobileNo) {
      this.toast.show({ message: 'Contact 1 and Contact 2 cannot be same', type: toastTypeEnum.warning });
    } else if (this.RegistrationDetail.BasicInformation.OfficialEmail != null && this.RegistrationDetail.BasicInformation.OfficialEmail != '' && this.common.ToLowerCase(this.RegistrationDetail.BasicInformation.OfficialEmail) == this.common.ToLowerCase(this.RegistrationDetail.BasicInformation.PersonalEmail)) {
      this.toast.show({ message: 'OfficialEmail and PersonalEmail cannot be same', type: toastTypeEnum.warning });
    } else if (this.RegistrationDetail.BasicInformation.ReportingManagerId1 != null && this.RegistrationDetail.BasicInformation.ReportingManagerId2 != null && this.RegistrationDetail.BasicInformation.ReportingManagerId1 == this.RegistrationDetail.BasicInformation.ReportingManagerId2 && !this.user.IsPreOnBoarding) {
      this.toast.show({ message: 'Reporting Manager 1 and Reporting Manager 2 cannot be same', type: toastTypeEnum.warning });
    } else if (this.RegistrationDetail.BasicInformation.DesignationId != null && this.RegistrationDetail.BasicInformation.DesignationId != ''
      && this.RegistrationDetail.BasicInformation.DesignationId != this.RegistrationDetail.BasicInformation.MainDesignationId
    ) {
      this.toast.show({ message: 'Posting designation missmatch with employee designation', type: toastTypeEnum.warning });
    }
    else {
      if (this.common.PageRight.IsEdit) {
        if (true) {
          this.isDisabled = true;
          if (this.RegistrationDetail.BasicInformation.JoiningDate != "" && this.RegistrationDetail.BasicInformation.JoiningDate != null) {
            this.RegistrationDetail.BasicInformation.JoiningDate = this.dateFormat.format(this.RegistrationDetail.BasicInformation.JoiningDate);
          }
          // if (this.RegistrationDetail.BasicInformation.ProbationDate != "" && this.RegistrationDetail.BasicInformation.ProbationDate != null) {
          //   this.RegistrationDetail.BasicInformation.ProbationDate = this.dateFormat.format(this.RegistrationDetail.BasicInformation.ProbationDate);
          // }
          if (this.RegistrationDetail.BasicInformation.BirthDate != "" && this.RegistrationDetail.BasicInformation.BirthDate != null) {
            this.RegistrationDetail.BasicInformation.BirthDate = this.dateFormat.format(this.RegistrationDetail.BasicInformation.BirthDate);
          }

          if (this.RegistrationDetail.BasicInformation.ContractStartDate != "" && this.RegistrationDetail.BasicInformation.ContractStartDate != null) {
            this.RegistrationDetail.BasicInformation.ContractStartDate = this.dateFormat.format(this.RegistrationDetail.BasicInformation.ContractStartDate);
          }
          if (this.RegistrationDetail.BasicInformation.ContractEndDate != "" && this.RegistrationDetail.BasicInformation.ContractEndDate != null) {
            this.RegistrationDetail.BasicInformation.ContractEndDate = this.dateFormat.format(this.RegistrationDetail.BasicInformation.ContractEndDate);
          }
          if (this.RegistrationDetail.BasicInformation.StatusDate != "" && this.RegistrationDetail.BasicInformation.StatusDate != null) {
            this.RegistrationDetail.BasicInformation.StatusDate = this.dateFormat.format(this.RegistrationDetail.BasicInformation.StatusDate);
          }
          if (this.RegistrationDetail.BasicInformation.RetirementDate != "" && this.RegistrationDetail.BasicInformation.RetirementDate != null) {
            this.RegistrationDetail.BasicInformation.RetirementDate = this.dateFormat.format(this.RegistrationDetail.BasicInformation.RetirementDate);
          }

          if (this.RegistrationDetail.BasicInformation.ReportingManagerId1 != null && this.RegistrationDetail.BasicInformation.ReportingManagerId1 != '' && this.RegistrationDetail.BasicInformation.ReportingManagerId1 != 0 && this.RegistrationDetail.BasicInformation.ReportingManagerId1 != '0') {
            this.RegistrationDetail.BasicInformation.ReportingManager1 = this.ReportingManagers.filter((e: any) => e.UserMasterId == parseInt(this.RegistrationDetail.BasicInformation.ReportingManagerId1))[0].Name;
          }
          if (this.RegistrationDetail.BasicInformation.ReportingManagerId2 != null && this.RegistrationDetail.BasicInformation.ReportingManagerId2 != '' && this.RegistrationDetail.BasicInformation.ReportingManagerId2 != 0 && this.RegistrationDetail.BasicInformation.ReportingManagerId2 != '0') {
            this.RegistrationDetail.BasicInformation.ReportingManager2 = this.ReportingManagers.filter((e: any) => e.UserMasterId == parseInt(this.RegistrationDetail.BasicInformation.ReportingManagerId2))[0].Name;
          }

          if (this.RegistrationDetail.BasicInformation.DesignationId == null || this.RegistrationDetail.BasicInformation.DesignationId == '' || this.RegistrationDetail.BasicInformation.DesignationId == 0) {
            this.RegistrationDetail.BasicInformation.DesignationId = this.RegistrationDetail.BasicInformation.MainDesignationId;
          }

          if (this.RegistrationDetail.BasicInformation.ESS_EmpServiceTypeId == null || this.RegistrationDetail.BasicInformation.ESS_EmpServiceTypeId == '') {
            this.RegistrationDetail.BasicInformation.ESS_EmpServiceTypeId = 0;
          }

          this.employeeRegistration.TabWise(this.RegistrationDetail.BasicInformation).subscribe({
            next: async (response) => {
              if (response.Error_Code == '352') {
                this.RegistrationDetail.ImageDocumnetTab.Photo = this.RegistrationDetail.BasicInformation.photo;
                this.RegistrationDetail.ImageDocumnetTab.Photourl = this.RegistrationDetail.BasicInformation.photourl;
                if (this.RegistrationDetail.employeeInfo.EmpType.toLowerCase() === 'front') {
                  if (this.user.CompanyCode === 'MSF' || this.user.CompanyCode === 'MFM') {
                    this.employeeRegistration.EmpRegSelectGetData({ 'RegistrationType': '', 'SelectType': 'EmpApproval', 'EmpMasterId': this.RegistrationDetail.employeeInfo.EmpMasterId, 'IsDraft': this.filter.IsDraft }).subscribe({
                      next: async (responsecheck) => {
                        if (responsecheck.Table.length > 0) {
                          this.EmpCodeForFRONT = responsecheck.Table[0].EmpCode;
                          if (!this.common.CompanyParameterValue.DefaultAPIIntegration && !this.common.CompanyParameterValue.ZingHRAPIIntegration && !this.common.CompanyParameterValue.ProptorAPIIntegration) {

                          }
                          else {
                            if (responsecheck.Table[0].EmpCode !== '' && responsecheck.Table[0].ApprovalStatus.toLowerCase() === 'approved') {
                              await this.Transovative(this.EmpCodeForFRONT, 'edit');
                            }
                          }
                        }
                        this.isDisabledG = false;
                      },
                      complete: () => {

                      },
                      error: (error) => {
                        this.isDisabledG = false;
                      },
                    });
                  }
                }

                if ((this.RegistrationDetail.BasicInformation.SiteId != null && this.RegistrationDetail.BasicInformation.SiteId != '' && this.RegistrationDetail.BasicInformation.SiteId > 0) && !this.RegistrationDetail.BasicInformation.IsTempEmployee) {
                  this.checkFieldDisableFlag = true;
                } else {
                  this.checkFieldDisableFlag = false;
                }
                this.toast.show({ message: response.Error_Message, type: toastTypeEnum.success });
                this.activeTab = 'AdditionalInformation';
              } else {
                this.toast.show({ message: response.Error_Message, type: toastTypeEnum.warning });
              }
              this.isDisabled = false;
            },
            complete: () => {
              if (this.RegistrationDetail.BasicInformation.JoiningDate != "" && this.RegistrationDetail.BasicInformation.JoiningDate != null) {
                this.RegistrationDetail.BasicInformation.JoiningDate = this.dateFormat.parse(this.RegistrationDetail.BasicInformation.JoiningDate);
              }
              // if (this.RegistrationDetail.BasicInformation.ProbationDate != "" && this.RegistrationDetail.BasicInformation.ProbationDate != null) {
              //   this.RegistrationDetail.BasicInformation.ProbationDate = this.dateFormat.parse(this.RegistrationDetail.BasicInformation.ProbationDate);
              // }
              if (this.RegistrationDetail.BasicInformation.BirthDate != "" && this.RegistrationDetail.BasicInformation.BirthDate != null) {
                this.RegistrationDetail.BasicInformation.BirthDate = this.dateFormat.parse(this.RegistrationDetail.BasicInformation.BirthDate);
              }
              if (this.RegistrationDetail.BasicInformation.ContractStartDate != "" && this.RegistrationDetail.BasicInformation.ContractStartDate != null) {
                this.RegistrationDetail.BasicInformation.ContractStartDate = this.dateFormat.parse(this.RegistrationDetail.BasicInformation.ContractStartDate);
              }
              if (this.RegistrationDetail.BasicInformation.ContractEndDate != "" && this.RegistrationDetail.BasicInformation.ContractEndDate != null) {
                this.RegistrationDetail.BasicInformation.ContractEndDate = this.dateFormat.parse(this.RegistrationDetail.BasicInformation.ContractEndDate);
              }
              if (this.RegistrationDetail.BasicInformation.StatusDate != "" && this.RegistrationDetail.BasicInformation.StatusDate != null) {
                this.RegistrationDetail.BasicInformation.StatusDate = this.dateFormat.parse(this.RegistrationDetail.BasicInformation.StatusDate);
              }
              if (this.RegistrationDetail.BasicInformation.RetirementDate != "" && this.RegistrationDetail.BasicInformation.RetirementDate != null) {
                this.RegistrationDetail.BasicInformation.RetirementDate = this.dateFormat.parse(this.RegistrationDetail.BasicInformation.RetirementDate);
              }

              if (this.RegistrationDetail.BasicInformation.ESS_EmpServiceTypeId == 0) {
                this.RegistrationDetail.BasicInformation.ESS_EmpServiceTypeId = null;
              }
            },
            error: (error) => {
              this.isDisabled = false;
            },
          });
        }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    }
  }

  async SaveAdditionalInformationDetail() {
    if (!this.user.IsPreOnBoarding) {
      await this.common.getPageRights();
    }
    if (false && this.CheckCompulsoryField(0, 'MetroCity', 'Tab3') && !this.RegistrationDetail.AdditionalInformation.MetroCity && !this.user.IsPreOnBoarding) {
      this.toast.show({ message: 'Please check is metro city.', type: toastTypeEnum.warning });
    } else if (false && this.CheckCompulsoryField(0, 'AutoTDS', 'Tab3') && !this.RegistrationDetail.AdditionalInformation.AutoTDS && !this.user.IsPreOnBoarding) {
      this.toast.show({ message: 'Please check auto tds flag.', type: toastTypeEnum.warning });
    } else if (this.common.CompanyParameterValue.ESS_IsPhysicalDisabilityAttachmentCompulsory && this.RegistrationDetail.AdditionalInformation.IsPhysicalDisability && (this.RegistrationDetail.AdditionalInformation.PhysicalDisabilityCertificate == null || this.RegistrationDetail.AdditionalInformation.PhysicalDisabilityCertificate == '')) {
      this.toast.show({ message: 'Upload physical disability certificate attachment.', type: toastTypeEnum.warning });
    } else if (this.CheckCompulsoryField(0, 'QualificationId', 'Tab3') && this.RegistrationDetail.AdditionalInformation.Ess_Qual.length == 0) {
      this.toast.show({ message: 'Please add minimum atleast 1 qualification.', type: toastTypeEnum.warning });
    } else if (this.CheckCompulsoryField(0, 'LanguageID', 'Tab3') && this.RegistrationDetail.AdditionalInformation.Ess_Lang.length == 0) {
      this.toast.show({ message: 'Please add minimum atleast 1 language.', type: toastTypeEnum.warning });
    } else if (this.CheckCompulsoryField(0, 'QualificationAttachment', 'Tab3') && this.RegistrationDetail.AdditionalInformation.QualificationAttachment == null) {
      this.toast.show({ message: 'Upload qulification attachment.', type: toastTypeEnum.warning });
    } else if (this.CheckCompulsoryField(0, 'DegreeAttachment', 'Tab3') && this.RegistrationDetail.AdditionalInformation.DegreeAttachment == null) {
      this.toast.show({ message: 'Upload degree attachment.', type: toastTypeEnum.warning });
    } else {
      if (this.common.PageRight.IsEdit) {
        if (true) {
          this.isDisabled = true;
          if (this.RegistrationDetail.AdditionalInformation.SpouseBirthDate != "" && this.RegistrationDetail.AdditionalInformation.SpouseBirthDate != null) {
            this.RegistrationDetail.AdditionalInformation.SpouseBirthDate = this.dateFormat.format(this.RegistrationDetail.AdditionalInformation.SpouseBirthDate);
          }

          if (this.RegistrationDetail.AdditionalInformation.NoofChildren == null || this.RegistrationDetail.AdditionalInformation.NoofChildren == '') {
            this.RegistrationDetail.AdditionalInformation.NoofChildren = 0;
          }

          if (this.RegistrationDetail.AdditionalInformation.NoofDependents == null || this.RegistrationDetail.AdditionalInformation.NoofDependents == '') {
            this.RegistrationDetail.AdditionalInformation.NoofDependents = 0
          }
          // if (this.RegistrationDetail.AdditionalInformation.Ess_Lang.length == 0) {
          //   this.RegistrationDetail.AdditionalInformation.Ess_Lang.push({
          //     LanguageID: null,
          //     Language: null,
          //     Read: null,
          //     Write: null,
          //     Speak: null
          //   });
          // }

          // if (this.RegistrationDetail.AdditionalInformation.Ess_Qual.length == 0) {
          //   this.RegistrationDetail.AdditionalInformation.Ess_Qual.push({
          //     GradeClass: null,
          //     YearOfPassing: null,
          //     Percentage: null,
          //     UniversityBoard: null,
          //     QualificationId: null,
          //     QualificationName: null
          //   });
          // }

          if (this.RegistrationDetail.AdditionalInformation.IsPhysicalDisability) {
            this.RegistrationDetail.AdditionalInformation.PhysicalDisability = "YES " + this.RegistrationDetail.AdditionalInformation.PhysicalDisability;
          } else {
            this.RegistrationDetail.AdditionalInformation.PhysicalDisability = "NO " + this.RegistrationDetail.AdditionalInformation.PhysicalDisability;
          }

          this.employeeRegistration.TabWise({
            SelectType: this.RegistrationDetail.AdditionalInformation.SelectType,
            TabName: this.RegistrationDetail.AdditionalInformation.TabName,
            EmpMasterId: this.RegistrationDetail.AdditionalInformation.EmpMasterId,
            IsDraft: this.RegistrationDetail.AdditionalInformation.IsDraft,
            IdenficationMark1: this.RegistrationDetail.AdditionalInformation.IdenficationMark1,
            IdenficationMark2: this.RegistrationDetail.AdditionalInformation.IdenficationMark2,
            PhysicalDisability: this.RegistrationDetail.AdditionalInformation.PhysicalDisability,
            PhysicalDisabilityCertificate: this.RegistrationDetail.AdditionalInformation.PhysicalDisabilityCertificate,
            BloodGroup: this.RegistrationDetail.AdditionalInformation.BloodGroup,
            Height: this.RegistrationDetail.AdditionalInformation.Height,
            Weight: this.RegistrationDetail.AdditionalInformation.Weight,
            ChestSize: this.RegistrationDetail.AdditionalInformation.ChestSize,
            ColourofEyes: this.RegistrationDetail.AdditionalInformation.ColourofEyes,
            ColourofHair: this.RegistrationDetail.AdditionalInformation.ColourofHair,
            UniformSize: this.RegistrationDetail.AdditionalInformation.UniformSize,
            ShoesSize: this.RegistrationDetail.AdditionalInformation.ShoesSize,
            MartialStatus: this.RegistrationDetail.AdditionalInformation.MartialStatus,
            NoofChildren: this.RegistrationDetail.AdditionalInformation.NoofChildren,
            NoofDependents: this.RegistrationDetail.AdditionalInformation.NoofDependents,
            SpouseName: this.RegistrationDetail.AdditionalInformation.SpouseName,
            SpouseBirthDate: this.RegistrationDetail.AdditionalInformation.SpouseBirthDate,
            SpouseAge: this.RegistrationDetail.AdditionalInformation.SpouseAge,
            Ess_Qual: this.RegistrationDetail.AdditionalInformation.Ess_Qual.length > 0 ? this.RegistrationDetail.AdditionalInformation.Ess_Qual : [{ GradeClass: null, YearOfPassing: null, Percentage: null, UniversityBoard: null, QualificationId: null, QualificationName: null, EnrollmentNumber: null, College: null, CGPA: null, }],
            Ess_Lang: this.RegistrationDetail.AdditionalInformation.Ess_Lang.length > 0 ? this.RegistrationDetail.AdditionalInformation.Ess_Lang : [{ LanguageID: null, Language: null, Read: null, Write: null, Speak: null }],
            QualificationAttachment: this.RegistrationDetail.AdditionalInformation.QualificationAttachment,
            QualificationAttachmenturl: this.RegistrationDetail.AdditionalInformation.QualificationAttachmenturl,
            DegreeAttachment: this.RegistrationDetail.AdditionalInformation.DegreeAttachment,
            DegreeAttachmenturl: this.RegistrationDetail.AdditionalInformation.DegreeAttachmenturl,
            MetroCity: this.RegistrationDetail.AdditionalInformation.MetroCity,
            AutoTDS: this.RegistrationDetail.AdditionalInformation.AutoTDS,
          }).subscribe({
            next: (response) => {
              if (response.Error_Code == '353') {
                if (this.RegistrationDetail.employeeInfo.EmpType.toLowerCase() === 'front') {
                  if (this.user.CompanyCode === 'MSF' || this.user.CompanyCode === 'MFM') {
                    this.employeeRegistration.EmpRegSelectGetData({ 'RegistrationType': '', 'SelectType': 'EmpApproval', 'EmpMasterId': this.RegistrationDetail.employeeInfo.EmpMasterId, 'IsDraft': this.filter.IsDraft }).subscribe({
                      next: async (responsecheck) => {
                        if (responsecheck.Table.length > 0) {
                          this.EmpCodeForFRONT = responsecheck.Table[0].EmpCode;
                          if (!this.common.CompanyParameterValue.DefaultAPIIntegration && !this.common.CompanyParameterValue.ZingHRAPIIntegration && !this.common.CompanyParameterValue.ProptorAPIIntegration) {

                          }
                          else {
                            if (responsecheck.Table[0].EmpCode !== '' && responsecheck.Table[0].ApprovalStatus.toLowerCase() === 'approved') {
                              await this.Transovative(this.EmpCodeForFRONT, 'edit');
                            }
                          }
                        }
                        this.isDisabledG = false;
                      },
                      complete: () => {

                      },
                      error: (error) => {
                        this.isDisabledG = false;
                      },
                    });
                  }
                }
                this.toast.show({ message: response.Error_Message, type: toastTypeEnum.success });
                this.activeTab = 'Address';
              } else {
                this.toast.show({ message: response.Error_Message, type: toastTypeEnum.warning });
              }
              this.isDisabled = false;
            },
            complete: () => {

              // if (this.RegistrationDetail.AdditionalInformation.Ess_Lang[0].LanguageID == null) {
              //   this.RegistrationDetail.AdditionalInformation.Ess_Lang = [];
              //   this.LanguageDatas = Object.values(this.RegistrationDetail.AdditionalInformation.Ess_Lang);
              //   // this.dtLanguage.dtInstance.then((dtInstance: DataTables.Api) => {
              //   //   dtInstance.destroy();
              //   //   this.dtTriggerLng.next(null);
              //   // });
              // }
              // if (this.RegistrationDetail.AdditionalInformation.Ess_Qual[0].QualificationId == null) {
              //   this.RegistrationDetail.AdditionalInformation.Ess_Qual = [];
              //   this.QualificationDatas = Object.values(this.RegistrationDetail.AdditionalInformation.Ess_Qual);
              //   // this.dtQulification.dtInstance.then((dtInstance: DataTables.Api) => {
              //   //   dtInstance.destroy();
              //   //   this.dtTrigger.next(null);
              //   // });
              // }
              if (this.RegistrationDetail.AdditionalInformation.SpouseBirthDate != "" && this.RegistrationDetail.AdditionalInformation.SpouseBirthDate != null) {
                this.RegistrationDetail.AdditionalInformation.SpouseBirthDate = this.dateFormat.parse(this.RegistrationDetail.AdditionalInformation.SpouseBirthDate);
              }
              if (this.RegistrationDetail.EmpNomineeESIC.EmpDependentDetails.length < this.RegistrationDetail.AdditionalInformation.NoofDependents) {
                for (let index = 0; this.RegistrationDetail.EmpNomineeESIC.EmpDependentDetails.length < this.RegistrationDetail.AdditionalInformation.NoofDependents; index++) {
                  this.addDependentForm();
                }
              }

              let PhysicalDisability = "";
              this.RegistrationDetail.AdditionalInformation.PhysicalDisability.split(" ").forEach((element: any, index: any) => {
                if (index == 0 && (this.common.ToLowerCase(element) == 'yes' || this.common.ToLowerCase(element) == 'no')) {

                } else {
                  PhysicalDisability += element;
                }
              });
              this.RegistrationDetail.AdditionalInformation.PhysicalDisability = PhysicalDisability;

            },
            error: (error) => {
              this.isDisabled = false;
            },
          });
        }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    }
  }

  async SaveAddressInformationDetail() {
    if (!this.user.IsPreOnBoarding) {
      await this.common.getPageRights();
    }
    if (this.CheckCompulsoryField(0, 'Attachment', 'Tab4') && this.RegistrationDetail.AddressTab.Attachment == null) {
      this.toast.show({ message: "upload local address attachment", type: toastTypeEnum.warning });
    } else {
      if (this.common.PageRight.IsEdit) {
        if (true) {
          this.isDisabled = true;
          if (this.RegistrationDetail.AddressTab.LocalAddress[0].LocalDateResiding != "" && this.RegistrationDetail.AddressTab.LocalAddress[0].LocalDateResiding != null) {
            this.RegistrationDetail.AddressTab.LocalAddress[0].LocalDateResiding = this.dateFormat.format(this.RegistrationDetail.AddressTab.LocalAddress[0].LocalDateResiding);
          }

          this.employeeRegistration.TabWise(this.RegistrationDetail.AddressTab).subscribe({
            next: (response) => {
              if (response.Error_Code == '354') {
                if (this.RegistrationDetail.employeeInfo.EmpType.toLowerCase() === 'front') {
                  if (this.user.CompanyCode === 'MSF' || this.user.CompanyCode === 'MFM') {
                    this.employeeRegistration.EmpRegSelectGetData({ 'RegistrationType': '', 'SelectType': 'EmpApproval', 'EmpMasterId': this.RegistrationDetail.employeeInfo.EmpMasterId, 'IsDraft': this.filter.IsDraft }).subscribe({
                      next: async (responsecheck) => {
                        if (responsecheck.Table.length > 0) {
                          this.EmpCodeForFRONT = responsecheck.Table[0].EmpCode;
                          if (!this.common.CompanyParameterValue.DefaultAPIIntegration && !this.common.CompanyParameterValue.ZingHRAPIIntegration && !this.common.CompanyParameterValue.ProptorAPIIntegration) {

                          }
                          else {
                            if (responsecheck.Table[0].EmpCode !== '' && responsecheck.Table[0].ApprovalStatus.toLowerCase() === 'approved') {
                              await this.Transovative(this.EmpCodeForFRONT, 'edit');
                            }
                          }
                        }
                        this.isDisabledG = false;
                      },
                      complete: () => {

                      },
                      error: (error) => {
                        this.isDisabledG = false;
                      },
                    });
                  }
                }
                this.toast.show({ message: response.Error_Message, type: toastTypeEnum.success });
                this.activeTab = 'NomineeESICDetails';
              } else {
                this.toast.show({ message: response.Error_Message, type: toastTypeEnum.warning });
              }
              this.isDisabled = false;
            },
            complete: () => {
              if (this.RegistrationDetail.AddressTab.LocalAddress[0].LocalDateResiding != "" && this.RegistrationDetail.AddressTab.LocalAddress[0].LocalDateResiding != null) {
                this.RegistrationDetail.AddressTab.LocalAddress[0].LocalDateResiding = this.dateFormat.parse(this.RegistrationDetail.AddressTab.LocalAddress[0].LocalDateResiding);
              }
            },
            error: (error) => {
              this.isDisabled = false;
            },
          });
        }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    }
  }

  async SaveNomineeESICDetail() {
    if (!this.user.IsPreOnBoarding) {
      await this.common.getPageRights();
    }
    // if (this.CheckCompulsoryField(0, 'Minor') && this.RegistrationDetail.EmpPFNomineeInformation.EmpPFNomineeDetails.findIndex((e: any) => e.Minor == false) >= 0) {
    //   this.toast.showMessage("Please check is minor.")
    // } else
    this.PercentageTotal = 0;
    this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails.forEach(element => {
      if (element.NomineeShare != null) {
        this.PercentageTotal += parseFloat(element.NomineeShare);
      }
    });
    if (this.PercentageTotal > 100) {
      this.toast.show({ message: "Share % must be less then to equal to 100%", type: toastTypeEnum.warning });
    } else if (this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails.length == 0 && this.CheckCompulsoryField(0, 'EmpPFNominee', 'Tab5')) {
      this.toast.show({ message: "Please add atleat 1 pf nominee", type: toastTypeEnum.warning });
    } else if (this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails.map(e => e.EmpPFNominee).filter((s => v => s.has(v) || !s.add(v))(new Set)).length > 0) {
      this.toast.show({ message: "PF nominee name duplicate", type: toastTypeEnum.warning });
    }
    // else if (this.RegistrationDetail.AdditionalInformation.NoofDependents > 0 && this.RegistrationDetail.AdditionalInformation.NoofDependents != '' && this.RegistrationDetail.AdditionalInformation.NoofDependents != null && this.RegistrationDetail.EmpNomineeESIC.EmpDependentDetails.length != this.RegistrationDetail.AdditionalInformation.NoofDependents) {
    //   this.toast.show({ message: "Add " + this.RegistrationDetail.AdditionalInformation.NoofDependents + " esic nominee details .", type: toastTypeEnum.warning });
    // } 
    else if (this.RegistrationDetail.EmpNomineeESIC.EmpDependentDetails.map((e: any) => e.Name).filter(((s: any) => (v: any) => s.has(v) || !s.add(v))(new Set)).length > 0) {
      this.toast.show({ message: "ESIC  nominee name duplicate", type: toastTypeEnum.warning });
    } else if (this.RegistrationDetail.EmpNomineeESIC.EmpDependentDetails.filter((e: any) => e.DocumentNo != null && e.DocumentNo != '').map((e: any) => e.DocumentNo).filter(((s: any) => (v: any) => s.has(v) || !s.add(v))(new Set)).length > 0) {
      this.toast.show({ message: "ESIC  nominee document no duplicate", type: toastTypeEnum.warning });
    } else if (this.RegistrationDetail.EmpNomineeESIC.EmpDependentDetails.filter((e: any) => (e.DocumentNo != null && e.DocumentNo != '') && e.DocumentMasterId == null).length > 0) {
      this.toast.show({ message: "ESIC Please select document", type: toastTypeEnum.warning });
    } else if ((this.CheckCompulsoryField(0, 'DocumentAttachment', 'Tab5') && this.RegistrationDetail.EmpNomineeESIC.EmpDependentDetails.findIndex((e: any) => e.DocumentAttachment == null) >= 0) || this.RegistrationDetail.EmpNomineeESIC.EmpDependentDetails.filter((e: any) => e.DocumentMasterId != null).findIndex((e: any) => e.DocumentAttachment == null) >= 0) {
      this.toast.show({ message: "Upload attachment for esic nominee " + (this.RegistrationDetail.EmpNomineeESIC.EmpDependentDetails.filter((e: any) => e.DocumentMasterId != null).findIndex((e: any) => e.DocumentAttachment == null) + 1), type: toastTypeEnum.warning });
    }
    else {
      if (this.PercentageTotal <= 100) {
        this.RegistrationDetail.EmpNomineeESIC.EmpDependentDetails.filter((e: any) => e.DocumentNo == null || e.DocumentNo == '').map((e: any) => e.DocumentNo = '0')
        if (this.common.PageRight.IsEdit) {
          if (true) {
            this.isDisabled = true;
            if (this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails.length > 0) {
              this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails.forEach(element => {
                if (element.NomineeBirthDate != "" && element.NomineeBirthDate != null) {
                  element.NomineeBirthDate = this.dateFormat.format(element.NomineeBirthDate);
                }
              });
            }
            // else {
            //   this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails.push(
            //     {
            //       EmpPFNominee: null,
            //       NomineeAddress1: null,
            //       NomineeAddress2: null,
            //       NomineeRelationshipId: null,
            //       NomineeVillageCity: null,
            //       NomineeStateId: null,
            //       NomineeDistrictId: null,
            //       NomineeTalukaTehsilId: null,
            //       NomineePinCode: null,
            //       NomineeBirthDate: null as any,
            //       NomineeShare: null,
            //       Minor: false,
            //       MinorNomineeGuardian: null,
            //       NomineeAddressTypeId: null,
            //       AddressTypeMasterId: null
            //     })
            // }

            if (this.RegistrationDetail.EmpNomineeESIC.EmpDependentDetails.length > 0) {
              this.RegistrationDetail.EmpNomineeESIC.EmpDependentDetails.forEach((element: any) => {
                if (element.DateOfBirth != "" && element.DateOfBirth != null) {
                  element.DateOfBirth = this.dateFormat.format(element.DateOfBirth);
                }
              });
            }
            // else {
            //   this.RegistrationDetail.EmpNomineeESIC.EmpDependentDetails.push({
            //     Name: null,
            //     Address: null,
            //     DateOfBirth: null as any,
            //     Relationship: null,
            //     DocumentMasterId: null,
            //     DocumentNo: null,
            //     DocumentAttachment: null,
            //     DocumentAttachmenturl: null,
            //   });
            // }

            this.employeeRegistration.TabWise({
              SelectType: this.RegistrationDetail.EmpNomineeESIC.SelectType,
              TabName: this.RegistrationDetail.EmpNomineeESIC.TabName,
              EmpMasterId: this.RegistrationDetail.EmpNomineeESIC.EmpMasterId,
              IsDraft: this.RegistrationDetail.EmpNomineeESIC.IsDraft,
              EmpPFNomineeDetails: this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails.length > 0 ? this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails : [{ EmpPFNominee: null, NomineeAddress1: null, NomineeAddress2: null, NomineeRelationshipId: null, NomineeVillageCity: null, NomineeStateId: null, NomineeDistrictId: null, NomineeTalukaTehsilId: null, NomineePinCode: null, NomineeBirthDate: null as any, NomineeShare: null, Minor: false, MinorNomineeGuardian: null, NomineeAddressTypeId: null, AddressTypeMasterId: null, ContactNo: null }],
              EmpDependentDetails: this.RegistrationDetail.EmpNomineeESIC.EmpDependentDetails.length > 0 ? this.RegistrationDetail.EmpNomineeESIC.EmpDependentDetails : [{ Name: null, Address: null, DateOfBirth: null as any, Relationship: null, DocumentMasterId: null, DocumentNo: null, DocumentAttachment: null, DocumentAttachmenturl: null, }],
            }).subscribe({
              next: (response) => {
                if (response.Error_Code == '355') {
                  this.RegistrationDetail.AdditionalInformation.NoofDependents = this.RegistrationDetail.EmpNomineeESIC.EmpDependentDetails.length;

                  if (this.RegistrationDetail.employeeInfo.EmpType.toLowerCase() === 'front') {
                    if (this.user.CompanyCode === 'MSF' || this.user.CompanyCode === 'MFM') {
                      this.employeeRegistration.EmpRegSelectGetData({ 'RegistrationType': '', 'SelectType': 'EmpApproval', 'EmpMasterId': this.RegistrationDetail.employeeInfo.EmpMasterId, 'IsDraft': this.filter.IsDraft }).subscribe({
                        next: async (responsecheck) => {
                          if (responsecheck.Table.length > 0) {
                            this.EmpCodeForFRONT = responsecheck.Table[0].EmpCode;
                            if (!this.common.CompanyParameterValue.DefaultAPIIntegration && !this.common.CompanyParameterValue.ZingHRAPIIntegration && !this.common.CompanyParameterValue.ProptorAPIIntegration) {

                            }
                            else {
                              if (responsecheck.Table[0].EmpCode !== '' && responsecheck.Table[0].ApprovalStatus.toLowerCase() === 'approved') {
                                await this.Transovative(this.EmpCodeForFRONT, 'edit');
                              }
                            }
                          }
                          this.isDisabledG = false;
                        },
                        complete: () => {

                        },
                        error: (error) => {
                          this.isDisabledG = false;
                        },
                      });
                    }
                  }
                  this.toast.show({ message: response.Error_Message, type: toastTypeEnum.success });
                  this.activeTab = 'OtherDetails';
                } else {
                  this.toast.show({ message: response.Error_Message, type: toastTypeEnum.warning });
                }
                this.isDisabled = false;
              },
              complete: () => {
                this.RegistrationDetail.EmpNomineeESIC.EmpPFNomineeDetails.forEach(element => {
                  if (element.NomineeBirthDate != "" && element.NomineeBirthDate != null) {
                    element.NomineeBirthDate = this.dateFormat.parse(element.NomineeBirthDate);
                  }
                });

                this.RegistrationDetail.EmpNomineeESIC.EmpDependentDetails.forEach((element: any) => {
                  if (element.DateOfBirth != "" && element.DateOfBirth != null) {
                    element.DateOfBirth = this.dateFormat.parse(element.DateOfBirth);
                  }
                });
              },
              error: (error) => {
                this.isDisabled = false;
              },
            });
          }
        } else {
          this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
        }
      } else {
        this.toast.show({ message: "Share % must be less then to equal to 100%", type: toastTypeEnum.warning });
      }
    }
  }

  async SaveOtherDetail() {
    if (!this.user.IsPreOnBoarding) {
      await this.common.getPageRights();
    }
    if (this.RegistrationDetail.OtherDetails.ReferenceDetails.length == 0 && this.CheckCompulsoryField(0, 'OthDet_Name', 'Tab6')) {
      this.toast.show({ message: "Please add atleast 1 reference", type: toastTypeEnum.warning });
    } else if (this.RegistrationDetail.OtherDetails.Witness.length == 0 && this.CheckCompulsoryField(0, 'WitnessDet_Name', 'Tab6')) {
      this.toast.show({ message: "Please add atleast 1 witness", type: toastTypeEnum.warning });
    } else if (this.RegistrationDetail.OtherDetails.PreviousEmploymentdetails.length == 0 && this.CheckCompulsoryField(0, 'Name', 'Tab6')) {
      this.toast.show({ message: "Please add atleast 1 employment", type: toastTypeEnum.warning });
    } else if (this.RegistrationDetail.OtherDetails.ReferralSource != null &&
      (this.common.ToLowerCase(this.RegistrationDetail.OtherDetails.ReferralSource) == 'internal' && (this.RegistrationDetail.OtherDetails.ReferredBy == null || this.RegistrationDetail.OtherDetails.ReferredBy == '' || this.RegistrationDetail.OtherDetails.ReferredBy <= 0 || this.RegistrationDetail.OtherDetails.ReferredBy == '0'))
    ) {
      this.toast.show({ message: "Please select referral employee", type: toastTypeEnum.warning });
    } else if (this.RegistrationDetail.OtherDetails.ReferralSource != null &&
      (this.common.ToLowerCase(this.RegistrationDetail.OtherDetails.ReferralSource) == 'external' && (this.RegistrationDetail.OtherDetails.ReferralSourceCategory == null || this.RegistrationDetail.OtherDetails.ReferralSourceCategory == ''))
    ) {
      this.toast.show({ message: "Please select referral category", type: toastTypeEnum.warning });
    }

    else if (this.RegistrationDetail.OtherDetails.PreviousEmploymentdetails.filter((e: any) => e.RelievingLetter == null || e.RelievingLetter == '').length > 0 && this.CheckCompulsoryField(0, 'RelievingLetter', 'Tab6')) {
      this.toast.show({ message: "Please upload relieving letter for previous employment", type: toastTypeEnum.warning });
    } else if (this.RegistrationDetail.OtherDetails.PreviousEmploymentdetails.filter((e: any) => e.OfferLetter == null || e.OfferLetter == '').length > 0 && this.CheckCompulsoryField(0, 'OfferLetter', 'Tab6')) {
      this.toast.show({ message: "Please upload offer letter for previous employment", type: toastTypeEnum.warning });
    } else if (this.RegistrationDetail.OtherDetails.PreviousEmploymentdetails.filter((e: any) => e.Payslip == null || e.Payslip == '').length > 0 && this.CheckCompulsoryField(0, 'Payslip', 'Tab6')) {
      this.toast.show({ message: "Please upload payslip for previous employment", type: toastTypeEnum.warning });
    }
    else {
      if (this.common.PageRight.IsEdit) {
        if (true) {
          this.isDisabled = true;
          this.RegistrationDetail.OtherDetails.PreviousEmploymentdetails.forEach((element: any) => {
            if (element.FromDate != "" && element.FromDate != null) {
              element.FromDate = this.dateFormat.format(element.FromDate);
            }
            if (element.ToDate != "" && element.ToDate != null) {
              element.ToDate = this.dateFormat.format(element.ToDate);
            }
          });

          // if (this.RegistrationDetail.OtherDetails.ReferenceDetails.length == 0) {
          //   this.RegistrationDetail.OtherDetails.ReferenceDetails.push({
          //     Name: null,
          //     Address1: null,
          //     Address2: null,
          //     VillageCity: null,
          //     StateId: null,
          //     DistrictId: null,
          //     TalukaTehsilId: null,
          //     PinCode: null,
          //     ContactNo: null,
          //     AddressTypeMasterId: null,
          //   });
          // }
          // if (this.RegistrationDetail.OtherDetails.Witness.length == 0) {
          //   this.RegistrationDetail.OtherDetails.Witness.push({
          //     Name: null,
          //     Address1: null,
          //     Address2: null,
          //     VillageCity: null,
          //     StateId: null,
          //     DistrictId: null,
          //     TalukaTehsilId: null,
          //     PinCode: null,
          //     ContactNo: null,
          //     AddressTypeMasterId: null,
          //   });
          // }
          // if (this.RegistrationDetail.OtherDetails.PreviousEmploymentdetails.length == 0) {
          //   this.RegistrationDetail.OtherDetails.PreviousEmploymentdetails.push({
          //     Name: null,
          //     Address: null,
          //     Position: null,
          //     FromDate: null,
          //     ToDate: null,
          //     EmployerPFNo: null,
          //     EmployerESICNo: null,
          //     TotalSalaryDrawn: null,
          //     ReasonOfLeaving: null,
          //   });
          // }

          this.employeeRegistration.TabWise({
            SelectType: this.RegistrationDetail.OtherDetails.SelectType,
            TabName: this.RegistrationDetail.OtherDetails.TabName,
            EmpMasterId: this.RegistrationDetail.OtherDetails.EmpMasterId,
            IsDraft: this.RegistrationDetail.OtherDetails.IsDraft,
            ReferenceDetails: this.RegistrationDetail.OtherDetails.ReferenceDetails.length > 0 ? this.RegistrationDetail.OtherDetails.ReferenceDetails : [{ Name: null, Address1: null, Address2: null, VillageCity: null, StateId: null, DistrictId: null, TalukaTehsilId: null, PinCode: null, ContactNo: null, AddressTypeMasterId: null, }],
            Witness: this.RegistrationDetail.OtherDetails.Witness.length > 0 ? this.RegistrationDetail.OtherDetails.Witness : [{ Name: null, Address1: null, Address2: null, VillageCity: null, StateId: null, DistrictId: null, TalukaTehsilId: null, PinCode: null, ContactNo: null, AddressTypeMasterId: null, }],
            PreviousEmploymentdetails: this.RegistrationDetail.OtherDetails.PreviousEmploymentdetails.length > 0 ? this.RegistrationDetail.OtherDetails.PreviousEmploymentdetails : [{ Name: null, Address: null, Position: null, FromDate: null, ToDate: null, EmployerPFNo: null, EmployerESICNo: null, TotalSalaryDrawn: null, ReasonOfLeaving: null, RelievingLetter: null, RelievingLetterURL: null, OfferLetter: null, OfferLetterURL: null, Payslip: null, PayslipURL: null, }],
            ReferralSource: this.RegistrationDetail.OtherDetails.ReferralSource,
            ReferredBy: this.RegistrationDetail.OtherDetails.ReferredBy ?? 0,
            ReferralSourceCategory: this.RegistrationDetail.OtherDetails.ReferralSourceCategory,
          }).subscribe({
            next: (response) => {
              if (response.Error_Code == '356') {
                if (this.RegistrationDetail.employeeInfo.EmpType.toLowerCase() === 'front') {
                  if (this.user.CompanyCode === 'MSF' || this.user.CompanyCode === 'MFM') {
                    this.employeeRegistration.EmpRegSelectGetData({ 'RegistrationType': '', 'SelectType': 'EmpApproval', 'EmpMasterId': this.RegistrationDetail.employeeInfo.EmpMasterId, 'IsDraft': this.filter.IsDraft }).subscribe({
                      next: async (responsecheck) => {
                        if (responsecheck.Table.length > 0) {
                          this.EmpCodeForFRONT = responsecheck.Table[0].EmpCode;
                          if (!this.common.CompanyParameterValue.DefaultAPIIntegration && !this.common.CompanyParameterValue.ZingHRAPIIntegration && !this.common.CompanyParameterValue.ProptorAPIIntegration) {

                          }
                          else {
                            if (responsecheck.Table[0].EmpCode !== '' && responsecheck.Table[0].ApprovalStatus.toLowerCase() === 'approved') {
                              await this.Transovative(this.EmpCodeForFRONT, 'edit');
                            }
                          }
                        }
                        this.isDisabledG = false;
                      },
                      complete: () => {

                      },
                      error: (error) => {
                        this.isDisabledG = false;
                      },
                    });
                  }
                }
                this.toast.show({ message: response.Error_Message, type: toastTypeEnum.success });
                this.activeTab = 'AccountsLicences';
              } else {
                this.toast.show({ message: response.Error_Message, type: toastTypeEnum.warning });
              }
              this.isDisabled = false;
            },
            complete: () => {
              this.RegistrationDetail.OtherDetails.PreviousEmploymentdetails.forEach((element: any) => {
                if (element.FromDate != "" && element.FromDate != null) {
                  element.FromDate = this.dateFormat.parse(element.FromDate);
                }
                if (element.ToDate != "" && element.ToDate != null) {
                  element.ToDate = this.dateFormat.parse(element.ToDate);
                }
              });
            },
            error: (error) => {
              this.isDisabled = false;
            },
          });
        }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    }
  }

  async SaveAccountLicencesDetail() {
    if (!this.user.IsPreOnBoarding) {
      await this.common.getPageRights();
    }
    // if (this.CheckCompulsoryField(0, 'ExistingMemberOfESIC') && !this.RegistrationDetail.AccountLicencesInformations.ExistingMemberOfESIC) {
    //   this.toast.showMessage("Please check existing member of esic.")
    // } else 
    // if (this.CheckCompulsoryField(0, 'ExistingMemberOfPF') && !this.RegistrationDetail.AccountLicencesInformations.ExistingMemberOfPF) {
    //   this.toast.showMessage("Please check existing member of pf.")
    // } else 
    // if (this.CheckCompulsoryField(0, 'PFStatutoryDeduction') && !this.RegistrationDetail.AccountLicencesInformations.PFStatutoryDeduction) {
    //   this.toast.showMessage("Please check pf statutory deduction.")
    // } else 
    if (this.RegistrationDetail.AccountLicencesTab.AadhaarNo != null && this.RegistrationDetail.AccountLicencesTab.AadhaarNo != '' && (this.RegistrationDetail.AccountLicencesTab.AadharAttachment == null || this.RegistrationDetail.AccountLicencesTab.AadharAttachment == '')) {
      this.toast.show({ message: "Please upload aadhar attachment.", type: toastTypeEnum.warning });
    } else if (this.RegistrationDetail.AccountLicencesTab.PANNo != null && this.RegistrationDetail.AccountLicencesTab.PANNo != '' && (this.RegistrationDetail.AccountLicencesTab.PANAttachment == null || this.RegistrationDetail.AccountLicencesTab.PANAttachment == '')) {
      this.toast.show({ message: "Please upload pan card attachment.", type: toastTypeEnum.warning });
    } else if (this.CheckCompulsoryField(0, 'HoldingGun', 'Tab7') && !this.RegistrationDetail.AccountLicencesTab.HoldingGun && this.common.ToLowerCase(this.RegistrationDetail.employeeInfo.EmpType) == 'front') {
      this.toast.show({ message: "Please enter gun details.", type: toastTypeEnum.warning });
    } else if (this.CheckCompulsoryField(0, 'HoldingDrivingLicense', 'Tab7') && !this.RegistrationDetail.AccountLicencesTab.HoldingDrivingLicense) {
      this.toast.show({ message: "Please enter driving license details.", type: toastTypeEnum.warning });
    } else if (this.CheckCompulsoryField(0, 'GunAttachment', 'Tab7') && this.RegistrationDetail.AccountLicencesTab.GunAttachment == null && this.RegistrationDetail.AccountLicencesTab.HoldingGun) {
      this.toast.show({ message: "Upload gun License.", type: toastTypeEnum.warning });
    } else if (this.CheckCompulsoryField(0, 'DrivingAttachment', 'Tab7') && this.RegistrationDetail.AccountLicencesTab.DrivingAttachment == null && this.RegistrationDetail.AccountLicencesTab.HoldingDrivingLicense) {
      this.toast.show({ message: "Upload driving License.", type: toastTypeEnum.warning });
    } else if (this.RegistrationDetail.AccountLicencesTab.BankId > 0 && (this.RegistrationDetail.AccountLicencesTab.Accountno == null || this.RegistrationDetail.AccountLicencesTab.Accountno == '' || this.RegistrationDetail.AccountLicencesTab.IFSCode == null || this.RegistrationDetail.AccountLicencesTab.IFSCode == '')) {
      this.toast.show({ message: "Enter All Bank Details.", type: toastTypeEnum.warning });
    } else if (this.RegistrationDetail.AccountLicencesTab.BankId > 0 && this.RegistrationDetail.AccountLicencesTab.Accountno != this.RegistrationDetail.AccountLicencesTab.AccountnoStar) {
      this.toast.show({ message: "Account No and Confirm Account No Mismatch.", type: toastTypeEnum.warning });
    } else {
      if (this.common.PageRight.IsEdit) {
        if (true) {
          this.isDisabled = true;
          this.RegistrationDetail.AccountLicencesTab.PaymentMode = this.RegistrationDetail.AccountLicencesTab.BankId > 0 ? 3 : 2;

          if (this.RegistrationDetail.AccountLicencesTab.BankId <= 0 || this.RegistrationDetail.AccountLicencesTab.BankId == null || this.RegistrationDetail.AccountLicencesTab.BankId == '') {
            this.RegistrationDetail.AccountLicencesTab.BankId = null;
            this.RegistrationDetail.AccountLicencesTab.BankName = null;
            this.RegistrationDetail.AccountLicencesTab.IFSCode = null;
            this.RegistrationDetail.AccountLicencesTab.Accountno = null;
            this.RegistrationDetail.AccountLicencesTab.AccountnoStar = null;
            this.RegistrationDetail.AccountLicencesTab.AccountLength = null;
            this.RegistrationDetail.AccountLicencesTab.NameAsPerBank = null;
          }
          if (this.RegistrationDetail.AccountLicencesTab.BankId > 0 && this.common.ToLowerCase(this.RegistrationDetail.AccountLicencesTab.BankVerificationStatus) == 'not verified') {
            this.RegistrationDetail.AccountLicencesTab.BankName = this.Banks.filter((e: any) => e.bank_master_id == this.RegistrationDetail.AccountLicencesTab.BankId)[0]['bank_name'];
          }
          if (this.RegistrationDetail.AccountLicencesTab.HoldingGun) {
            if (this.RegistrationDetail.AccountLicencesTab.DateOfIssue != "" && this.RegistrationDetail.AccountLicencesTab.DateOfIssue != null) {
              this.RegistrationDetail.AccountLicencesTab.DateOfIssue = this.dateFormat.format(this.RegistrationDetail.AccountLicencesTab.DateOfIssue);
            }
            if (this.RegistrationDetail.AccountLicencesTab.DateOfExpiry != "" && this.RegistrationDetail.AccountLicencesTab.DateOfExpiry != null) {
              this.RegistrationDetail.AccountLicencesTab.DateOfExpiry = this.dateFormat.format(this.RegistrationDetail.AccountLicencesTab.DateOfExpiry);
            }
            if (this.RegistrationDetail.AccountLicencesTab.GunRegistrationDate != "" && this.RegistrationDetail.AccountLicencesTab.GunRegistrationDate != null) {
              this.RegistrationDetail.AccountLicencesTab.GunRegistrationDate = this.dateFormat.format(this.RegistrationDetail.AccountLicencesTab.GunRegistrationDate);
            }
          } else {
            this.RegistrationDetail.AccountLicencesTab.TypeOfGunId = null;
            this.RegistrationDetail.AccountLicencesTab.GunLicenseNo = null;
            this.RegistrationDetail.AccountLicencesTab.GunNo = null;
            this.RegistrationDetail.AccountLicencesTab.IssuingAuthority = null;
            this.RegistrationDetail.AccountLicencesTab.DateOfIssue = null;
            this.RegistrationDetail.AccountLicencesTab.DateOfExpiry = null;
            this.RegistrationDetail.AccountLicencesTab.GunRegistrationDate = null;
            this.RegistrationDetail.AccountLicencesTab.GunAttachment = null;
            this.RegistrationDetail.AccountLicencesTab.GunAttachmenturl = null;
          }

          if (this.RegistrationDetail.AccountLicencesTab.HoldingDrivingLicense) {
            if (this.RegistrationDetail.AccountLicencesTab.DrivingLicenseIssueDate != "" && this.RegistrationDetail.AccountLicencesTab.DrivingLicenseIssueDate != null) {
              this.RegistrationDetail.AccountLicencesTab.DrivingLicenseIssueDate = this.dateFormat.format(this.RegistrationDetail.AccountLicencesTab.DrivingLicenseIssueDate);
            }
            if (this.RegistrationDetail.AccountLicencesTab.DrivingLicenseExpiryDate != "" && this.RegistrationDetail.AccountLicencesTab.DrivingLicenseExpiryDate != null) {
              this.RegistrationDetail.AccountLicencesTab.DrivingLicenseExpiryDate = this.dateFormat.format(this.RegistrationDetail.AccountLicencesTab.DrivingLicenseExpiryDate);
            }
          } else {
            this.RegistrationDetail.AccountLicencesTab.DrivingLicenseNumber = null;
            this.RegistrationDetail.AccountLicencesTab.DrivingLicenseIssueDate = null;
            this.RegistrationDetail.AccountLicencesTab.DrivingLicenseExpiryDate = null;
            this.RegistrationDetail.AccountLicencesTab.DrivingLicenseIssuingAuthority = null;
            this.RegistrationDetail.AccountLicencesTab.DrivingAttachment = null;
            this.RegistrationDetail.AccountLicencesTab.DrivingAttachmenturl = null;
          }


          this.employeeRegistration.TabWise(this.RegistrationDetail.AccountLicencesTab).subscribe({
            next: (response) => {
              if (response.Error_Code == '357') {
                if (this.RegistrationDetail.employeeInfo.EmpType.toLowerCase() === 'front') {
                  if (this.user.CompanyCode === 'MSF' || this.user.CompanyCode === 'MFM') {
                    this.employeeRegistration.EmpRegSelectGetData({ 'RegistrationType': '', 'SelectType': 'EmpApproval', 'EmpMasterId': this.RegistrationDetail.employeeInfo.EmpMasterId, 'IsDraft': this.filter.IsDraft }).subscribe({
                      next: async (responsecheck) => {
                        if (responsecheck.Table.length > 0) {
                          this.EmpCodeForFRONT = responsecheck.Table[0].EmpCode;
                          if (!this.common.CompanyParameterValue.DefaultAPIIntegration && !this.common.CompanyParameterValue.ZingHRAPIIntegration && !this.common.CompanyParameterValue.ProptorAPIIntegration) {

                          }
                          else {
                            if (responsecheck.Table[0].EmpCode !== '' && responsecheck.Table[0].ApprovalStatus.toLowerCase() === 'approved') {
                              await this.Transovative(this.EmpCodeForFRONT, 'edit');
                            }
                          }
                        }
                        this.isDisabledG = false;
                      },
                      complete: () => {

                      },
                      error: (error) => {
                        this.isDisabledG = false;
                      },
                    });
                  }
                }
                this.toast.show({ message: response.Error_Message, type: toastTypeEnum.success });
                this.activeTab = 'ImageDocument';
              } else {
                this.toast.show({ message: response.Error_Message, type: toastTypeEnum.warning });
              }
              this.isDisabled = false;
            },
            complete: () => {
              if (this.RegistrationDetail.AccountLicencesTab.DateOfIssue != "" && this.RegistrationDetail.AccountLicencesTab.DateOfIssue != null) {
                this.RegistrationDetail.AccountLicencesTab.DateOfIssue = this.dateFormat.parse(this.RegistrationDetail.AccountLicencesTab.DateOfIssue);
              }
              if (this.RegistrationDetail.AccountLicencesTab.DateOfExpiry != "" && this.RegistrationDetail.AccountLicencesTab.DateOfExpiry != null) {
                this.RegistrationDetail.AccountLicencesTab.DateOfExpiry = this.dateFormat.parse(this.RegistrationDetail.AccountLicencesTab.DateOfExpiry);
              }
              if (this.RegistrationDetail.AccountLicencesTab.GunRegistrationDate != "" && this.RegistrationDetail.AccountLicencesTab.GunRegistrationDate != null) {
                this.RegistrationDetail.AccountLicencesTab.GunRegistrationDate = this.dateFormat.parse(this.RegistrationDetail.AccountLicencesTab.GunRegistrationDate);
              }
              if (this.RegistrationDetail.AccountLicencesTab.DrivingLicenseIssueDate != "" && this.RegistrationDetail.AccountLicencesTab.DrivingLicenseIssueDate != null) {
                this.RegistrationDetail.AccountLicencesTab.DrivingLicenseIssueDate = this.dateFormat.parse(this.RegistrationDetail.AccountLicencesTab.DrivingLicenseIssueDate);
              }
              if (this.RegistrationDetail.AccountLicencesTab.DrivingLicenseExpiryDate != "" && this.RegistrationDetail.AccountLicencesTab.DrivingLicenseExpiryDate != null) {
                this.RegistrationDetail.AccountLicencesTab.DrivingLicenseExpiryDate = this.dateFormat.parse(this.RegistrationDetail.AccountLicencesTab.DrivingLicenseExpiryDate);
              }
            },
            error: (error) => {
              this.isDisabled = false;
            },
          });
        }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    }
  }

  async SaveImageDocumentDetail() {
    if (!this.user.IsPreOnBoarding) {
      await this.common.getPageRights();
    }
    if ((this.RegistrationDetail.ImageDocumnetTab.Photo == null && this.CheckCompulsoryField(0, 'Photo', 'Tab8'))
      || (this.RegistrationDetail.ImageDocumnetTab.Signature == null && this.CheckCompulsoryField(0, 'Signature', 'Tab8'))) {
      this.toast.show({ message: "Upload photo and signature both.", type: toastTypeEnum.warning });
    } else if ((this.RegistrationDetail.ImageDocumnetTab.LH1 == null && this.CheckCompulsoryField(0, 'LH1', 'Tab8'))
      || (this.RegistrationDetail.ImageDocumnetTab.LH2 == null && this.CheckCompulsoryField(0, 'LH2', 'Tab8'))
      || (this.RegistrationDetail.ImageDocumnetTab.LH3 == null && this.CheckCompulsoryField(0, 'LH3', 'Tab8'))
      || (this.RegistrationDetail.ImageDocumnetTab.LH4 == null && this.CheckCompulsoryField(0, 'LH4', 'Tab8'))
      || (this.RegistrationDetail.ImageDocumnetTab.LH5 == null && this.CheckCompulsoryField(0, 'LH5', 'Tab8'))) {
      this.toast.show({ message: "Upload all left hand impression.", type: toastTypeEnum.warning });
    } else if ((this.RegistrationDetail.ImageDocumnetTab.RH1 == null && this.CheckCompulsoryField(0, 'RH1', 'Tab8'))
      || (this.RegistrationDetail.ImageDocumnetTab.RH2 == null && this.CheckCompulsoryField(0, 'RH2', 'Tab8'))
      || (this.RegistrationDetail.ImageDocumnetTab.RH3 == null && this.CheckCompulsoryField(0, 'RH3', 'Tab8'))
      || (this.RegistrationDetail.ImageDocumnetTab.RH4 == null && this.CheckCompulsoryField(0, 'RH4', 'Tab8'))
      || (this.RegistrationDetail.ImageDocumnetTab.RH5 == null && this.CheckCompulsoryField(0, 'RH5', 'Tab8'))) {
      this.toast.show({ message: "Upload all right hand impression.", type: toastTypeEnum.warning });
    }
    // else if (this.CheckCompulsoryField(0, 'Attachment', 'Tab8') && this.RegistrationDetail.ImageDocumnetTab.EmpDocumentAttachment.findIndex((e: any) => e.Attachment == null) >= 0) {
    //   this.toast.show({ message: "Upload " + this.Documents[this.RegistrationDetail.ImageDocumnetTab.EmpDocumentAttachment.findIndex((e: any) => e.Attachment == null)].DocumentName, type: toastTypeEnum.warning });
    // } 
    else if (this.RegistrationDetail.ImageDocumnetTab.EmpDocumentAttachment.findIndex((e: any) => e.Attachment == null && e.DocumentNo != null && e.DocumentNo != '') >= 0) {
      this.toast.show({ message: "Upload " + this.RegistrationDetail.ImageDocumnetTab.EmpDocumentAttachment.filter((e: any) => e.Attachment == null && e.DocumentNo != null && e.DocumentNo != '')[0].DocumentName, type: toastTypeEnum.warning });
    }
    else {
      if (this.common.PageRight.IsEdit) {
        if (true) {
          this.isDisabled = true;
          while (this.RegistrationDetail.ImageDocumnetTab.EmpDocumentAttachment.findIndex((e: any) =>
            (e.DocumentNo == null || e.DocumentNo == "") &&
            (e.Attachment == null || e.Attachment == "") &&
            (e.IssueDate == null || e.IssueDate == "") &&
            (e.ExpiryDate == null || e.ExpiryDate == "")
          ) >= 0) {
            this.RegistrationDetail.ImageDocumnetTab.EmpDocumentAttachment.splice(this.RegistrationDetail.ImageDocumnetTab.EmpDocumentAttachment.findIndex((e: any) =>
              (e.DocumentNo == null || e.DocumentNo == "") &&
              (e.Attachment == null || e.Attachment == "") &&
              (e.IssueDate == null || e.IssueDate == "") &&
              (e.ExpiryDate == null || e.ExpiryDate == "")
            ), 1);
          }

          this.RegistrationDetail.ImageDocumnetTab.EmpDocumentAttachment.forEach((element: any) => {
            if (element.IssueDate != "" && element.IssueDate != null) {
              element.IssueDate = this.dateFormat.format(element.IssueDate);
            }
            if (element.ExpiryDate != "" && element.ExpiryDate != null) {
              element.ExpiryDate = this.dateFormat.format(element.ExpiryDate);
            }
          });

          // if (this.RegistrationDetail.ImageDocumnetTab.EmpDocumentAttachment.length == 0) {
          //   this.RegistrationDetail.ImageDocumnetTab.EmpDocumentAttachment.push({
          //     DocumentMasterId: null,
          //     DocumentName: null,
          //     DocumentNo: null,
          //     Attachment: null,
          //     Attachmenturl: null,
          //     Document: null,
          //     IssueDate: null,
          //     ExpiryDate: null,
          //     IssueExpiryDateRequired: null,
          //     Compulsory: null,
          //   });
          // } else {
          //   this.RegistrationDetail.ImageDocumnetTab.EmpDocumentAttachment.filter((e: any) => e.DocumentNo == null).map((e: any) => e.DocumentNo = 0);
          // }

          if (this.RegistrationDetail.ImageDocumnetTab.EmpDocumentAttachment.length > 0) {
            this.RegistrationDetail.ImageDocumnetTab.EmpDocumentAttachment.filter((e: any) => e.DocumentNo == null).map((e: any) => e.DocumentNo = "0");
          }

          this.employeeRegistration.TabWise({
            SelectType: this.RegistrationDetail.ImageDocumnetTab.SelectType,
            TabName: this.RegistrationDetail.ImageDocumnetTab.TabName,
            EmpMasterId: this.RegistrationDetail.ImageDocumnetTab.EmpMasterId,
            IsDraft: this.RegistrationDetail.ImageDocumnetTab.IsDraft,
            Photo: this.RegistrationDetail.ImageDocumnetTab.Photo,
            Photourl: this.RegistrationDetail.ImageDocumnetTab.Photourl,
            Signature: this.RegistrationDetail.ImageDocumnetTab.Signature,
            Signatureurl: this.RegistrationDetail.ImageDocumnetTab.Signatureurl,
            LH1: this.RegistrationDetail.ImageDocumnetTab.LH1,
            LH1url: this.RegistrationDetail.ImageDocumnetTab.LH1url,
            LH2: this.RegistrationDetail.ImageDocumnetTab.LH2,
            LH2url: this.RegistrationDetail.ImageDocumnetTab.LH2url,
            LH3: this.RegistrationDetail.ImageDocumnetTab.LH3,
            LH3url: this.RegistrationDetail.ImageDocumnetTab.LH3url,
            LH4: this.RegistrationDetail.ImageDocumnetTab.LH4,
            LH4url: this.RegistrationDetail.ImageDocumnetTab.LH4url,
            LH5: this.RegistrationDetail.ImageDocumnetTab.LH5,
            LH5url: this.RegistrationDetail.ImageDocumnetTab.LH5url,
            RH1: this.RegistrationDetail.ImageDocumnetTab.RH1,
            RH1url: this.RegistrationDetail.ImageDocumnetTab.RH1url,
            RH2: this.RegistrationDetail.ImageDocumnetTab.RH2,
            RH2url: this.RegistrationDetail.ImageDocumnetTab.RH2url,
            RH3: this.RegistrationDetail.ImageDocumnetTab.RH3,
            RH3url: this.RegistrationDetail.ImageDocumnetTab.RH3url,
            RH4: this.RegistrationDetail.ImageDocumnetTab.RH4,
            RH4url: this.RegistrationDetail.ImageDocumnetTab.RH4url,
            RH5: this.RegistrationDetail.ImageDocumnetTab.RH5,
            RH5url: this.RegistrationDetail.ImageDocumnetTab.RH5url,
            InterviewingOfficer: this.RegistrationDetail.ImageDocumnetTab.InterviewingOfficer,
            AppointingAuthority: this.RegistrationDetail.ImageDocumnetTab.AppointingAuthority,
            RecommendedBy1: this.RegistrationDetail.ImageDocumnetTab.RecommendedBy1,
            RecommendedBy2: this.RegistrationDetail.ImageDocumnetTab.RecommendedBy2,
            Remark: this.RegistrationDetail.ImageDocumnetTab.Remark,
            EmpDocumentAttachment: this.RegistrationDetail.ImageDocumnetTab.EmpDocumentAttachment.length > 0 ? this.RegistrationDetail.ImageDocumnetTab.EmpDocumentAttachment : [{ DocumentMasterId: null, DocumentName: null, DocumentNo: null, Attachment: null, Attachmenturl: null, Document: null, IssueDate: null, ExpiryDate: null, IssueExpiryDateRequired: null, Compulsory: null, }],
          }).subscribe({
            next: (response) => {
              if (response.Error_Code == '358') {
                if (this.user.IsPreOnBoarding) {
                  this.router.navigate(['preonboarding/detail/' + this.RegistrationDetail.employeeInfo.EmpMasterId + '/' + this.filter.IsDraft]);
                } else {
                  if (this.RegistrationDetail.employeeInfo.EmpType.toLowerCase() === 'front') {
                    if (this.user.CompanyCode === 'MSF' || this.user.CompanyCode === 'MFM') {
                      this.employeeRegistration.EmpRegSelectGetData({ 'RegistrationType': '', 'SelectType': 'EmpApproval', 'EmpMasterId': this.RegistrationDetail.employeeInfo.EmpMasterId, 'IsDraft': this.filter.IsDraft }).subscribe({
                        next: async (responsecheck) => {
                          if (responsecheck.Table.length > 0) {
                            this.EmpCodeForFRONT = responsecheck.Table[0].EmpCode;
                            if (!this.common.CompanyParameterValue.DefaultAPIIntegration && !this.common.CompanyParameterValue.ZingHRAPIIntegration && !this.common.CompanyParameterValue.ProptorAPIIntegration) {

                            }
                            else {
                              if (responsecheck.Table[0].EmpCode !== '' && responsecheck.Table[0].ApprovalStatus.toLowerCase() === 'approved') {
                                await this.Transovative(this.EmpCodeForFRONT, 'edit');
                              }
                            }
                          }
                          this.isDisabledG = false;
                        },
                        complete: () => {
                          //this.activeTab = 'ImageDocument';
                        },
                        error: (error) => {
                          this.isDisabledG = false;
                        },
                      });
                    }
                  }
                  this.router.navigate(['onboarding/' + this.addonURL + '/detail/' + this.RegistrationDetail.employeeInfo.EmpMasterId + '/' + this.filter.IsDraft]);
                }
                this.toast.show({ message: response.Error_Message, type: toastTypeEnum.success });
              } else {
                this.toast.show({ message: response.Error_Message, type: toastTypeEnum.warning });
              }
              this.isDisabled = false;
            },
            complete: () => {
              if (this.RegistrationDetail.ImageDocumnetTab.EmpDocumentAttachment[0].DocumentMasterId == null) {
                this.RegistrationDetail.ImageDocumnetTab.EmpDocumentAttachment = [];
              }
              this.RegistrationDetail.ImageDocumnetTab.EmpDocumentAttachment.forEach((element: any) => {
                if (element.IssueDate != "" && element.IssueDate != null) {
                  element.IssueDate = this.dateFormat.parse(element.IssueDate);
                }
                if (element.ExpiryDate != "" && element.ExpiryDate != null) {
                  element.ExpiryDate = this.dateFormat.parse(element.ExpiryDate);
                }
              });
            },
            error: (error) => {
              this.isDisabled = false;
            },
          });
        }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    }
  }

  RemoveAttechment(id: number, index = 0) {
    if (id == 1) {
      this.RegistrationDetail.Verification.AadharAttachment = null;
      this.RegistrationDetail.Verification.AadharAttachmenturl = null;
    } else if (id == 2) {
      this.RegistrationDetail.Verification.PANAttachment = null;
      this.RegistrationDetail.Verification.PANAttachmenturl = null;
    } else if (id == 3) {
      this.RegistrationDetail.Verification.BankAttachment = null;
      this.RegistrationDetail.Verification.BankAttachmenturl = null;
    } else if (id == 4) {
      this.RegistrationDetail.BasicInformation.photo = null;
      this.RegistrationDetail.BasicInformation.photourl = null;
    } else if (id == 5) {
      this.RegistrationDetail.AdditionalInformation.QualificationAttachment = null;
      this.RegistrationDetail.AdditionalInformation.QualificationAttachmenturl = null;
    } else if (id == 6) {
      this.RegistrationDetail.AddressTab.Attachment = null;
      this.RegistrationDetail.AddressTab.Attachment = null;
    } else if (id == 7) {
      this.RegistrationDetail.EmpNomineeESIC.EmpDependentDetails[index].DocumentAttachment = null;
      this.RegistrationDetail.EmpNomineeESIC.EmpDependentDetails[index].DocumentAttachmenturl = null;
    } else if (id == 8) {
      this.RegistrationDetail.AccountLicencesTab.AadharAttachment = null;
      this.RegistrationDetail.AccountLicencesTab.AadharAttachmenturl = null;
    } else if (id == 9) {
      this.RegistrationDetail.AccountLicencesTab.PANAttachment = null;
      this.RegistrationDetail.AccountLicencesTab.PANAttachmenturl = null;
    } else if (id == 10) {
      this.RegistrationDetail.AccountLicencesTab.BankAttachment = null;
      this.RegistrationDetail.AccountLicencesTab.BankAttachmenturl = null;
    } else if (id == 11) {
      this.RegistrationDetail.AccountLicencesTab.GunAttachment = null;
      this.RegistrationDetail.AccountLicencesTab.GunAttachmenturl = null;
    } else if (id == 12) {
      this.RegistrationDetail.AccountLicencesTab.DrivingAttachment = null;
      this.RegistrationDetail.AccountLicencesTab.DrivingAttachmenturl = null;
    } else if (id == 13) {
      this.RegistrationDetail.ImageDocumnetTab.Photo = null;
      this.RegistrationDetail.ImageDocumnetTab.Photourl = null;
    } else if (id == 14) {
      this.RegistrationDetail.ImageDocumnetTab.Signature = null;
      this.RegistrationDetail.ImageDocumnetTab.Signature = null;
    } else if (id == 15) {
      this.RegistrationDetail.ImageDocumnetTab.LH1 = null;
      this.RegistrationDetail.ImageDocumnetTab.LH1url = null;
    } else if (id == 16) {
      this.RegistrationDetail.ImageDocumnetTab.LH2 = null;
      this.RegistrationDetail.ImageDocumnetTab.LH2url = null;
    } else if (id == 17) {
      this.RegistrationDetail.ImageDocumnetTab.LH3 = null;
      this.RegistrationDetail.ImageDocumnetTab.LH3url = null;
    } else if (id == 18) {
      this.RegistrationDetail.ImageDocumnetTab.LH4 = null;
      this.RegistrationDetail.ImageDocumnetTab.LH4url = null;
    } else if (id == 19) {
      this.RegistrationDetail.ImageDocumnetTab.LH5 = null;
      this.RegistrationDetail.ImageDocumnetTab.LH5url = null;
    } else if (id == 20) {
      this.RegistrationDetail.ImageDocumnetTab.RH1 = null;
      this.RegistrationDetail.ImageDocumnetTab.RH1url = null;
    } else if (id == 21) {
      this.RegistrationDetail.ImageDocumnetTab.RH2 = null;
      this.RegistrationDetail.ImageDocumnetTab.RH2url = null;
    } else if (id == 22) {
      this.RegistrationDetail.ImageDocumnetTab.RH3 = null;
      this.RegistrationDetail.ImageDocumnetTab.RH3url = null;
    } else if (id == 23) {
      this.RegistrationDetail.ImageDocumnetTab.RH4 = null;
      this.RegistrationDetail.ImageDocumnetTab.RH4url = null;
    } else if (id == 24) {
      this.RegistrationDetail.ImageDocumnetTab.RH5 = null;
      this.RegistrationDetail.ImageDocumnetTab.RH5url = null;
    } else if (id == 25) {
      this.RegistrationDetail.ImageDocumnetTab.EmpDocumentAttachment[index].Attachment = null;
      this.RegistrationDetail.ImageDocumnetTab.EmpDocumentAttachment[index].Attachmenturl = null;
    }
    else if (id == 26) {
      this.RegistrationDetail.OtherDetails.PreviousEmploymentdetails[index].RelievingLetter = null;
      this.RegistrationDetail.OtherDetails.PreviousEmploymentdetails[index].RelievingLetterURL = null;
    } else if (id == 27) {
      this.RegistrationDetail.OtherDetails.PreviousEmploymentdetails[index].OfferLetter = null;
      this.RegistrationDetail.OtherDetails.PreviousEmploymentdetails[index].OfferLetterURL = null;
    } else if (id == 28) {
      this.RegistrationDetail.OtherDetails.PreviousEmploymentdetails[index].Payslip = null;
      this.RegistrationDetail.OtherDetails.PreviousEmploymentdetails[index].PayslipURL = null;
    } else if (id == 29) {
      this.RegistrationDetail.AdditionalInformation.DegreeAttachment = null;
      this.RegistrationDetail.AdditionalInformation.DegreeAttachmenturl = null;
    } else if (id == 30) {
      this.RegistrationDetail.AdditionalInformation.PhysicalDisabilityCertificate = null;
      this.RegistrationDetail.AdditionalInformation.PhysicalDisabilityCertificateURL = null;
    }
  }

  GetURL(name: string, URL: any) {
    return this.common.isPdf(name) ? URL['changingThisBreaksApplicationSecurity'] : URL;
  }

  showFooterMasking() {
    if (this.RegistrationDetail.employeeInfo.IsShow == undefined) { this.RegistrationDetail.employeeInfo.IsShow = true }
    this.RegistrationDetail.employeeInfo.IsShow = !this.RegistrationDetail.employeeInfo.IsShow;
    if (this.RegistrationDetail.employeeInfo.IsShow) {
      if (this.RegistrationDetail.Verification.EmailId != null) {
        this.RegistrationDetail.employeeInfo.EmailIdShow = this.RegistrationDetail.Verification.EmailId;
      }
      if (this.RegistrationDetail.Verification.MobileNo != null) {
        this.RegistrationDetail.employeeInfo.MobileNoShow = this.RegistrationDetail.Verification.MobileNo;
      }
    } else {
      if (this.RegistrationDetail.Verification.EmailId != null) {
        this.RegistrationDetail.employeeInfo.EmailIdShow = 'XXXXX@' + this.RegistrationDetail.Verification.EmailId.split('@')[1];
      }
      if (this.RegistrationDetail.Verification.MobileNo != null) {
        this.RegistrationDetail.employeeInfo.MobileNoShow = this.RegistrationDetail.Verification.MobileNo?.substring(0, 4) + 'XXXXXX';
      }
    }
  }

  mobileEmailOTP(type: number) {
    //type 1 for mobile
    //type 2 for email
    //if (this.VerificationStatus.BankDetailsVerificationEnabled) {
    if ((type == 1 && this.RegistrationDetail.Verification.MobileNo != null && this.RegistrationDetail.Verification.MobileNo != '') ||
      (type == 2 && this.RegistrationDetail.Verification.EmailId != null && this.RegistrationDetail.Verification.EmailId != '')) {
      const modalRef = this.modalService.open(MobileEmailComponent, { backdrop: 'static', });
      modalRef.componentInstance.IsDraft = this.filter.IsDraft;
      modalRef.componentInstance.EmpTempCode = this.RegistrationDetail.employeeInfo.EmpTempCode;
      modalRef.componentInstance.EmpMasterId = this.RegistrationDetail.employeeInfo.EmpMasterId;
      modalRef.componentInstance.EmailId = type == 1 ? this.RegistrationDetail.Verification.MobileNo : type == 2 ? this.RegistrationDetail.Verification.EmailId : '';
      modalRef.componentInstance.TypeID = type;
      modalRef.result.then(result => {
        if (result != null && result != undefined && result) {
          if (type == 1) {
            this.RegistrationDetail.Verification.MobileVerificationStatus = 'Verified';
            this.RegistrationDetail.employeeInfo.IsEditVMobileNo = false;
          } else if (type == 2) {
            this.RegistrationDetail.Verification.EmailVerificationStatus = 'Verified';
            this.RegistrationDetail.employeeInfo.IsEditVEmail = false;
          }
        } else {
          if (type == 1) {
            this.RegistrationDetail.Verification.MobileVerificationStatus = 'Not Verified';
          } else if (type == 2) {
            this.RegistrationDetail.Verification.EmailVerificationStatus = 'Not Verified';
          }
        }
      });
    } else {
      this.toast.show({ message: type == 1 ? 'Mobile No Cannot Be Blank.' : type == 2 ? 'EmailID Cannot Be Blank.' : '', type: toastTypeEnum.warning });
    }
    // } else {
    //   this.toast.show({ message: 'Bank verification not enabled. please contact your administrator.', type: toastTypeEnum.warning });
    // }    
  }

  GetIFSCCode() {
    this.RegistrationDetail.AccountLicencesTab.IFSCode = null;
    this.RegistrationDetail.AccountLicencesTab.Accountno = null;
    this.RegistrationDetail.AccountLicencesTab.AccountnoStar = null;

    this.RegistrationDetail.AccountLicencesTab.IFSCode = this.Banks.filter((e: any) => e.bank_master_id == this.RegistrationDetail.AccountLicencesTab.BankId)[0]['DefaultIFSCCode'];
    this.RegistrationDetail.AccountLicencesTab.AccountLength = this.Banks.filter((e: any) => e.bank_master_id == this.RegistrationDetail.AccountLicencesTab.BankId)[0]['AcNoLength'];
  }

  GetDataPreonboarding() {
    this.employeeRegistration.ESS_EmpRegistration_SearchGet({ 'SelectType': 'PreOnBoarding', 'EmpMasterId': this.RegistrationDetail.employeeInfo.EmpMasterId, 'IsDraft': this.filter.IsDraft }).subscribe({
      next: (response) => {
        if (response.Table) {
          if (response.Table.length > 0) {
            this.filter.EmpStatus = response.Table.filter((e: any) => e.EmpMasterId == this.RegistrationDetail.employeeInfo.EmpMasterId)[0].Status;
            if (response.Table.filter((e: any) => e.EmpMasterId == this.RegistrationDetail.employeeInfo.EmpMasterId && this.common.ToLowerCase(e.Status) != 'finalsubmitted').length > 0) {
              //commit on 21-april-2026 confirm with shreya , ankit sir , ravi sir for approved employee editable any case not check bgv status
              // if (this.common.ToLowerCase(this.RegistrationDetail.employeeInfo.BGVStatus) == null || this.common.ToLowerCase(this.RegistrationDetail.employeeInfo.BGVStatus) == '' || this.common.ToLowerCase(this.RegistrationDetail.employeeInfo.VerificationMode) == 'manual') {
              //   this.IsEditable = true;
              // } else {
              //   this.IsEditable = false;
              // }
              this.IsEditable = true;
            } else {
              if (this.user.IsPreOnBoarding) {
                this.router.navigate(['preonboarding/detail/' + this.RegistrationDetail.employeeInfo.EmpMasterId + '/' + this.filter.IsDraft]);
              }
              this.IsEditable = false;
            }
          }
          this.GetCompulsoryFields('');
          if (this.common.CompanyParameterValue.ESS_IsEmpBGVApplicable) {
            this.ESS_EmpBgvMandatoryDataLoad();
          }
          this.SelectDate('PreJoiningDate', null, null);
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  GetDataMenual() {
    this.employeeRegistration.ESS_EmpRegistration_SearchGet({ 'SelectType': 'Search', 'EmpMasterId': this.RegistrationDetail.employeeInfo.EmpMasterId, 'IsDraft': this.filter.IsDraft }).subscribe({
      next: (response) => {
        if (response.Table.length > 0) {
          this.filter.EmpStatus = response.Table.filter((e: any) => e.EmpMasterId == this.RegistrationDetail.employeeInfo.EmpMasterId)[0].ApprovalStatus;
          if (response.Table.filter((e: any) => e.EmpMasterId == this.RegistrationDetail.employeeInfo.EmpMasterId && (this.common.ToLowerCase(e.ApprovalStatus) == 'approved' || e.ApprovalStatus == '')).length > 0) {
            //commit on 21-april-2026 confirm with shreya , ankit sir , ravi sir for approved employee editable any case not check bgv status
            // if (this.common.ToLowerCase(this.RegistrationDetail.employeeInfo.BGVStatus) != 'clear' && this.RegistrationDetail.employeeInfo.BGVStatus != null && this.RegistrationDetail.employeeInfo.BGVStatus != '' && this.common.ToLowerCase(this.RegistrationDetail.employeeInfo.VerificationMode) != 'manual') {
            //   this.IsEditable = false;
            // } else {
            //   this.IsEditable = true;
            // }
            this.IsEditable = true;
          } else {
            this.IsEditable = false;
          }
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  DocLength(id: number, type: String) {
    try {
      if (this.EmpDependentsTypeOfProofs.filter((e: any) => e.DocumentMasterID == id)[0].DocumentLength != "" && this.EmpDependentsTypeOfProofs.filter((e: any) => e.DocumentMasterID == id)[0].DocumentLength != null && this.EmpDependentsTypeOfProofs.filter((e: any) => e.DocumentMasterID == id)[0].DocumentLength != 0 && this.EmpDependentsTypeOfProofs.filter((e: any) => e.DocumentMasterID == id)[0].DocumentLength != "0") {
        return this.EmpDependentsTypeOfProofs.filter((e: any) => e.DocumentMasterID == id)[0].DocumentLength
      } else {
        return type == 'Max' ? 25 : 0;
      }
    } catch (e) {
      return type == 'Max' ? 25 : 0;
    }
  }

  DocMandatory(id: number) {
    try {
      if (this.EmpDependentsTypeOfProofs.filter((e: any) => e.DocumentMasterID == id)[0].DocumentLength != "" && this.EmpDependentsTypeOfProofs.filter((e: any) => e.DocumentMasterID == id)[0].DocumentLength != null && this.EmpDependentsTypeOfProofs.filter((e: any) => e.DocumentMasterID == id)[0].DocumentLength != 0 && this.EmpDependentsTypeOfProofs.filter((e: any) => e.DocumentMasterID == id)[0].DocumentLength != "0") {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  }

  InitContactEdit() {
    const modalRef = this.modalService.open(InitMobileEmaiComponent, { backdrop: 'static', });
    modalRef.componentInstance.EmpMasterID = this.RegistrationDetail.employeeInfo.EmpMasterId;
    modalRef.componentInstance.IsDraft = this.filter.IsDraft;
    modalRef.result.then(result => {
      if (result != null && result != undefined) {
        this.RegistrationDetail.Verification.BankId = result.BankId;
        this.RegistrationDetail.Verification.BankName = result.BankName;
        this.RegistrationDetail.Verification.BankAccountNo = result.BankAccountNo;
        this.RegistrationDetail.Verification.IFSCode = result.IFSCode;
        this.RegistrationDetail.Verification.NameAsPerBank = result.NameAsPerBank;
        this.RegistrationDetail.Verification.BankVerificationID = result.BankVerificationID;
        this.RegistrationDetail.Verification.BankVerificationStatus = result.BankVerificationStatus;
      }
    });
  }

  ClearAccountNo() {
    if (this.RegistrationDetail.AccountLicencesTab.Accountno != null) {
      this.RegistrationDetail.AccountLicencesTab.Accountno = null;
    }
  }

  VContactEdit(type: number) {
    if (type == 1) {
      this.RegistrationDetail.employeeInfo.IsEditVMobileNo = !this.RegistrationDetail.employeeInfo.IsEditVMobileNo
      this.RegistrationDetail.Verification.MobileVerificationStatus = 'Not Verified';
    } else if (type == 2) {
      this.RegistrationDetail.employeeInfo.IsEditVEmail = !this.RegistrationDetail.employeeInfo.IsEditVEmail
      this.RegistrationDetail.Verification.EmailVerificationStatus = 'Not Verified';
    }
  }

  Cancel() {
    if (this.common.ToLowerCase(this.addonURL) == 'register' || this.common.ToLowerCase(this.addonURL) == 'preonboarding') {
      this.router.navigate(['onboarding/' + this.addonURL + '/' + this.common.ToLowerCase(this.RegistrationDetail.employeeInfo.EmpType)]);
    } else {
      this.router.navigate(['onboarding/' + this.addonURL]);
    }
  }

  ESS_EmpMobileEmailDuplicateCheck(type: number, EmailID: string, MobileNo: string) {
    if ((type == 1 && MobileNo != null && MobileNo != '' && MobileNo.length == 10) || type == 2) {
      this.isDisabled = true;
      this.employeeRegistration.ESS_EmpMobileEmailDuplicateCheck({ 'SelectType': EmailID != '' ? 'Email' : MobileNo != '' ? 'Mobile' : '', 'EmpMasterId': this.RegistrationDetail.employeeInfo.EmpMasterId, 'EmailId': EmailID, 'MobileNo': MobileNo, 'IsDraft': this.filter.IsDraft }).subscribe({
        next: (response) => {
          if (response.Error_Code == '01') {
            this.mobileEmailOTP(type)
          } else {
            this.toast.show({ message: response.Error_Message, type: toastTypeEnum.warning });
          }
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    } else {
      this.toast.show({ message: 'Please enter 10 digit mobile no.', type: toastTypeEnum.warning });
    }

  }

  handleInputChange(event: any, propertyPath: string) {
    this.common.ToUpperCaseE(event);
    const keys = propertyPath.split('.');
    let obj = this.RegistrationDetail as any;

    for (let i = 0; i < keys.length - 1; i++) {
      obj = obj[keys[i]];
    }
    const lastKey = keys[keys.length - 1];
    obj[lastKey] = (event.target as HTMLInputElement).value.toUpperCase();

    const input = event.target as HTMLInputElement;
    const value = input.value;

    // Manually convert to uppercase
    const upperValue = value.toUpperCase();
    obj[lastKey] = upperValue;
  }


  forceUppercase(event: any, propertyPath: string) {
    const input = event.target as HTMLInputElement;
    const upperValue = input.value.toUpperCase();

    // Force update DOM
    input.value = upperValue;

    // Ensure model is uppercase
    const keys = propertyPath.split('.');
    let obj = this.RegistrationDetail as any;

    for (let i = 0; i < keys.length - 1; i++) {
      obj = obj[keys[i]];
    }

    const lastKey = keys[keys.length - 1];
    obj[lastKey] = upperValue;
  }


  checkFieldDisable(): boolean {
    // if ((!this.RegistrationDetail.BasicInformation.IsTempEmployee && this.common.ToLowerCase(this.user.U_UserType) == 'administrator') || this.common.CompanyParameterValue.AllowUserToUpdateAllEmpMasterData) {
    //   return false;
    // } else if (this.RegistrationDetail.BasicInformation.IsTempEmployee) {
    //   return false;
    // } else {
    //   return true;
    // }

    //changes as per rahul 12-Jun-2025
    if ((!this.RegistrationDetail.BasicInformation.IsTempEmployee && (this.common.ToLowerCase(this.user.U_UserType) == 'administrator' || this.common.CompanyParameterValue.AllowUserToUpdateAllEmpMasterData))) {
      return false;
    } else if (this.RegistrationDetail.BasicInformation.IsTempEmployee) {
      return false;
    } else {
      return true;
    }

    //changes commit as per rahul 12-Jun-2025
    // if (this.RegistrationDetail.BasicInformation.IsTempEmployee) {
    //   return false;
    // } else {
    //   return true;
    // }
  }

  checkFieldDisable2(): boolean {
    return this.checkFieldDisableFlag;
    // if (this.RegistrationDetail.BasicInformation.SiteId != null && this.RegistrationDetail.BasicInformation.SiteId != '' && this.RegistrationDetail.BasicInformation.SiteId > 0) {
    //   return true;
    // } else {
    //   return false;
    // }
    // if (this.filter.IsDraft == 'true' || this.filter.isSiteCheck) {
    //   return false;
    // } else {
    //   return true;
    // }
  }

  async Transovative(id: any, type: string) {
    this.isDisabled = true
    const data = {
      SQL_TableName: 'EmpMaster',
      SQL_IDColumnName: 'EmpMasterId',
      DefaultSyncAPI: false,
      ZingHRSyncAPI: false,
      ProptorSyncAPI: false,
      UserId: this.user.UserId,
      Id: id
    }
    await this.approvalMatrix.SetSyncAPIFlagIn(data).subscribe({
      next: async (response) => {
        await this.approvalMatrix.GetMaster({ MasterName: 'Employee', MasterCode: id }).subscribe({
          next: async (responses) => {
            if (responses.Table.length > 0) {
              const employeeAdd = {
                username: responses.Table[0].username,
                empid: responses.Table[0].empid,
                Contactno: responses.Table[0].contactno,
                Emailid: responses.Table[0].emailid,
                Role: responses.Table[0].role,
                Branch: responses.Table[0].branch,
                Bh: responses.Table[0].bh,
                Designation: responses.Table[0].designation,
                Siteowneruserid: responses.Table[0].siteowneruserid,
                Fathersname: responses.Table[0].fathersname,
                Doj: responses.Table[0].doj,
                Dob: responses.Table[0].dob,
                Nativeplace: responses.Table[0].nativeplace,
                State: responses.Table[0].state,
                Siteid: responses.Table[0].siteid,
                Location: responses.Table[0].location,
                Dutyhrs: responses.Table[0].dutyhrs,
                Bankname: responses.Table[0].bankname,
                Aadharno: responses.Table[0].aadharno,
                Age: responses.Table[0].age,
                Address: responses.Table[0].address,
                companycode: responses.Table[0].companyCode,
                OperationType: 'Employee',
                Action: 'add'
              }
              const EmpEdit = {
                username: responses.Table[0].username,
                empid: responses.Table[0].empid,
                Contactno: responses.Table[0].contactno,
                Emailid: responses.Table[0].emailid,
                Fathersname: responses.Table[0].fathersname,
                Doj: responses.Table[0].doj,
                Dob: responses.Table[0].dob,
                Nativeplace: responses.Table[0].nativeplace,
                State: responses.Table[0].state,
                Bankname: responses.Table[0].bankname,
                Aadharno: responses.Table[0].aadharno,
                Age: responses.Table[0].age,
                Address: responses.Table[0].address,
                companycode: responses.Table[0].companyCode,
                OperationType: 'Employee',
                Action: 'edit'
              }
              let data = {
              }
              if (type === 'edit') {
                data = EmpEdit;
              } else if (type === 'add') {
                data = employeeAdd;
              }
              await this.approvalMatrix.SubMasterApi(data).subscribe({
                next: async (response1) => {

                  this.isDisabled = false
                  this.RestData = response1
                  alert(response1.DefaultMessage);
                  if (response1.ErrorCode === '2016') {
                    const modalRef = this.modalService.open(ConfirmationComponent, {
                      size: 'md',
                      backdrop: 'static',
                      centered: true,
                      windowClass: 'confirmation-modal'
                    });
                    modalRef.componentInstance.Message = 'Do you want to add Employee in EFSR? ,EmployeeID invalid in EFSR'
                    modalRef.result.then(async (result: any) => {
                      if (result) {
                        await this.Transovative(id, 'add');
                      }
                    }).catch(() => {

                    });
                  }
                  this.Transovative_SubMasterApi_ConsumptionLogs(responses.Table[0].username, id, this.RestData, responses.Table[0], type);
                },
                complete: async () => {

                },
                error: (error: any) => {
                  this.isDisabled = false;
                },
              });
            }
          },
          complete: () => {

          },
          error: (error: any) => {
            this.isDisabled = false;
          },
        });
      },
      complete: () => {

      },
      error: (error: any) => {
        this.isDisabled = false;
      },
    });
  }
  Transovative_SubMasterApi_ConsumptionLogs(name: string, id: any, res: any, requestjson: any, type: string) {
    const employeeAdd = {
      empid: requestjson.empid,
      Contactno: requestjson.contactno,
      Emailid: requestjson.emailid,
      Role: requestjson.role,
      Branch: requestjson.branch,
      Bh: requestjson.bh,
      Designation: requestjson.designation,
      Siteowneruserid: requestjson.siteowneruserid,
      Fathersname: requestjson.fathersname,
      Doj: requestjson.doj,
      Dob: requestjson.dob,
      Nativeplace: requestjson.nativeplace,
      State: requestjson.state,
      Siteid: requestjson.siteid,
      Location: requestjson.location,
      Dutyhrs: requestjson.dutyhrs,
      Bankname: requestjson.bankname,
      Aadharno: requestjson.aadharno,
      Age: requestjson.age,
      Address: requestjson.address,
      companycode: requestjson.companyCode,
      OperationType: 'Employee',
      Action: 'add'
    }
    const EmpEdit = {
      username: requestjson.username,
      empid: requestjson.empid,
      Contactno: requestjson.contactno,
      Emailid: requestjson.emailid,
      Fathersname: requestjson.fathersname,
      Doj: requestjson.doj,
      Dob: requestjson.dob,
      Nativeplace: requestjson.nativeplace,
      State: requestjson.state,
      Bankname: requestjson.bankname,
      Aadharno: requestjson.aadharno,
      Age: requestjson.age,
      Address: requestjson.address,
      companycode: requestjson.companyCode,
      OperationType: 'Employee',
      Action: 'edit'
    }
    let json = {
    }
    if (type === 'edit') {
      json = EmpEdit;
    } else if (type === 'add') {
      json = employeeAdd;
    }
    const data = {
      requestJson: json,
      UserId: this.user.UserId,
      OperationType: 'Employee',
      UnitCode: id,
      UnitDescription: name,
      DefaultReturnCode: res.DefaultReturnCode,
      DefaultMessage: res.DefaultMessage,
      ActionType: type === 'edit' ? 'updateemployeedetails' : 'addemployeedetails',
    }
    this.approvalMatrix.Transovative_SubMasterApi_ConsumptionLogs(data).subscribe({
      next: (response) => {
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error: any) => {
        this.isDisabled = false;
      },
    });
  }

  ESS_EmployeeLetterDetailsLoad() {
    this.isDisabled = true;
    this.letterDocument.ESS_EmployeeLetterDetailsLoad({ SelectType: 'RegistrationLetter', EmpMasterID: this.RegistrationDetail.BasicInformation.EmpMasterId }).subscribe({
      next: (response) => {
        if (response.Table) {
          this.LetterData = response.Table;
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  setIsReportingToNotApplicable() {
    if (this.RegistrationDetail.BasicInformation.MainDesignationId > 0) {
      if (this.EmpDesignations.length > 0) {
        this.IsReportingToNotApplicable = this.EmpDesignations.filter((e: any) => e.DesignationMasterID == this.RegistrationDetail.BasicInformation.MainDesignationId)[0].IsReportingToNotApplicable;
      } else {
        this.IsReportingToNotApplicable = false;
      }
    } else {
      this.IsReportingToNotApplicable = false;
    }
  }

  ESS_EmpBgvMandatoryDataLoad() {
    this.isDisabled = true;
    this.backgroundVerification.ESS_EmpBgvMandatoryDataLoad({ SelectType: 'S', EmpMasterId: this.RegistrationDetail.employeeInfo.EmpMasterId, IsDraft: this.filter.IsDraft }).subscribe({
      next: (response) => {
        if (response.Table1 && response.Table1.length > 0) {
          this.BGVCompulsoryField = [...response.Table1];
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ESS_EmpBGVVerificationDetailsSelect() {
    this.isDisabled = true;
    this.bgvHistoryHeader = [];
    this.backgroundVerification.ESS_EmpBGVVerificationDetailsSelect({ SelectType: 'S', EmpMasterId: this.RegistrationDetail.employeeInfo.EmpMasterId, IsDraft: this.filter.IsDraft }).subscribe({
      next: (response) => {
        if (response && response.Table) {
          this.bgvHistory = Object.values(response.Table);
        }

        [...new Set(this.bgvHistory.map((e: any) => e.APIName))].forEach((element: any) => {

          [...new Set(this.bgvHistory.filter((e: any) => e.APIName == element && this.common.ToLowerCase(e.VerificationMode) == 'automatic').map((e: any) => e.APIName))].forEach((element: any) => {
            this.bgvHistoryHeader.push({
              ESS_BGVAPIMasterID: this.bgvHistory.filter((e: any) => e.APIName == element && this.common.ToLowerCase(e.VerificationMode) == 'automatic')[0].ESS_BGVAPIMasterID,
              APIName: this.bgvHistory.filter((e: any) => e.APIName == element && this.common.ToLowerCase(e.VerificationMode) == 'automatic')[0].APIName,
              InitiatedBy: this.bgvHistory.filter((e: any) => e.APIName == element && this.common.ToLowerCase(e.VerificationMode) == 'automatic')[0].InitiatedBy,
              InitiatedOn: this.bgvHistory.filter((e: any) => e.APIName == element && this.common.ToLowerCase(e.VerificationMode) == 'automatic')[0].InitiatedOn,
              Data: this.bgvHistory.filter((e: any) => e.APIName == element && this.common.ToLowerCase(e.VerificationMode) == 'automatic'),
              VerificationMode: this.bgvHistory.filter((e: any) => e.APIName == element && this.common.ToLowerCase(e.VerificationMode) == 'automatic')[0].VerificationMode,
              VerificationType: this.bgvHistory.filter((e: any) => e.APIName == element && this.common.ToLowerCase(e.VerificationMode) == 'automatic')[0].FinalVerificationStatus,
              FinalStatusColourCode: this.bgvHistory.filter((e: any) => e.APIName == element && this.common.ToLowerCase(e.VerificationMode) == 'automatic')[0].FinalStatusColourCode,
              FinalStatusFontColor: this.bgvHistory.filter((e: any) => e.APIName == element && this.common.ToLowerCase(e.VerificationMode) == 'automatic')[0].FinalStatusFontColor,
            })
          });

          const Dates = [...new Set(this.bgvHistory.filter((e: any) => e.APIName == element && this.common.ToLowerCase(e.VerificationMode) != 'automatic').map((e: any) => e.Createdon))];

          Dates.forEach((eDate: any) => {
            this.bgvHistoryHeader.push({
              ESS_BGVAPIMasterID: this.bgvHistory.filter((e: any) => e.APIName == element && this.common.ToLowerCase(e.VerificationMode) != 'automatic' && e.Createdon == eDate)[0].ESS_BGVAPIMasterID,
              APIName: this.bgvHistory.filter((e: any) => e.APIName == element && this.common.ToLowerCase(e.VerificationMode) != 'automatic' && e.Createdon == eDate)[0].APIName,
              InitiatedBy: this.bgvHistory.filter((e: any) => e.APIName == element && this.common.ToLowerCase(e.VerificationMode) != 'automatic' && e.Createdon == eDate)[0].InitiatedBy,
              InitiatedOn: this.bgvHistory.filter((e: any) => e.APIName == element && this.common.ToLowerCase(e.VerificationMode) != 'automatic' && e.Createdon == eDate)[0].Createdon,
              Data: this.bgvHistory.filter((e: any) => e.APIName == element && this.common.ToLowerCase(e.VerificationMode) != 'automatic' && e.Createdon == eDate),
              VerificationMode: this.bgvHistory.filter((e: any) => e.APIName == element && this.common.ToLowerCase(e.VerificationMode) != 'automatic' && e.Createdon == eDate)[0].VerificationMode,
              VerificationType: this.bgvHistory.filter((e: any) => e.APIName == element && this.common.ToLowerCase(e.VerificationMode) != 'automatic' && e.Createdon == eDate)[0].FinalVerificationStatus,
              FinalStatusColourCode: this.bgvHistory.filter((e: any) => e.APIName == element && this.common.ToLowerCase(e.VerificationMode) != 'automatic' && e.Createdon == eDate)[0].FinalStatusColourCode,
              FinalStatusFontColor: this.bgvHistory.filter((e: any) => e.APIName == element && this.common.ToLowerCase(e.VerificationMode) != 'automatic' && e.Createdon == eDate)[0].FinalStatusFontColor,
            })
          });
        });

        // [...new Set(this.bgvHistory.map((e: any) => e.APIName))].forEach((element: any) => {
        //   this.bgvHistoryHeader.push({
        //     ESS_BGVAPIMasterID: this.bgvHistory.filter((e: any) => e.APIName == element)[0].ESS_BGVAPIMasterID,
        //     APIName: this.bgvHistory.filter((e: any) => e.APIName == element)[0].APIName,
        //     InitiatedBy: this.bgvHistory.filter((e: any) => e.APIName == element)[0].InitiatedBy,
        //     InitiatedOn: this.bgvHistory.filter((e: any) => e.APIName == element)[0].InitiatedOn,
        //     Data: this.bgvHistory.filter((e: any) => e.APIName == element),
        //     VerificationType: this.bgvHistory.filter((e: any) => e.APIName == element)[0].FinalVerificationStatus,
        //     FinalStatusColourCode: this.bgvHistory.filter((e: any) => e.APIName == element)[0].FinalStatusColourCode,
        //   });
        // });

        this.bgvHistoryHeader.forEach((element: any) => {
          element.Data.forEach((element2: any) => {
            if (element2.FileName != null && element2.FileName != '') {
              element2.ReportURL = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.MenualBGVAttachment + '/' + element2.FileName;
            }
          });
        });

        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  toggleRow(i: number, j: number): void {
    if (!this.bgvHistoryHeader[i].Data[j].expanded) {
      this.bgvHistoryHeader[i].Data.map((e: any) => e.expanded = false);
    }
    this.bgvHistoryHeader[i].Data[j].expanded = !this.bgvHistoryHeader[i].Data[j].expanded;
  }

  GetHedername(type: string) {
    switch (this.common.ToLowerCase(type)) {
      case 'eav':
        return 'Employee Address Verification';
      case 'crc':
        return 'Criminal Record Check';
      case 'eqv':
        return 'Employee Qualification Verification';
      case 'ev':
        return 'Employment Verification';
      default:
        return '';
    }
  }

  ESS_AdditionalFillCombo() {
    this.isDisabled = true;
    this.employeeRegistration.ESS_AdditionalFillCombo({
      'SelectType': 'EmpServiceType',
    }).subscribe({
      next: (response) => {
        if (response.Table) {
          this.AddtionalEmpServiceTypes = response.Table
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  FindEmployee() {
    if (this.RegistrationDetail.OtherDetails.ReferralSource != null) {
      if (this.common.ToLowerCase(this.RegistrationDetail.OtherDetails.ReferralSource) == 'internal') {
        this.RegistrationDetail.OtherDetails.ReferralSourceCategory = null;
        this.FilterForm();
      } else {
        this.RegistrationDetail.OtherDetails.ReferredBy = null;
        this.RegistrationDetail.OtherDetails.EmpCode = null;
        this.RegistrationDetail.OtherDetails.EmpName = null;
      }
    } else {
      this.RegistrationDetail.OtherDetails.ReferredBy = null;
      this.RegistrationDetail.OtherDetails.EmpCode = null;
      this.RegistrationDetail.OtherDetails.EmpName = null;
      this.RegistrationDetail.OtherDetails.ReferralSourceCategory = null;
    }
  }

  FilterForm() {
    const modalRef = this.modalService.open(ApprovalMatrixFormFilterComponent, { size: 'lg' });
    modalRef.componentInstance.Title = 'Employee';
    modalRef.componentInstance.WebESSApplicabilityId = 8;
    modalRef.componentInstance.EmpType = 'Front';
    modalRef.componentInstance.Limit = 1;
    modalRef.componentInstance.ShowSample = false;
    modalRef.componentInstance.ShowUpload = false;

    modalRef.componentInstance.ShowFilter = {
      ShowBranch: false,
      ShowClient: false,
      ShowSite: false,
      ShowSearchEmployee: true
    }
    modalRef.result.then(result => {
      if (result.length >= 0) {
        this.RegistrationDetail.OtherDetails.ReferredBy = result[0].EmpMasterID;
        this.RegistrationDetail.OtherDetails.EmpCode = result[0].EmpCode;
        this.RegistrationDetail.OtherDetails.EmpName = result[0].FullName;
      }
    });
  }

  BGVMenualAdd() {
    if (this.common.CompanyParameterValue.ESS_IsEmpBGVApplicable) {
      const modalRef = this.modalService.open(MenualBGVFormComponent, { size: 'lg', backdrop: 'static', });
      modalRef.componentInstance.EmpMasterId = this.RegistrationDetail.employeeInfo.EmpMasterId;
      modalRef.componentInstance.EmpTempCode = this.RegistrationDetail.employeeInfo.EmpTempCode;
      modalRef.componentInstance.EmpName = this.RegistrationDetail.employeeInfo.FirstName;
      modalRef.componentInstance.JoiningDate = this.RegistrationDetail.BasicInformation.JoiningDate;
      modalRef.componentInstance.RegistrationDate = this.RegistrationDetail.BasicInformation.RegistrationDate;
      modalRef.componentInstance.BirthDate = this.RegistrationDetail.BasicInformation.BirthDate;
      modalRef.componentInstance.Today = this.ToDayDate;
      modalRef.componentInstance.SetTypes = this.bgvHistoryHeader.map((e: any) => { return { ESS_BGVAPIMasterID: e.ESS_BGVAPIMasterID, VerificationType: e.VerificationType }; });
      modalRef.componentInstance.maxBirthdate = this.maxBirthdate,
        modalRef.componentInstance.Datas = {
          LocalAddress1: this.RegistrationDetail.AddressTab.LocalAddress.length > 0 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalAddress1 : null,
          LocalAddress2: this.RegistrationDetail.AddressTab.LocalAddress.length > 0 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalAddress2 : null,
          FatherName: this.RegistrationDetail.BasicInformation.FatherName,
          BirthDate: this.RegistrationDetail.BasicInformation.BirthDate,
          Type: 'current',
          Address1: this.RegistrationDetail.AddressTab.LocalAddress.length > 0 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalAddress1 : null,
          Address2: this.RegistrationDetail.AddressTab.LocalAddress.length > 0 ? this.RegistrationDetail.AddressTab.LocalAddress[0].LocalAddress1 : null,
          PrevCompanyName: this.RegistrationDetail.OtherDetails.PreviousEmploymentdetails.length > 0 ? this.RegistrationDetail.OtherDetails.PreviousEmploymentdetails[this.RegistrationDetail.OtherDetails.PreviousEmploymentdetails.length - 1].Name : null,
          PrevCompanyPosition: this.RegistrationDetail.OtherDetails.PreviousEmploymentdetails.length > 0 ? this.RegistrationDetail.OtherDetails.PreviousEmploymentdetails[this.RegistrationDetail.OtherDetails.PreviousEmploymentdetails.length - 1].Position : null,
          PrevCompanyJoiningDate: this.RegistrationDetail.OtherDetails.PreviousEmploymentdetails.length > 0 ? this.RegistrationDetail.OtherDetails.PreviousEmploymentdetails[this.RegistrationDetail.OtherDetails.PreviousEmploymentdetails.length - 1].FromDate : null,
          PrevCompanyRelievingDate: this.RegistrationDetail.OtherDetails.PreviousEmploymentdetails.length > 0 ? this.RegistrationDetail.OtherDetails.PreviousEmploymentdetails[this.RegistrationDetail.OtherDetails.PreviousEmploymentdetails.length - 1].ToDate : null,
          EnrollmentNumber: this.RegistrationDetail.AdditionalInformation.Ess_Qual.length > 0 ? this.RegistrationDetail.AdditionalInformation.Ess_Qual[this.RegistrationDetail.AdditionalInformation.Ess_Qual.length - 1].EnrollmentNumber : null,
          College: this.RegistrationDetail.AdditionalInformation.Ess_Qual.length > 0 ? this.RegistrationDetail.AdditionalInformation.Ess_Qual[this.RegistrationDetail.AdditionalInformation.Ess_Qual.length - 1].College : null,
          QualificationName: this.RegistrationDetail.AdditionalInformation.Ess_Qual.length > 0 ? this.RegistrationDetail.AdditionalInformation.Ess_Qual[this.RegistrationDetail.AdditionalInformation.Ess_Qual.length - 1].QualificationId > 0 ? this.Qualifications.filter((e: any) => e.QualificationMasterID == this.RegistrationDetail.AdditionalInformation.Ess_Qual[this.RegistrationDetail.AdditionalInformation.Ess_Qual.length - 1].QualificationId)[0].QualificationName : null : null,
          UniversityBoard: this.RegistrationDetail.AdditionalInformation.Ess_Qual.length > 0 ? this.RegistrationDetail.AdditionalInformation.Ess_Qual[this.RegistrationDetail.AdditionalInformation.Ess_Qual.length - 1].UniversityBoard : null,
          CGPA: this.RegistrationDetail.AdditionalInformation.Ess_Qual.length > 0 ? this.RegistrationDetail.AdditionalInformation.Ess_Qual[this.RegistrationDetail.AdditionalInformation.Ess_Qual.length - 1].CGPA : null,
        };

      modalRef.result.then(result => {
        if (result) {
          this.ESS_EmpBGVVerificationDetailsSelect();
        }
      });
    }
  }

  toggleCollapse(apiName: number) {
    console.log(apiName);
    console.log(this.collapseStates[apiName]);
    this.collapseStates[apiName] = !(this.collapseStates[apiName] ?? false);
    console.log(this.collapseStates[apiName]);
  }


  RemoveBGV(VerificationType: string) {
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Do you want to remove?';
    modalRef.result.then((result: any) => {
      if (result) {
        this.isDisabled = true;
        this.backgroundVerification.ESS_EmpBGVManualVerificationDetailsInsert({ VerificationType: VerificationType, SelectType: 'D', EmpMasterId: this.RegistrationDetail.employeeInfo.EmpMasterId, ESS_EmpBGVVerificationDetails_Manual: [] }).subscribe({
          next: (response) => {
            if (response.Error_Code == '855') {
              const modalRef = this.modalService.open(AlertSuccessComponent, {
                size: 'md',
                backdrop: 'static',
                centered: true,
                windowClass: 'confirmation-modal'
              });
              modalRef.componentInstance.Message = response.Error_Message;
              modalRef.result.then((result: any) => {
                if (result) {
                  this.ESS_EmpBGVVerificationDetailsSelect();
                }
              });
            } else {
              const modalRef = this.modalService.open(AlertWarningComponent, {
                size: 'md',
                backdrop: 'static',
                centered: true,
                windowClass: 'confirmation-modal'
              });
              modalRef.componentInstance.Message = response.Error_Message;
              modalRef.result.then((result: any) => { });
            }
            this.isDisabled = false;
          },
          complete: () => { },
          error: (error) => {
            this.isDisabled = false;
          },
        });

      }
    });
  }

  EditBGV(ESS_EmpBGVVerificationDetailsId: number) {
    if (this.common.CompanyParameterValue.ESS_IsEmpBGVApplicable) {
      const modalRef = this.modalService.open(ConfirmationComponent, {
        size: 'md',
        backdrop: 'static',
        centered: true,
        windowClass: 'confirmation-modal'
      });
      modalRef.componentInstance.Message = 'Do you want to edit?';
      modalRef.result.then((result: any) => {
        if (result) {
          const modalRef = this.modalService.open(MenualBGVFormComponent, { size: 'lg', backdrop: 'static', });
          modalRef.componentInstance.ESS_EmpBGVVerificationDetailsId = ESS_EmpBGVVerificationDetailsId;
          modalRef.componentInstance.EmpMasterId = this.bgvHistory.filter((e: any) => e.ESS_EmpBGVVerificationDetailsId == ESS_EmpBGVVerificationDetailsId)[0].EmpMasterId;
          modalRef.componentInstance.EmpTempCode = this.bgvHistory.filter((e: any) => e.ESS_EmpBGVVerificationDetailsId == ESS_EmpBGVVerificationDetailsId)[0].EmpCode;
          modalRef.componentInstance.EmpName = this.bgvHistory.filter((e: any) => e.ESS_EmpBGVVerificationDetailsId == ESS_EmpBGVVerificationDetailsId)[0].EmpName;
          modalRef.componentInstance.JoiningDate = this.RegistrationDetail.BasicInformation.JoiningDate;
          modalRef.componentInstance.RegistrationDate = this.RegistrationDetail.BasicInformation.RegistrationDate;
          modalRef.componentInstance.BirthDate = this.RegistrationDetail.BasicInformation.BirthDate;
          modalRef.componentInstance.Today = this.ToDayDate;
          modalRef.componentInstance.SetTypes = [this.bgvHistory.filter((e: any) => e.ESS_EmpBGVVerificationDetailsId == ESS_EmpBGVVerificationDetailsId)[0]].map((e: any) => { return { ESS_BGVAPIMasterID: e.ESS_BGVAPIMasterID, VerificationType: e.FinalVerificationStatus }; });
          modalRef.componentInstance.ESS_BGVAPIMasterID = this.bgvHistory.filter((e: any) => e.ESS_EmpBGVVerificationDetailsId == ESS_EmpBGVVerificationDetailsId)[0].ESS_BGVAPIMasterID;
          modalRef.componentInstance.VerificationTypeFinal = this.bgvHistory.filter((e: any) => e.ESS_EmpBGVVerificationDetailsId == ESS_EmpBGVVerificationDetailsId)[0].VerificationType;

          modalRef.componentInstance.Verification_Status = this.bgvHistory.filter((e: any) => e.ESS_EmpBGVVerificationDetailsId == ESS_EmpBGVVerificationDetailsId)[0].Verification_Status;
          modalRef.componentInstance.Status_Description = this.bgvHistory.filter((e: any) => e.ESS_EmpBGVVerificationDetailsId == ESS_EmpBGVVerificationDetailsId)[0].Status_Description;
          modalRef.componentInstance.Remarks = this.bgvHistory.filter((e: any) => e.ESS_EmpBGVVerificationDetailsId == ESS_EmpBGVVerificationDetailsId)[0].Remarks;

          modalRef.componentInstance.InitiatedOn = this.bgvHistory.filter((e: any) => e.ESS_EmpBGVVerificationDetailsId == ESS_EmpBGVVerificationDetailsId)[0].InitiatedOn;
          modalRef.componentInstance.IsVerified = this.bgvHistory.filter((e: any) => e.ESS_EmpBGVVerificationDetailsId == ESS_EmpBGVVerificationDetailsId)[0].IsVerified;
          modalRef.componentInstance.FileName = this.bgvHistory.filter((e: any) => e.ESS_EmpBGVVerificationDetailsId == ESS_EmpBGVVerificationDetailsId)[0].FileName;

          modalRef.componentInstance.Datas = {
            LocalAddress1: this.bgvHistory.filter((e: any) => e.ESS_EmpBGVVerificationDetailsId == ESS_EmpBGVVerificationDetailsId)[0].LocalAddress1,
            LocalAddress2: this.bgvHistory.filter((e: any) => e.ESS_EmpBGVVerificationDetailsId == ESS_EmpBGVVerificationDetailsId)[0].LocalAddress2,
            FatherName: this.bgvHistory.filter((e: any) => e.ESS_EmpBGVVerificationDetailsId == ESS_EmpBGVVerificationDetailsId)[0].FatherName,
            BirthDate: this.bgvHistory.filter((e: any) => e.ESS_EmpBGVVerificationDetailsId == ESS_EmpBGVVerificationDetailsId)[0].BirthDate,
            Type: 'current',
            Address1: this.bgvHistory.filter((e: any) => e.ESS_EmpBGVVerificationDetailsId == ESS_EmpBGVVerificationDetailsId)[0].Address1,
            Address2: this.bgvHistory.filter((e: any) => e.ESS_EmpBGVVerificationDetailsId == ESS_EmpBGVVerificationDetailsId)[0].Address2,
            PrevCompanyName: this.bgvHistory.filter((e: any) => e.ESS_EmpBGVVerificationDetailsId == ESS_EmpBGVVerificationDetailsId)[0].PrevCompanyName,
            PrevCompanyPosition: this.bgvHistory.filter((e: any) => e.ESS_EmpBGVVerificationDetailsId == ESS_EmpBGVVerificationDetailsId)[0].PrevCompanyPosition,
            PrevCompanyJoiningDate: this.bgvHistory.filter((e: any) => e.ESS_EmpBGVVerificationDetailsId == ESS_EmpBGVVerificationDetailsId)[0].PrevCompanyJoiningDate,
            PrevCompanyRelievingDate: this.bgvHistory.filter((e: any) => e.ESS_EmpBGVVerificationDetailsId == ESS_EmpBGVVerificationDetailsId)[0].PrevCompanyRelievingDate,
            EnrollmentNumber: this.bgvHistory.filter((e: any) => e.ESS_EmpBGVVerificationDetailsId == ESS_EmpBGVVerificationDetailsId)[0].EnrollmentNumber,
            College: this.bgvHistory.filter((e: any) => e.ESS_EmpBGVVerificationDetailsId == ESS_EmpBGVVerificationDetailsId)[0].College,
            QualificationName: this.bgvHistory.filter((e: any) => e.ESS_EmpBGVVerificationDetailsId == ESS_EmpBGVVerificationDetailsId)[0].QualificationName,
            UniversityBoard: this.bgvHistory.filter((e: any) => e.ESS_EmpBGVVerificationDetailsId == ESS_EmpBGVVerificationDetailsId)[0].UniversityBoard,
            CGPA: this.bgvHistory.filter((e: any) => e.ESS_EmpBGVVerificationDetailsId == ESS_EmpBGVVerificationDetailsId)[0].CGPA,
          };

          modalRef.result.then(result => {
            if (result) {
              this.ESS_EmpBGVVerificationDetailsSelect();
            }
          });
        }
      });
    }
  }

  checkAadharpattern(): string {
    if (this.RegistrationDetail.AccountLicencesTab.AadhaarNo != null && this.RegistrationDetail.AccountLicencesTab.AadhaarNo != '' && isNaN(this.RegistrationDetail.AccountLicencesTab.AadhaarNo)) {
      return '^[a-zA-Z0-9]';
    } else {
      return '^[0-9]';
    }
  }
}

